export default [
    {
        latitude: 37.4410078,
        longitude: -122.532882,
        timestamp: '2025-08-28T23:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                124.12426351351611, 118.50521239718218, 115.87481433607749, 114.52430757932066, 113.44105992949687,
                113.55348281433825, 113.01477834900334, 112.51176718566609, 113.80195887191755, 109.86859004113008,
                109.0361869859009, 105.82114585781618, 104.09795255581844, 103.98360179201114, 105.00223795534845,
                104.55629200940247, 102.60026601057747, 104.22254861927321, 104.89157770270451, 105.69979964747542,
                105.73262867215225, 104.80542905405585, 103.88748325499587, 102.57327570505454, 101.001834018803,
                105.07048487074208, 96.39662690951951, 95.36537690951945,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                109.0248125, 103.845125, 103.845125, 105.626375, 106.6810625, 107.782625, 108.0873125, 107.3841875,
                106.6341875, 105.9310625, 104.782625, 102.3216875, 100.7748125, 100.04825, 101.267, 99.9545, 98.782625,
                99.9310625, 100.42325, 101.54825, 101.92325, 101.7591875, 100.845125, 99.67325, 98.8998125, 101.4545,
                95.73575, 95.0795,
            ],
            '25th_percentile': [
                117.9310625, 112.095125, 109.4466875, 109.7748125, 109.7045, 110.73575, 110.970125, 110.3841875,
                111.2748125, 108.3685625, 107.126375, 104.36075, 102.532625, 102.392, 103.188875, 101.782625, 100.517,
                101.92325, 102.2279375, 103.563875, 103.188875, 102.813875, 101.7123125, 100.892, 99.7435625,
                103.376375, 96.017, 95.267,
            ],
            '50th_percentile': [
                124.001375, 118.282625, 114.720125, 112.845125, 112.001375, 112.892, 112.61075, 112.04825, 114.017,
                109.7045, 108.67325, 105.532625, 103.751375, 103.892, 104.73575, 104.220125, 102.5795, 104.032625,
                104.501375, 105.438875, 105.345125, 104.032625, 102.86075, 101.782625, 100.42325, 105.29825, 96.251375,
                95.36075,
            ],
            '75th_percentile': [
                130.3060625, 124.7279375, 121.845125, 118.6810625, 116.36075, 115.657625, 114.48575, 114.345125,
                116.407625, 111.157625, 110.313875, 107.0091875, 105.2045, 105.3685625, 106.517, 107.0795, 104.220125,
                105.813875, 106.79825, 107.36075, 107.220125, 106.2123125, 105.345125, 103.9623125, 101.7591875,
                106.23575, 96.5795, 95.4545,
            ],
            '99th_percentile': [
                141.720125, 135.9779375, 132.1341875, 129.29825, 127.5873125, 125.876375, 121.61075, 120.6029375,
                120.9545, 115.517, 115.8685625, 111.626375, 110.0795, 108.907625, 110.6185625, 111.8373125, 108.7435625,
                111.6029375, 112.563875, 112.657625, 113.6185625, 111.6498125, 112.188875, 109.42325, 107.0560625,
                110.782625, 98.1966875, 95.782625,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410078,
        longitude: -122.532882,
        timestamp: '2025-08-28T23:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 127.50619984378075,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410078,
        longitude: -122.532882,
        timestamp: '2025-08-28T23:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                125.27345783848241, 119.6220697743492, 116.7434326009524, 115.45882378266255, 114.17132007126106,
                113.95075148456269, 114.7369933194796, 117.73159323040603, 111.43124807007322, 107.71782393111819,
                108.3224112232797, 106.35856027316083, 105.03726425178314, 106.43510792755521, 105.86665112826775,
                104.40473010689, 104.95225460213945, 105.15890543349337, 106.1618188836122, 107.08484441805403,
                106.90447030879037, 105.40218779691382, 103.64910733373084, 102.50016879453838, 100.7500945665098,
                104.43317799881405, 96.19776380641453, 95.30647075415794,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                109.67684374999999, 105.017, 104.61434374999999, 106.751375, 107.54825, 107.73575, 109.39559374999999,
                109.342625, 105.48575, 102.64559374999999, 102.438875, 101.19246874999999, 100.845125,
                102.02778124999999, 101.00496874999999, 99.9545, 100.142, 100.001375, 101.032625, 102.45809374999999,
                102.55184374999999, 102.03621874999999, 101.4545, 100.62996874999999, 99.345125, 102.50496874999999,
                95.688875, 95.0795,
            ],
            '25th_percentile': [
                119.313875, 113.65371875, 110.04434375, 110.8295, 110.407625, 111.157625, 112.61075, 114.157625,
                108.91934375, 105.251375, 104.970125, 102.86075, 102.438875, 104.8295, 103.142, 101.782625, 102.532625,
                102.813875, 103.751375, 104.04434375, 103.892, 103.23575, 102.29825, 101.407625, 99.9545, 103.845125,
                95.970125, 95.220125,
            ],
            '50th_percentile': [
                125.1966875, 119.642, 116.17325, 113.876375, 112.470125, 113.36075, 114.48575, 117.7904375, 111.345125,
                107.8529375, 107.8060625, 104.970125, 104.3841875, 106.517, 105.813875, 103.98575, 104.642, 105.4154375,
                105.720125, 106.845125, 106.282625, 104.595125, 103.1654375, 102.063875, 100.42325, 104.36075,
                96.157625, 95.267,
            ],
            '75th_percentile': [
                130.98575, 125.58340625, 122.86465625, 119.595125, 117.251375, 115.79825, 116.44278125, 121.08340625,
                113.642, 110.11465625, 111.56778125, 109.42325, 107.642, 107.8295, 108.345125, 107.032625, 107.16153125,
                107.220125, 108.438875, 109.64590625, 109.517, 107.17325, 104.595125, 103.23575, 101.17325, 104.92325,
                96.345125, 95.36075,
            ],
            '99th_percentile': [
                142.45934375, 136.657625, 133.1035625, 128.88246875000002, 127.40168750000001, 125.14325, 122.7441875,
                127.68528125, 118.470125, 113.06871875, 115.845125, 115.83200000000001, 110.642, 111.43653125,
                111.79465625, 109.79825, 110.846375, 110.76340625, 113.14325, 114.5410625, 114.04465625, 111.9160625,
                109.35715625, 107.58434375, 104.85481250000001, 107.267, 97.27184375, 95.688875,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410078,
        longitude: -122.532882,
        timestamp: '2025-08-28T23:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 128.62644778791744,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408,
        longitude: -122.53295,
        timestamp: '2025-08-28T23:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 133.892,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408,
        longitude: -122.53295,
        timestamp: '2025-08-28T23:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408,
        longitude: -122.53295,
        timestamp: '2025-08-28T23:44:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 18,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408,
        longitude: -122.53295,
        timestamp: '2025-08-28T23:44:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408,
        longitude: -122.53295,
        timestamp: '2025-08-28T23:44:00.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b0e6948219017c185aa50518c707185a08185b1518b511185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408,
        longitude: -122.53295,
        timestamp: '2025-08-28T23:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                131.642, 126.392, 123.392, 119.642, 117.392, 115.892, 115.892, 119.642, 112.142, 108.392, 109.892,
                107.642, 106.142, 106.892, 106.892, 105.392, 106.142, 106.142, 107.642, 108.392, 108.392, 106.142,
                103.892, 102.392, 100.892, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                119.642, 113.642, 109.892, 110.642, 110.642, 111.392, 112.892, 114.392, 109.142, 105.392, 104.642,
                103.142, 102.392, 104.642, 103.142, 101.642, 102.392, 103.142, 103.892, 103.892, 103.892, 103.142,
                102.392, 101.642, 100.142, 103.892, 95.642, 94.892,
            ],
            '50th_percentile': [
                125.642, 119.642, 116.642, 113.642, 112.892, 113.642, 114.392, 117.392, 111.392, 107.642, 107.642,
                104.642, 103.892, 106.142, 105.392, 103.892, 104.642, 105.392, 105.392, 106.892, 106.142, 104.642,
                103.142, 102.392, 100.142, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                130.892, 125.642, 122.642, 119.642, 117.392, 115.892, 116.642, 121.142, 113.642, 109.892, 111.392,
                109.142, 107.642, 107.642, 108.392, 106.892, 106.892, 106.892, 108.392, 109.892, 109.142, 106.892,
                104.642, 103.142, 100.892, 104.642, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408,
        longitude: -122.53295,
        timestamp: '2025-08-29T00:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 134.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408,
        longitude: -122.53295,
        timestamp: '2025-08-29T00:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 7.5,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408,
        longitude: -122.53295,
        timestamp: '2025-08-29T00:14:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408,
        longitude: -122.53295,
        timestamp: '2025-08-29T00:14:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408,
        longitude: -122.53295,
        timestamp: '2025-08-29T00:14:00.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b0ed9c8219017c185aa4051833081901491519014911185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408,
        longitude: -122.53295,
        timestamp: '2025-08-29T00:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                132.392, 126.392, 123.392, 120.392, 118.142, 116.642, 115.142, 115.892, 117.392, 111.392, 107.642,
                106.142, 103.892, 104.642, 104.642, 104.642, 103.892, 103.892, 105.392, 106.142, 108.392, 104.642,
                103.142, 102.392, 99.392, 103.142, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                119.642, 114.392, 111.392, 112.142, 112.142, 112.892, 112.142, 114.392, 112.892, 109.142, 106.142,
                104.642, 102.392, 103.142, 103.142, 102.392, 101.642, 102.392, 103.142, 103.892, 105.392, 103.142,
                101.642, 100.892, 99.392, 103.142, 95.642, 94.892,
            ],
            '50th_percentile': [
                125.642, 120.392, 117.392, 115.142, 114.392, 114.392, 113.642, 115.142, 115.892, 110.642, 106.892,
                105.392, 103.892, 103.892, 104.642, 103.892, 103.892, 103.892, 105.392, 105.392, 106.892, 104.642,
                103.142, 101.642, 99.392, 103.142, 96.392, 95.642,
            ],
            '75th_percentile': [
                130.142, 124.892, 121.892, 119.642, 118.142, 116.642, 115.142, 116.642, 118.892, 112.142, 108.392,
                106.892, 105.392, 105.392, 106.142, 105.392, 105.392, 105.392, 106.142, 106.892, 108.392, 106.142,
                103.892, 102.392, 100.142, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406848,
        longitude: -122.5330842,
        timestamp: '2025-08-29T00:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                125.13616147687091, 119.66857918149705, 117.18542749110549, 116.08995373665704, 115.3347824733118,
                115.07010275800931, 113.92947775800924, 115.37303870106983, 115.66435320284926, 110.5359612989344,
                107.36141725978833, 105.86297419929004, 103.62604137010844, 104.2644421708202, 104.2720044484003,
                103.91246263345364, 103.71089457295537, 103.58405960854257, 104.70889279359602, 105.53345907473486,
                107.03607250889866, 104.58767393238605, 102.9933678825639, 101.78885275800867, 99.6433345195744,
                103.43175756227923, 96.1477829181507, 95.30336565836417,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                109.1148125, 104.5679375, 104.8491875, 107.673875, 108.7248125, 109.98575, 109.38856249999999,
                112.001375, 108.9273125, 106.455125, 104.688875, 102.4116875, 100.0679375, 100.5366875, 100.5835625,
                100.6773125, 99.2710625, 99.6460625, 100.8845, 102.017, 102.9273125, 101.970125, 100.79825, 100.001375,
                98.642, 101.8960625, 95.6148125, 95.126375,
            ],
            '25th_percentile': [
                119.501375, 113.782625, 111.532625, 111.86075, 112.0248125, 112.892, 112.23575, 114.251375, 112.98575,
                109.04825, 106.3295, 104.4545, 102.017, 103.0248125, 102.767, 102.532625, 102.063875, 102.063875,
                103.142, 103.845125, 105.017, 103.23575, 101.92325, 100.98575, 99.251375, 102.9545, 95.970125,
                95.220125,
            ],
            '50th_percentile': [
                125.220125, 119.8295, 116.876375, 115.23575, 114.251375, 114.29825, 113.4545, 115.188875, 115.376375,
                110.407625, 107.220125, 105.626375, 103.470125, 104.220125, 104.36075, 103.751375, 104.126375, 103.892,
                105.017, 105.5795, 106.517, 104.4545, 102.813875, 101.501375, 99.532625, 103.42325, 96.11075, 95.313875,
            ],
            '75th_percentile': [
                130.142, 124.7748125, 122.032625, 119.4545, 118.0248125, 116.6654375, 115.188875, 116.267, 118.3998125,
                111.767, 108.2045, 107.0560625, 105.251375, 105.532625, 105.8373125, 105.11075, 105.251375, 105.11075,
                106.095125, 106.892, 108.4623125, 105.720125, 103.845125, 102.392, 99.9310625, 103.845125, 96.29825,
                95.36075,
            ],
            '99th_percentile': [
                143.8173125, 138.14825000000002, 134.171375, 130.0979375, 127.8329375, 125.35887500000001,
                123.63950000000003, 120.51293749999999, 123.720125, 116.17325, 111.51293749999999, 110.883875,
                107.74325, 108.258875, 108.48575, 108.11075, 108.540125, 107.15356249999999, 108.74731249999999,
                110.0795, 114.88793749999999, 108.446375, 107.05981249999999, 106.1766875, 101.4545, 105.3995,
                97.12231249999999, 95.54825,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406848,
        longitude: -122.5330842,
        timestamp: '2025-08-29T00:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 128.64166245213508,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406848,
        longitude: -122.5330842,
        timestamp: '2025-08-29T00:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                126.13755160142613, 120.57861032028714, 117.81882384341868, 116.9146312277603, 116.10574555160368,
                116.52912188612328, 116.56520951957522, 115.38621708185272, 114.48841903914806, 111.08939768683477,
                109.72885498220836, 109.68309208185252, 109.98107918149668, 110.29569217082053, 110.03306983985966,
                107.51622153025099, 109.03629492882754, 108.17397286477059, 108.8778763345215, 110.4701806049842,
                109.1521201067635, 107.92591903914777, 105.89617037366726, 103.96984697509065, 101.47134830961008,
                104.93648398576686, 96.54719350533932, 95.34556983985883,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                110.8960625, 106.001375, 105.813875, 108.82606249999999, 109.8179375, 110.642, 111.5054375, 111.431375,
                110.2398125, 107.4741875, 106.29481249999999, 105.67325, 105.48575, 105.77918749999999, 105.86075,
                103.0679375, 103.001375, 103.61075, 103.9585625, 105.29075, 104.4545, 104.0991875, 103.04825, 101.36075,
                99.626375, 103.001375, 95.92325, 95.126375,
            ],
            '25th_percentile': [
                121.001375, 115.563875, 112.7045, 113.032625, 113.0795, 114.0404375, 114.626375, 113.8295, 112.938875,
                109.8685625, 108.345125, 107.4545, 107.4545, 107.782625, 107.970125, 105.3685625, 106.188875,
                106.0716875, 106.751375, 108.063875, 107.032625, 105.9779375, 104.501375, 102.345125, 100.470125,
                103.892, 96.251375, 95.267,
            ],
            '50th_percentile': [
                126.251375, 120.48575, 117.532625, 116.0795, 115.282625, 116.313875, 116.220125, 115.188875, 114.29825,
                111.017, 109.7045, 108.67325, 109.142, 109.188875, 109.563875, 107.0795, 109.188875, 107.220125,
                108.438875, 110.4545, 108.720125, 107.688875, 105.48575, 103.517, 101.0795, 104.407625, 96.438875,
                95.313875,
            ],
            '75th_percentile': [
                131.267, 125.642, 122.6654375, 120.1341875, 118.376375, 118.5404375, 118.142, 116.782625, 115.938875,
                112.142, 111.017, 111.9545, 111.67325, 111.767, 111.532625, 109.4935625, 111.5795, 110.4545, 111.063875,
                112.470125, 111.11075, 109.282625, 106.938875, 105.11075, 101.8295, 105.157625, 96.720125, 95.407625,
            ],
            '99th_percentile': [
                144.00012500000003, 137.282, 133.6454375, 131.2623125, 128.16387500000002, 125.73106250000001,
                124.211375, 120.962, 119.92325, 116.055125, 113.8173125, 116.17325, 118.98106250000001,
                119.84450000000001, 117.258875, 114.3329375, 115.3641875, 114.09106249999999, 114.76231250000001,
                117.063875, 116.2079375, 114.29825, 111.67325, 109.376375, 106.77856249999999, 110.883875, 98.0795,
                95.73575,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406848,
        longitude: -122.5330842,
        timestamp: '2025-08-29T00:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 129.80503346182454,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44065,
        longitude: -122.5331167,
        timestamp: '2025-08-29T00:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 134.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44065,
        longitude: -122.5331167,
        timestamp: '2025-08-29T00:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 7.5,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44065,
        longitude: -122.5331167,
        timestamp: '2025-08-29T00:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44065,
        longitude: -122.5331167,
        timestamp: '2025-08-29T00:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44065,
        longitude: -122.5331167,
        timestamp: '2025-08-29T00:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b0f4a48219017c185aa70518700819010c1519010c111858130114011601',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44065,
        longitude: -122.5331167,
        timestamp: '2025-08-29T00:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                132.392, 126.392, 123.392, 120.392, 118.892, 118.142, 117.392, 115.892, 115.142, 111.392, 109.892,
                110.642, 111.392, 112.142, 111.392, 108.392, 109.892, 109.142, 109.892, 111.392, 110.642, 108.392,
                106.142, 104.642, 101.642, 105.392, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                121.142, 115.892, 112.892, 112.892, 112.892, 114.392, 114.392, 113.642, 112.892, 109.892, 108.392,
                107.642, 107.642, 107.642, 108.392, 105.392, 106.142, 106.142, 106.892, 108.392, 106.892, 106.142,
                104.642, 102.392, 100.142, 103.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                126.392, 120.392, 117.392, 115.892, 115.142, 116.642, 115.892, 115.142, 114.392, 110.642, 109.892,
                108.392, 109.142, 109.142, 109.892, 106.892, 109.142, 106.892, 108.392, 110.642, 109.142, 107.642,
                105.392, 103.892, 100.892, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                131.642, 125.642, 122.642, 120.392, 118.142, 118.892, 118.142, 116.642, 115.892, 112.142, 111.392,
                112.142, 111.392, 112.142, 111.392, 109.892, 111.392, 110.642, 111.392, 112.892, 111.392, 109.142,
                106.892, 105.392, 101.642, 105.392, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44065,
        longitude: -122.5331167,
        timestamp: '2025-08-29T01:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 133.892,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44065,
        longitude: -122.5331167,
        timestamp: '2025-08-29T01:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 7.5,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44065,
        longitude: -122.5331167,
        timestamp: '2025-08-29T01:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 17,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44065,
        longitude: -122.5331167,
        timestamp: '2025-08-29T01:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44065,
        longitude: -122.5331167,
        timestamp: '2025-08-29T01:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b0fbac8219017c185aa80518b807186908185b1518c4111858130114011601',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44065,
        longitude: -122.5331167,
        timestamp: '2025-08-29T01:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                131.642, 126.392, 123.392, 120.392, 118.142, 117.392, 117.392, 117.392, 117.392, 110.642, 108.392,
                108.392, 106.892, 107.642, 107.642, 106.892, 104.642, 105.392, 105.392, 106.142, 105.392, 103.892,
                102.392, 101.642, 99.392, 103.142, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                120.392, 114.392, 113.642, 114.392, 112.142, 113.642, 114.392, 114.392, 112.892, 109.142, 106.892,
                106.142, 103.892, 105.392, 104.642, 103.142, 100.892, 100.892, 100.892, 102.392, 103.892, 103.142,
                101.642, 100.892, 99.392, 103.142, 96.392, 94.892,
            ],
            '50th_percentile': [
                125.642, 120.392, 118.142, 116.642, 114.392, 115.142, 115.892, 115.892, 115.142, 109.892, 107.642,
                108.392, 106.892, 107.642, 106.892, 106.142, 103.892, 103.142, 103.892, 103.892, 104.642, 103.892,
                102.392, 101.642, 99.392, 103.142, 96.392, 95.642,
            ],
            '75th_percentile': [
                130.892, 125.642, 122.642, 120.392, 117.392, 117.392, 117.392, 117.392, 118.142, 111.392, 109.142,
                109.892, 107.642, 109.142, 109.142, 109.142, 106.142, 106.142, 106.142, 106.142, 105.392, 104.642,
                103.142, 101.642, 100.142, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406443,
        longitude: -122.5331332,
        timestamp: '2025-08-29T01:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                125.4293407879173, 119.96512648104505, 118.4508529324668, 117.52035085900705, 115.29756501777472,
                115.73560189573682, 116.14070408767996, 116.28166232227716, 115.7663705568742, 109.84062633294033,
                107.76379724526252, 107.3065993779639, 105.67086181872212, 106.59897571090227, 106.14388832938563,
                105.60349289099695, 103.50111581753714, 103.93876392180255, 104.06644831161297, 105.0296629146936,
                104.82855583530974, 104.08583145734762, 102.53545749407742, 101.55324851895888, 99.69951999407726,
                103.37165417654192, 96.23504650474058, 95.28155124407702,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                107.876375, 105.063875, 107.628875, 110.19340625, 109.04825, 110.70903125, 110.7760625, 111.13090625,
                109.25590625, 104.5416875, 103.5573125, 99.69340625, 98.17325, 97.657625, 97.20903125, 97.30278125,
                97.142, 98.05278125, 98.876375, 100.95903125, 102.67325, 102.251375, 101.032625, 100.30278125,
                98.688875, 101.92325, 95.8295, 95.0795,
            ],
            '25th_percentile': [
                120.2045, 114.47403125, 113.86465625, 114.345125, 112.23575, 113.782625, 114.438875, 114.48575, 112.892,
                108.86075, 106.79825, 106.03653125, 104.11465625, 105.345125, 104.595125, 103.282625, 101.17325,
                101.17325, 101.20840625, 102.532625, 103.657625, 103.142, 101.782625, 101.0795, 99.345125, 102.907625,
                96.063875, 95.220125,
            ],
            '50th_percentile': [
                125.642, 120.1341875, 117.767, 116.4545, 114.1810625, 115.142, 115.9623125, 115.938875, 115.282625,
                110.17325, 107.970125, 108.063875, 106.42325, 107.501375, 107.17325, 106.376375, 104.0795, 103.563875,
                103.7045, 104.0091875, 104.36075, 103.892, 102.438875, 101.4545, 99.626375, 103.3295, 96.2045, 95.267,
            ],
            '75th_percentile': [
                130.80996875, 125.32559375, 122.501375, 120.11075, 117.48575, 117.157625, 117.67325, 117.59121875,
                118.3295, 111.11075, 108.907625, 109.470125, 107.876375, 109.04825, 109.04825, 108.813875, 106.001375,
                106.3295, 106.42325, 106.24746875, 105.720125, 104.8295, 103.142, 101.970125, 100.001375, 103.79825,
                96.345125, 95.313875,
            ],
            '99th_percentile': [
                143.62746874999993, 137.66824999999997, 134.02559374999998, 129.5795, 127.98528124999997,
                125.96918749999995, 124.12840624999998, 124.39606249999997, 125.10621875, 114.0704375,
                111.82699999999998, 111.88746875, 111.00996874999998, 111.87387499999998, 112.61075, 112.49684375,
                109.563875, 113.54825, 112.59059375, 113.407625, 110.00543749999997, 107.4141875, 105.11075, 103.3295,
                101.0391875, 105.063875, 97.04825, 95.595125,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406443,
        longitude: -122.5331332,
        timestamp: '2025-08-29T01:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 129.17808211488597,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406443,
        longitude: -122.5331332,
        timestamp: '2025-08-29T01:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                123.79465847156655, 118.40175636848578, 116.24039677132927, 115.76775903436243, 115.02259093602116,
                113.79717624407799, 114.22627132701639, 115.77775607227716, 112.87422748815379, 107.15886537322457,
                107.8183366409971, 107.13215106635252, 106.67839662322454, 103.73221401066516, 103.16460441350873,
                102.98082553317697, 102.93717180094949, 104.31459700829555, 104.8728760367316, 105.50474437203967,
                106.80424822275064, 105.83575740521506, 104.06233841824813, 103.09784641587841, 101.41173489336647,
                104.63855657583109, 96.28058856635195, 95.29277014218128,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                107.126375, 104.4948125, 105.707, 108.73371875, 109.44340625, 109.02153125, 109.89246874999999, 110.267,
                108.13090625, 104.24731249999999, 103.470125, 101.14653125, 100.376375, 98.05278125, 97.20903125,
                97.23575, 97.751375, 99.29825, 100.02153125, 101.84965625, 103.470125, 103.06840625, 101.782625,
                100.845125, 98.970125, 102.29825, 95.782625, 95.0795,
            ],
            '25th_percentile': [
                117.720125, 112.42325, 111.19278125, 112.42325, 112.61075, 111.767, 112.7045, 113.44278125,
                110.81778125, 106.188875, 105.813875, 104.06778125, 103.517, 100.845125, 100.001375, 99.813875,
                99.80215625, 100.938875, 101.595125, 102.813875, 104.36075, 103.845125, 102.392, 101.501375, 99.767,
                103.376375, 96.017, 95.220125,
            ],
            '50th_percentile': [
                123.6029375, 118.23575, 115.23575, 114.907625, 114.157625, 113.220125, 114.017, 115.188875, 112.3295,
                107.0795, 107.407625, 106.61075, 105.813875, 103.001375, 102.017, 101.876375, 101.92325, 103.188875,
                103.470125, 104.1498125, 105.5795, 104.876375, 103.188875, 102.157625, 100.563875, 103.98575, 96.157625,
                95.267,
            ],
            '75th_percentile': [
                129.2045, 123.61465625, 120.30996875, 118.01309375, 116.642, 115.10684375, 115.470125, 118.01309375,
                114.532625, 107.92325, 109.517, 109.85684375, 109.751375, 106.517, 106.188875, 105.9779375, 105.67325,
                107.27871875, 107.79434375, 107.93496875, 108.907625, 107.642, 105.532625, 104.313875, 102.77871875,
                105.67325, 96.392, 95.36075,
            ],
            '99th_percentile': [
                143.15965624999998, 137.22621874999996, 133.08715624999994, 129.3048125, 126.61278124999998,
                124.35621875, 121.4298125, 123.67325, 122.01856249999997, 112.54371875, 115.22215624999998,
                115.25543749999997, 114.7735625, 111.67325, 111.7735625, 111.4923125, 111.05684374999998, 113.3204375,
                113.85621875, 113.56090624999996, 114.4454375, 111.60621875, 109.04825, 109.32903124999997,
                107.93637499999998, 110.1329375, 98.35371874999998, 95.92278124999997,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406443,
        longitude: -122.5331332,
        timestamp: '2025-08-29T01:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 127.67226863624224,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5332667,
        timestamp: '2025-08-29T01:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 133.892,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5332667,
        timestamp: '2025-08-29T01:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 8.25,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5332667,
        timestamp: '2025-08-29T01:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5332667,
        timestamp: '2025-08-29T01:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5332667,
        timestamp: '2025-08-29T01:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b102b48219017c185aa50519011a070408185e15186211185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5332667,
        timestamp: '2025-08-29T01:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                131.642, 125.642, 122.642, 118.892, 117.392, 115.142, 115.142, 117.392, 114.392, 107.642, 109.142,
                109.142, 108.392, 105.392, 105.392, 105.392, 104.642, 106.142, 106.892, 106.892, 108.392, 106.892,
                104.642, 103.892, 102.392, 105.392, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                117.392, 112.142, 111.392, 112.142, 112.892, 112.142, 112.892, 113.642, 110.642, 106.142, 106.142,
                103.892, 103.142, 100.892, 100.142, 100.142, 100.142, 100.892, 101.642, 103.142, 104.642, 103.892,
                102.392, 101.642, 100.142, 103.142, 96.392, 94.892,
            ],
            '50th_percentile': [
                124.142, 118.142, 115.142, 115.142, 114.392, 112.892, 114.392, 115.142, 112.142, 106.892, 107.642,
                106.892, 106.142, 103.142, 102.392, 101.642, 102.392, 103.142, 103.892, 104.642, 105.392, 105.392,
                103.142, 102.392, 100.892, 103.892, 96.392, 95.642,
            ],
            '75th_percentile': [
                129.392, 124.142, 120.392, 118.142, 116.642, 115.142, 115.142, 118.142, 114.392, 107.642, 109.892,
                109.892, 109.892, 106.892, 106.142, 106.142, 106.142, 107.642, 108.392, 108.392, 109.142, 107.642,
                105.392, 104.642, 103.142, 106.142, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5332667,
        timestamp: '2025-08-29T02:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 133.892,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5332667,
        timestamp: '2025-08-29T02:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5332667,
        timestamp: '2025-08-29T02:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5332667,
        timestamp: '2025-08-29T02:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5332667,
        timestamp: '2025-08-29T02:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b109bc8219017c185aa60519010e070308186b15186e1118591401',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5332667,
        timestamp: '2025-08-29T02:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                131.642, 125.642, 121.142, 118.892, 117.392, 115.892, 115.892, 116.642, 118.142, 112.892, 109.892,
                106.142, 104.642, 102.392, 102.392, 101.642, 100.892, 101.642, 103.142, 103.892, 106.142, 104.642,
                103.142, 102.392, 100.892, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                118.142, 112.892, 111.392, 113.642, 113.642, 112.892, 113.642, 115.142, 114.392, 112.142, 108.392,
                104.642, 102.392, 99.392, 99.392, 98.642, 98.642, 99.392, 99.392, 102.392, 103.892, 103.892, 102.392,
                101.642, 99.392, 103.142, 96.392, 94.892,
            ],
            '50th_percentile': [
                124.892, 118.892, 115.892, 115.892, 115.142, 114.392, 115.142, 116.642, 116.642, 112.892, 109.892,
                106.142, 103.892, 100.892, 100.892, 100.892, 99.392, 100.142, 100.892, 102.392, 104.642, 103.892,
                102.392, 101.642, 100.142, 103.892, 96.392, 95.642,
            ],
            '75th_percentile': [
                130.142, 124.142, 121.142, 118.892, 117.392, 116.642, 116.642, 117.392, 119.642, 114.392, 110.642,
                106.892, 105.392, 103.892, 103.892, 103.142, 101.642, 103.142, 103.892, 104.642, 106.142, 104.642,
                103.142, 102.392, 100.892, 104.642, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406045,
        longitude: -122.5333317,
        timestamp: '2025-08-29T02:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                124.59925340640068, 119.03251392180331, 116.52431264810654, 116.36674822275107, 115.77842254147143,
                114.89435115521547, 115.24130390995482, 116.36758130924397, 116.83377651066586, 112.86606324052346,
                109.57881501777452, 105.61176821682643, 103.61147200829555, 101.09888314573618, 100.99863507109163,
                100.69255909360346, 99.94261463270294, 100.88705702014373, 101.66871430687364, 103.27529383886423,
                105.36039825237144, 104.4798258293856, 102.90129354265567, 102.2172739928926, 100.42908160545173,
                104.03729028436187, 96.34473622630456, 95.30737692535664,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                109.02856249999999, 105.9010625, 106.3698125, 109.25590625, 110.3073125, 110.032625, 110.73575,
                111.86075, 111.09106249999999, 108.5260625, 105.83403125, 101.09309375, 98.70903125, 95.70903125,
                95.47465625, 95.38090625, 95.33403125, 96.9545, 98.28715625, 100.938875, 103.23575, 103.001375,
                101.782625, 100.81840625, 99.017, 102.41215625, 95.876375, 95.0795,
            ],
            '25th_percentile': [
                118.27090625, 113.02090625, 111.56778125, 113.54825, 113.54825, 113.220125, 113.876375, 115.142,
                114.29825, 111.86075, 108.392, 104.25528125, 102.063875, 98.8295, 99.00528125, 98.688875, 98.20840625,
                99.017, 99.5795, 101.970125, 103.98575, 103.517, 102.345125, 101.501375, 99.67325, 103.282625,
                96.157625, 95.220125,
            ],
            '50th_percentile': [
                124.517, 118.7748125, 116.126375, 115.892, 115.2123125, 114.67325, 115.23575, 116.4545, 116.126375,
                113.0560625, 109.79825, 105.813875, 103.657625, 100.8685625, 100.7045, 100.42325, 99.626375, 100.188875,
                100.517, 102.67325, 104.36075, 103.845125, 102.67325, 101.92325, 100.095125, 103.7045, 96.251375,
                95.267,
            ],
            '75th_percentile': [
                130.41153125, 124.29434375, 120.767, 118.71621875, 117.48575, 116.313875, 116.4545, 117.5795,
                119.313875, 114.017, 110.782625, 106.99746875, 105.063875, 103.7045, 103.52871875, 103.04825, 101.642,
                103.01309375, 103.2591875, 104.313875, 105.9545, 104.876375, 103.142, 102.45059375, 100.7045,
                104.27871875, 96.438875, 95.36075,
            ],
            '99th_percentile': [
                143.21309374999998, 136.7579375, 132.37090624999996, 127.96559375, 125.98324999999998, 122.4610625,
                121.12793749999997, 120.5860625, 125.76246875, 116.220125, 112.8048125, 109.892, 108.907625,
                107.25949999999996, 106.5704375, 107.15309375, 106.4766875, 106.938875, 109.8048125, 108.48575,
                112.1016875, 109.55684374999998, 105.65309375, 106.517, 105.0235625, 108.86075, 97.73121875,
                95.71559375,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406045,
        longitude: -122.5333317,
        timestamp: '2025-08-29T02:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 128.50315536430654,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406045,
        longitude: -122.5333317,
        timestamp: '2025-08-29T02:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                123.96537278106766, 118.42668934911478, 115.85710724852295, 115.3498032544401, 115.02622707100812,
                114.08423372781283, 114.32809467455839, 114.12289866864121, 110.23721079881855, 106.75237352071187,
                105.3121738165698, 102.8528727810667, 99.36587204142154, 95.74573520710179, 94.14421893491233,
                93.52291715976438, 93.96581656804842, 96.08689644970536, 98.19272115384751, 101.40346449704296,
                103.89272115384783, 103.76080547337446, 102.56518786982409, 101.71239571006073, 99.79418195266418,
                103.92705917159931, 96.17798372781189, 95.28042455621421,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                108.292625, 104.87075, 106.11574999999999, 109.0895, 109.432625, 109.39699999999999, 110.49575,
                110.19387499999999, 106.58449999999999, 103.77199999999999, 102.48575, 99.69387499999999, 95.87075,
                92.92325, 91.81887499999999, 91.72512499999999, 92.876375, 95.313875, 97.517, 100.751375, 103.188875,
                103.04825, 101.92325, 100.938875, 99.11075, 102.74074999999999, 95.876375, 95.0795,
            ],
            '25th_percentile': [
                117.86075, 112.095125, 110.313875, 112.3295, 112.845125, 112.282625, 112.98575, 112.892, 108.9545,
                105.767, 104.267, 101.36075, 97.892, 94.42325, 93.11075, 92.73575, 93.5795, 95.8295, 97.98575,
                101.17325, 103.657625, 103.563875, 102.392, 101.501375, 99.5795, 103.563875, 96.063875, 95.220125,
            ],
            '50th_percentile': [
                123.9545, 118.751375, 115.282625, 114.29825, 114.392, 113.73575, 114.2045, 114.157625, 110.220125,
                106.657625, 105.157625, 102.532625, 99.157625, 95.313875, 93.907625, 93.392, 93.907625, 96.063875,
                98.17325, 101.407625, 103.892, 103.751375, 102.5795, 101.73575, 99.767, 103.938875, 96.157625, 95.267,
            ],
            '75th_percentile': [
                129.438875, 123.767, 120.063875, 117.48575, 116.54825, 115.470125, 115.42325, 115.23575, 111.48575,
                107.595125, 106.095125, 104.0795, 100.61075, 96.813875, 94.938875, 94.142, 94.3295, 96.345125,
                98.407625, 101.595125, 104.126375, 103.98575, 102.767, 101.92325, 100.001375, 104.267, 96.251375,
                95.313875,
            ],
            '99th_percentile': [
                144.491375, 137.61199999999997, 132.82324999999994, 129.16325, 125.94574999999998, 122.87262499999997,
                121.32012499999999, 118.75699999999999, 115.38199999999999, 111.23637499999998, 109.402625, 108.23075,
                104.67387499999998, 100.95012499999999, 97.91825, 96.39762499999999, 95.54825, 97.215125, 98.9495,
                102.23075, 104.595125, 104.407625, 103.16825, 102.345125, 100.517, 105.29825, 96.79325, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406045,
        longitude: -122.5333317,
        timestamp: '2025-08-29T02:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 127.31823222148577,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.53335,
        timestamp: '2025-08-29T02:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 133.892,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.53335,
        timestamp: '2025-08-29T02:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 8.25,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.53335,
        timestamp: '2025-08-29T02:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.53335,
        timestamp: '2025-08-29T02:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.53335,
        timestamp: '2025-08-29T02:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b110c58219017c185aa40518c20718ba1518ba11185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.53335,
        timestamp: '2025-08-29T02:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                131.642, 125.642, 122.642, 118.892, 116.642, 115.142, 115.142, 114.392, 110.642, 106.892, 105.392,
                103.142, 100.142, 96.392, 94.142, 93.392, 94.142, 96.392, 97.892, 101.642, 103.892, 103.892, 102.392,
                101.642, 100.142, 103.892, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                118.142, 112.142, 110.642, 112.142, 112.892, 112.142, 112.892, 112.892, 109.142, 105.392, 104.642,
                101.642, 97.892, 94.142, 93.392, 92.642, 93.392, 95.642, 97.892, 100.892, 103.892, 103.892, 102.392,
                101.642, 99.392, 103.892, 96.392, 94.892,
            ],
            '50th_percentile': [
                124.142, 118.892, 115.142, 114.392, 114.392, 113.642, 114.392, 114.392, 109.892, 106.892, 105.392,
                102.392, 99.392, 95.642, 94.142, 93.392, 94.142, 96.392, 97.892, 101.642, 103.892, 103.892, 102.392,
                101.642, 100.142, 103.892, 96.392, 95.642,
            ],
            '75th_percentile': [
                129.392, 123.392, 120.392, 117.392, 116.642, 115.142, 115.142, 115.142, 111.392, 107.642, 106.142,
                103.892, 100.892, 96.392, 94.892, 94.142, 94.142, 96.392, 98.642, 101.642, 103.892, 103.892, 102.392,
                101.642, 100.142, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.53335,
        timestamp: '2025-08-29T03:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 131.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.53335,
        timestamp: '2025-08-29T03:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 8.25,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.53335,
        timestamp: '2025-08-29T03:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.53335,
        timestamp: '2025-08-29T03:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.53335,
        timestamp: '2025-08-29T03:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b117cc8219017c185aa6051863071901160803151901191118591401',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.53335,
        timestamp: '2025-08-29T03:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                129.392, 123.392, 119.642, 118.142, 116.642, 115.892, 116.642, 115.892, 112.142, 109.892, 109.892,
                109.142, 106.142, 102.392, 100.892, 100.142, 98.642, 99.392, 100.892, 102.392, 104.642, 104.642,
                104.642, 103.892, 101.642, 106.142, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                115.892, 111.392, 112.142, 113.642, 113.642, 113.642, 115.142, 113.642, 110.642, 108.392, 109.142,
                107.642, 104.642, 100.142, 97.142, 94.892, 93.392, 94.142, 96.392, 99.392, 101.642, 102.392, 102.392,
                101.642, 100.142, 104.642, 96.392, 95.642,
            ],
            '50th_percentile': [
                121.892, 116.642, 114.392, 115.142, 115.892, 114.392, 115.892, 115.142, 111.392, 109.142, 109.892,
                108.392, 105.392, 101.642, 98.642, 97.142, 95.642, 97.142, 98.642, 101.642, 103.892, 103.892, 103.142,
                102.392, 100.892, 105.392, 96.392, 95.642,
            ],
            '75th_percentile': [
                127.892, 121.892, 118.892, 117.392, 117.392, 115.892, 117.392, 116.642, 112.892, 110.642, 110.642,
                109.142, 106.892, 103.142, 101.642, 100.142, 99.392, 100.142, 100.892, 103.142, 105.392, 105.392,
                105.392, 103.892, 102.392, 106.142, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406167,
        longitude: -122.5334088,
        timestamp: '2025-08-29T03:14:06.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.15111612426284, 117.02981434911472, 115.67787278106732, 115.8901139053277, 115.79536538461763,
                114.87423002958799, 116.11145266272413, 115.21572411242825, 111.79728846154053, 109.49719600591914,
                109.97021745562328, 108.62964792899601, 105.94911908284203, 101.94177810651048, 99.62482174556362,
                97.91607544378839, 96.55276183432085, 97.57946301775286, 99.03613831361093, 101.40623816568207,
                103.88040606509047, 104.1302581360964, 103.98342011834492, 103.07454437869988, 101.28120118343351,
                105.41640828402545, 96.36742529585925, 95.32424852071125,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                108.74074999999999, 106.230125, 108.22512499999999, 110.19387499999999, 111.157625, 111.105125,
                112.563875, 112.001375, 108.480125, 106.792625, 107.501375, 105.78762499999999, 103.06887499999999,
                98.38137499999999, 95.407625, 93.27199999999999, 91.892, 93.27199999999999, 95.33449999999999, 98.267,
                101.05324999999999, 101.8295, 101.33449999999999, 100.845125, 99.392, 103.3295, 95.94387499999999,
                95.126375,
            ],
            '25th_percentile': [
                116.126375, 111.29825, 111.86075, 113.4545, 113.92325, 113.407625, 114.86075, 113.92325, 110.407625,
                108.532625, 109.142, 107.73575, 104.73575, 100.282625, 97.23575, 95.17325, 93.438875, 94.3295,
                96.251375, 99.11075, 101.876375, 102.626375, 102.017, 101.501375, 99.86075, 104.220125, 96.2045, 95.267,
            ],
            '50th_percentile': [
                122.0795, 116.407625, 114.438875, 115.376375, 115.563875, 114.720125, 115.98575, 115.142, 111.67325,
                109.376375, 109.892, 108.48575, 105.626375, 101.4545, 98.688875, 96.626375, 95.4545, 96.813875, 98.267,
                101.267, 103.845125, 103.938875, 103.3295, 102.532625, 100.751375, 104.970125, 96.29825, 95.313875,
            ],
            '75th_percentile': [
                127.61075, 121.79825, 118.751375, 117.67325, 117.2045, 116.032625, 117.345125, 116.313875, 113.032625,
                110.36075, 110.782625, 109.42325, 106.845125, 103.188875, 101.54825, 100.282625, 99.063875, 99.907625,
                100.938875, 102.67325, 104.92325, 105.157625, 105.532625, 104.0795, 102.345125, 106.04825, 96.48575,
                95.36075,
            ],
            '99th_percentile': [
                139.70637499999998, 133.0557499999999, 129.52325, 126.59824999999995, 124.08012499999998,
                121.61262499999998, 120.251375, 119.27262499999999, 116.152625, 112.845125, 112.80387499999999,
                112.17949999999999, 110.74137499999999, 108.33012499999998, 107.34574999999998, 107.715125,
                106.84137499999997, 107.55949999999999, 108.14262499999998, 108.652625, 110.37762499999998, 108.79325,
                110.43949999999998, 108.25699999999999, 106.29387499999999, 110.46012499999999, 97.142, 95.762,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406167,
        longitude: -122.5334088,
        timestamp: '2025-08-29T03:14:06.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 126.98784401425961,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406167,
        longitude: -122.5334088,
        timestamp: '2025-08-29T03:44:06.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                121.35069082840482, 116.97594970414428, 116.63179289941054, 116.26206286982475, 114.57495118343415,
                112.99418195266485, 113.68366050296073, 112.29660428994293, 108.6874511834339, 106.90858653846338,
                107.04577218935096, 105.81359763313789, 102.85192973372945, 97.53746967455754, 94.42580177514907,
                92.77630103550399, 92.06163757396548, 93.88560207100703, 96.42245488165807, 99.80716272189494,
                102.79806508875902, 103.03415976331524, 101.93678550296015, 101.50986242603706, 99.95749556213164,
                104.78850517751653, 96.25109763313733, 95.4017448224864,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                110.05324999999999, 108.62075, 110.93825, 111.97512499999999, 110.56887499999999, 109.02199999999999,
                109.79825, 108.198875, 104.70949999999999, 104.126375, 104.28762499999999, 102.43325, 99.392,
                93.64699999999999, 90.907625, 89.92325, 90.27199999999999, 92.876375, 95.642, 99.017,
                102.08449999999999, 102.27199999999999, 101.267, 100.892, 99.29825, 103.751375, 95.8295,
                95.10012499999999,
            ],
            '25th_percentile': [
                115.188875, 111.86075, 113.4545, 114.157625, 112.845125, 111.2045, 111.9545, 110.595125, 107.0795,
                105.813875, 106.04825, 104.501375, 101.407625, 95.8295, 93.157625, 91.470125, 91.142, 93.392, 96.11075,
                99.5795, 102.5795, 102.767, 101.688875, 101.267, 99.720125, 104.407625, 96.017, 95.220125,
            ],
            '50th_percentile': [
                120.251375, 115.23575, 115.04825, 115.563875, 114.063875, 112.517, 113.407625, 112.04825, 108.392,
                106.751375, 106.98575, 105.5795, 102.626375, 97.188875, 94.188875, 92.36075, 91.7045, 93.67325,
                96.345125, 99.767, 102.767, 103.001375, 101.92325, 101.4545, 99.86075, 104.642, 96.11075, 95.313875,
            ],
            '75th_percentile': [
                126.767, 121.282625, 119.220125, 117.48575, 115.517, 114.2045, 115.001375, 113.876375, 110.220125,
                107.73575, 107.92325, 106.938875, 103.892, 98.876375, 95.642, 93.720125, 92.407625, 94.04825, 96.626375,
                99.9545, 102.9545, 103.23575, 102.11075, 101.642, 100.095125, 104.92325, 96.251375, 95.36075,
            ],
            '99th_percentile': [
                140.76762499999998, 134.257625, 130.61449999999996, 127.12324999999997, 125.25199999999998, 122.058875,
                119.97574999999999, 118.57699999999997, 114.29825, 112.10637499999999, 111.3245, 110.90449999999997,
                110.83512499999999, 104.25387499999997, 100.17387499999998, 99.933875, 99.02824999999999,
                97.60699999999997, 97.91825, 100.751375, 103.4495, 103.79825, 102.767, 102.183875, 100.78324999999998,
                106.470125, 97.73637499999998, 97.13449999999996,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406167,
        longitude: -122.5334088,
        timestamp: '2025-08-29T03:44:06.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 126.03342030929831,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5333833,
        timestamp: '2025-08-29T03:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 131.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5333833,
        timestamp: '2025-08-29T03:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 8.25,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5333833,
        timestamp: '2025-08-29T03:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5333833,
        timestamp: '2025-08-29T03:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5333833,
        timestamp: '2025-08-29T03:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b11ed58219017c185aa405120719016a1519016a11185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5333833,
        timestamp: '2025-08-29T03:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                129.392, 123.392, 120.392, 118.142, 115.892, 114.392, 114.392, 112.892, 109.142, 107.642, 107.642,
                106.142, 103.892, 98.642, 94.892, 93.392, 92.642, 94.142, 96.392, 100.142, 103.142, 103.142, 102.392,
                102.392, 104.642, 109.892, 97.892, 96.392,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                115.142, 112.142, 113.642, 114.392, 112.892, 111.392, 112.142, 110.642, 106.892, 106.142, 106.142,
                104.642, 101.642, 95.642, 93.392, 91.142, 91.142, 93.392, 96.392, 99.392, 102.392, 103.142, 101.642,
                101.642, 99.392, 104.642, 96.392, 94.892,
            ],
            '50th_percentile': [
                120.392, 115.142, 115.142, 115.892, 114.392, 112.892, 113.642, 112.142, 108.392, 106.892, 106.892,
                105.392, 102.392, 97.142, 94.142, 92.642, 91.892, 93.392, 96.392, 100.142, 103.142, 103.142, 101.642,
                101.642, 100.142, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                126.392, 121.142, 118.892, 117.392, 115.142, 114.392, 115.142, 113.642, 109.892, 107.642, 107.642,
                106.892, 103.892, 99.392, 95.642, 94.142, 92.642, 94.142, 96.392, 100.142, 103.142, 103.142, 102.392,
                101.642, 100.142, 104.642, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5333833,
        timestamp: '2025-08-29T04:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 127.892,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5333833,
        timestamp: '2025-08-29T04:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 7.5,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5333833,
        timestamp: '2025-08-29T04:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5333833,
        timestamp: '2025-08-29T04:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5333833,
        timestamp: '2025-08-29T04:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b125dc8219017c185aa70518230719015915190159111856120114031601',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5333833,
        timestamp: '2025-08-29T04:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                124.892, 119.642, 118.142, 117.392, 115.142, 112.892, 112.142, 110.642, 106.892, 104.642, 104.642,
                103.892, 100.142, 95.642, 92.642, 91.142, 91.142, 93.392, 96.392, 100.142, 102.392, 103.142, 101.642,
                100.892, 99.392, 105.392, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                113.642, 111.392, 112.892, 114.392, 112.142, 110.642, 110.642, 109.142, 105.392, 103.892, 103.142,
                101.642, 97.892, 92.642, 90.392, 89.642, 90.392, 93.392, 95.642, 99.392, 102.392, 102.392, 100.892,
                100.892, 99.392, 104.642, 95.642, 94.892,
            ],
            '50th_percentile': [
                117.392, 113.642, 114.392, 115.142, 113.642, 111.392, 111.392, 109.892, 106.142, 104.642, 103.892,
                102.392, 99.392, 94.142, 91.892, 90.392, 91.142, 93.392, 96.392, 100.142, 102.392, 103.142, 101.642,
                100.892, 99.392, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                123.392, 118.892, 117.392, 116.642, 114.392, 112.142, 112.142, 111.392, 107.642, 105.392, 104.642,
                103.892, 100.892, 95.642, 92.642, 91.142, 91.142, 93.392, 96.392, 100.142, 103.142, 103.142, 101.642,
                100.892, 100.142, 105.392, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.440653,
        longitude: -122.5336052,
        timestamp: '2025-08-29T04:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                119.00744421487845, 115.35783530106481, 115.5508695395536, 115.6401368063777, 113.92042753837289,
                111.8297582644649, 111.63218595041529, 110.1950548996478, 106.60377685950596, 104.61687455726265,
                104.07114329988364, 102.91515156434639, 99.5642808441573, 94.44167901416878, 91.92830460448741,
                90.7036883116892, 91.01714757969397, 93.42066735537298, 96.1324442148773, 99.75897535419273,
                102.69356065525548, 102.76030357143021, 101.38272092680204, 101.05703099173707, 99.58752464581019,
                104.85451475797103, 96.28325221369666, 95.40779102715587,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                108.907625, 108.01325, 110.782625, 112.0229375, 110.6635625, 108.7416875, 108.767, 107.122625,
                103.470125, 102.01325, 101.3354375, 100.0698125, 96.48575, 91.0229375, 89.126375, 88.79825, 89.8510625,
                92.54825, 95.407625, 99.063875, 101.92325, 101.782625, 100.563875, 100.470125, 98.970125, 103.7045,
                95.73575, 95.126375,
            ],
            '25th_percentile': [
                113.54825, 111.438875, 112.892, 114.063875, 112.517, 110.595125, 110.501375, 109.095125, 105.438875,
                103.61075, 102.9545, 101.267, 98.032625, 92.595125, 90.438875, 89.688875, 90.438875, 93.063875,
                95.876375, 99.532625, 102.438875, 102.392, 101.0795, 100.845125, 99.392, 104.36075, 95.970125,
                95.220125,
            ],
            '50th_percentile': [
                117.626375, 113.73575, 114.29825, 114.907625, 113.267, 111.345125, 111.438875, 110.032625, 106.376375,
                104.4545, 103.938875, 102.532625, 99.2045, 93.907625, 91.657625, 90.438875, 90.767, 93.251375,
                96.063875, 99.767, 102.720125, 102.767, 101.36075, 101.032625, 99.5795, 104.688875, 96.11075, 95.313875,
            ],
            '75th_percentile': [
                123.6966875, 118.61075, 117.157625, 116.313875, 114.48575, 112.3060625, 112.376375, 111.11075,
                107.501375, 105.29825, 104.9935625, 104.17325, 100.751375, 95.8529375, 92.9935625, 91.42325, 91.282625,
                93.5795, 96.29825, 99.9545, 102.907625, 103.095125, 101.688875, 101.220125, 99.767, 105.11075, 96.2045,
                95.36075,
            ],
            '99th_percentile': [
                135.4754375, 130.6866875, 128.79387499999999, 126.0891875, 124.09231249999998, 121.54606249999999,
                118.87793749999999, 115.4954375, 112.84887499999999, 109.4485625, 107.76856249999999, 108.3704375,
                105.63387499999999, 101.55293749999997, 97.52074999999999, 94.6360625, 94.41668749999998,
                97.27699999999996, 98.28949999999998, 100.61075, 103.517, 103.751375, 102.345125, 101.9485625,
                101.0579375, 110.4329375, 102.06762499999999, 99.017,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.440653,
        longitude: -122.5336052,
        timestamp: '2025-08-29T04:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 124.43501549587077,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.440653,
        longitude: -122.5336052,
        timestamp: '2025-08-29T04:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                115.44820941558666, 111.50998996458293, 112.04537219598792, 114.19193727863264, 113.12283308736932,
                111.21147314049792, 111.46992207792412, 109.79575959268203, 106.05068506493686, 104.02598391381515,
                103.42557438016695, 102.68171738488948, 99.3467299291632, 93.76307069067407, 91.33060684769869,
                90.4760650826455, 90.87203984651804, 93.33101269185467, 96.02137204840739, 99.78221915584562,
                102.80845144628262, 102.83628866588121, 101.26312603305941, 100.82581050767566, 99.51513680637689,
                104.41747594451176, 96.20206493506619, 95.35731877213816,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.4648125, 104.1948125, 107.2416875, 111.0385625, 110.6635625, 108.767, 109.517, 107.4291875,
                103.9135625, 101.8510625, 100.845125, 99.438875, 96.20075, 90.4604375, 88.892, 88.6791875, 89.8510625,
                92.4760625, 95.2885625, 99.017, 102.017, 101.9916875, 100.517, 100.2104375, 98.92325, 103.5385625,
                95.782625, 95.126375,
            ],
            '25th_percentile': [
                109.79825, 106.892, 109.282625, 112.8216875, 112.04825, 110.267, 110.688875, 109.04825, 105.345125,
                103.188875, 102.251375, 100.79825, 97.5404375, 91.98575, 90.017, 89.501375, 90.392, 93.017, 95.73575,
                99.532625, 102.532625, 102.5795, 100.98575, 100.61075, 99.29825, 104.032625, 96.017, 95.267,
            ],
            '50th_percentile': [
                114.392, 109.563875, 110.54825, 113.642, 112.751375, 110.92325, 111.29825, 109.7045, 105.9545,
                103.79825, 103.142, 102.157625, 98.782625, 93.2045, 90.9545, 90.157625, 90.67325, 93.251375, 95.970125,
                99.767, 102.813875, 102.813875, 101.267, 100.79825, 99.48575, 104.267, 96.11075, 95.36075,
            ],
            '75th_percentile': [
                120.0873125, 114.907625, 113.4779375, 114.767, 113.54825, 111.626375, 112.04825, 110.36075, 106.657625,
                104.4545, 104.2435625, 103.938875, 100.563875, 94.98575, 92.220125, 91.04825, 91.142, 93.532625,
                96.251375, 100.001375, 103.04825, 103.095125, 101.54825, 100.98575, 99.67325, 104.595125, 96.251375,
                95.407625,
            ],
            '99th_percentile': [
                133.40918749999997, 128.43293749999998, 126.76418749999998, 123.89356249999999, 121.78418749999999,
                119.27074999999999, 116.24918749999999, 113.17325, 109.83481249999998, 111.66668749999998,
                108.72387499999999, 112.7045, 107.96074999999996, 100.9173125, 96.11449999999999, 94.99418749999997,
                93.39574999999999, 94.92106249999999, 97.142, 100.66137499999999, 103.61075, 103.61075, 102.0891875,
                101.6673125, 100.8235625, 107.88012499999999, 97.8704375, 95.9485625,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.440653,
        longitude: -122.5336052,
        timestamp: '2025-08-29T04:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 122.38649776226953,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410167,
        longitude: -122.5339,
        timestamp: '2025-08-29T04:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410167,
        longitude: -122.5339,
        timestamp: '2025-08-29T04:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 7.5,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410167,
        longitude: -122.5339,
        timestamp: '2025-08-29T04:44:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410167,
        longitude: -122.5339,
        timestamp: '2025-08-29T04:44:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410167,
        longitude: -122.5339,
        timestamp: '2025-08-29T04:44:00.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b12ce48219017c185aa805185707190120080515190125111856130114041601',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410167,
        longitude: -122.5339,
        timestamp: '2025-08-29T04:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.642, 117.392, 115.142, 115.142, 114.392, 112.142, 111.392, 109.892, 106.142, 104.642, 103.892,
                103.892, 100.142, 94.892, 91.892, 91.142, 91.142, 93.392, 96.392, 100.142, 103.142, 103.142, 101.642,
                100.892, 99.392, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                109.892, 106.892, 109.142, 112.892, 112.142, 110.642, 110.642, 109.142, 105.392, 103.142, 102.392,
                100.892, 97.892, 91.892, 89.642, 89.642, 90.392, 93.392, 95.642, 99.392, 102.392, 102.392, 100.892,
                100.892, 99.392, 103.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                114.392, 109.892, 110.642, 113.642, 112.892, 110.642, 111.392, 109.892, 106.142, 103.892, 103.142,
                102.392, 98.642, 93.392, 91.142, 90.392, 90.392, 93.392, 95.642, 100.142, 103.142, 103.142, 100.892,
                100.892, 99.392, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                119.642, 114.392, 113.642, 114.392, 113.642, 111.392, 112.142, 110.642, 106.892, 104.642, 103.892,
                103.892, 100.892, 94.892, 91.892, 91.142, 91.142, 93.392, 96.392, 100.142, 103.142, 103.142, 101.642,
                100.892, 99.392, 104.642, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410167,
        longitude: -122.5339,
        timestamp: '2025-08-29T05:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 126.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410167,
        longitude: -122.5339,
        timestamp: '2025-08-29T05:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 8.25,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410167,
        longitude: -122.5339,
        timestamp: '2025-08-29T05:14:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410167,
        longitude: -122.5339,
        timestamp: '2025-08-29T05:14:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410167,
        longitude: -122.5339,
        timestamp: '2025-08-29T05:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.642, 117.392, 115.142, 115.892, 114.392, 112.892, 112.892, 111.392, 106.892, 104.642, 103.142,
                103.142, 99.392, 94.142, 91.142, 90.392, 91.142, 94.142, 96.392, 100.142, 103.142, 103.892, 101.642,
                100.892, 99.392, 103.892, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                110.642, 106.892, 109.142, 112.892, 112.892, 110.642, 111.392, 110.642, 106.142, 103.892, 102.392,
                100.142, 97.142, 91.892, 89.642, 89.642, 90.392, 93.392, 96.392, 100.142, 103.142, 103.142, 101.642,
                100.142, 99.392, 103.142, 96.392, 95.642,
            ],
            '50th_percentile': [
                116.642, 111.392, 110.642, 113.642, 113.642, 111.392, 112.142, 111.392, 106.892, 103.892, 103.142,
                100.892, 97.892, 92.642, 90.392, 90.392, 91.142, 93.392, 96.392, 100.142, 103.142, 103.892, 101.642,
                100.892, 99.392, 103.892, 96.392, 95.642,
            ],
            '75th_percentile': [
                121.892, 116.642, 114.392, 115.142, 114.392, 112.892, 112.892, 112.142, 107.642, 104.642, 103.892,
                103.142, 99.392, 94.142, 91.892, 91.142, 91.142, 94.142, 97.142, 100.142, 103.142, 103.892, 102.392,
                100.892, 99.392, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4412905,
        longitude: -122.5339018,
        timestamp: '2025-08-29T05:30:03.000Z',
        sensorPosition: null,
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        units: 'hex',
        value: '626d5f70726f746f636f6c2076302e31332e332c20626f7265616c6973206d6f746520386135343735336463362c206461712036306332393638',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: null,
    },
    {
        latitude: 37.4413772,
        longitude: -122.5338303,
        timestamp: '2025-08-29T05:14:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                116.73707978723631, 112.38640381205883, 112.18084086879641, 114.57584308510856, 113.86257845744898,
                112.09301950354818, 112.4076250000021, 111.1467096631226, 106.88645921986, 104.17762721631375,
                103.10365780142008, 101.82672960993065, 98.47982136524962, 93.26855141844078, 91.05223936170306,
                90.36690026595832, 91.00647251773142, 93.83332313829897, 96.6252114361715, 100.19469281915042,
                103.18998315603002, 103.5919113475194, 101.8103289007108, 100.61595833333485, 99.54985682624257,
                103.75431161347686, 96.256638741136, 95.35315913120688,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.9185625, 103.67403125, 106.53809375, 110.8295, 110.94434375, 109.06934375, 109.86621875, 108.720125,
                104.66309375, 102.27246875, 100.79825, 99.063875, 95.8295, 90.532625, 88.98575, 88.938875, 90.063875,
                92.970125, 95.876375, 99.532625, 102.532625, 102.86075, 100.892, 100.11621875, 99.017, 102.907625,
                95.876375, 95.10059375,
            ],
            '25th_percentile': [
                110.5716875, 106.85684375, 108.86075, 113.032625, 112.563875, 110.876375, 111.48575, 110.313875,
                106.142, 103.517, 102.11075, 100.188875, 96.86075, 91.7045, 89.876375, 89.642, 90.67325, 93.392,
                96.345125, 100.001375, 103.001375, 103.42325, 101.595125, 100.470125, 99.392, 103.42325, 96.063875,
                95.267,
            ],
            '50th_percentile': [
                116.5248125, 111.3685625, 110.688875, 113.92325, 113.313875, 111.5795, 112.23575, 111.017, 106.751375,
                104.0795, 102.813875, 101.126375, 97.845125, 92.782625, 90.67325, 90.063875, 90.907625, 93.626375,
                96.532625, 100.188875, 103.188875, 103.61075, 101.8295, 100.61075, 99.532625, 103.657625, 96.2045,
                95.36075,
            ],
            '75th_percentile': [
                122.032625, 116.8295, 114.52090625, 115.42325, 114.67325, 112.751375, 113.0795, 111.767, 107.501375,
                104.73575, 103.7045, 102.720125, 99.38028125, 94.42325, 91.657625, 90.80215625, 91.188875, 93.86075,
                96.767, 100.376375, 103.376375, 103.79825, 102.017, 100.751375, 99.720125, 103.98575, 96.345125,
                95.407625,
            ],
            '99th_percentile': [
                132.87012499999997, 127.71387499999999, 125.10996875, 123.27715624999999, 121.40215624999999,
                118.76543749999999, 116.53653124999998, 114.88653124999999, 110.13574999999999, 107.13106249999998,
                107.78731249999998, 110.94903124999999, 105.78574999999998, 99.82324999999999, 96.75059375,
                93.79278124999999, 93.157625, 98.27637499999999, 98.95371875, 100.96465624999999, 103.892, 104.36075,
                102.5795, 101.126375, 100.35528124999999, 105.40137499999999, 97.26153124999999, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4413772,
        longitude: -122.5338303,
        timestamp: '2025-08-29T05:14:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 123.13516656515297,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4413772,
        longitude: -122.5338303,
        timestamp: '2025-08-29T05:44:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                115.98806345476139, 111.56694124559549, 111.51191407168245, 114.04426571680595, 113.36097032902684,
                111.62373105170597, 112.07584621034289, 110.59727320799266, 106.25398222679384, 103.56260810810983,
                102.73306933020142, 101.72566994712264, 98.46221151586509, 93.09328892479544, 91.2290299647483,
                90.10639850176352, 90.4156302878975, 92.92247884841471, 95.92710575793312, 99.64730625734578,
                101.87775205640584, 102.66779685664089, 101.36003393067138, 100.64528657461965, 100.44935898942573,
                104.10665555229315, 96.39271606933148, 95.4091122209178,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.407625, 103.517, 106.563875, 110.7591875, 110.970125, 109.23575, 109.938875, 108.6966875,
                104.4779375, 101.4779375, 99.767, 97.79825, 94.938875, 90.1810625, 88.3998125, 88.188875, 89.2435625,
                91.938875, 95.17325, 98.876375, 101.0795, 101.970125, 100.657625, 100.095125, 99.767, 103.1185625,
                95.970125, 95.17325,
            ],
            '25th_percentile': [
                109.563875, 106.563875, 108.626375, 112.79825, 112.376375, 110.782625, 111.392, 109.845125, 105.626375,
                102.67325, 101.126375, 99.392, 96.392, 91.42325, 89.4545, 88.938875, 89.8295, 92.407625, 95.642, 99.392,
                101.642, 102.48575, 101.17325, 100.470125, 100.188875, 103.7045, 96.2045, 95.313875,
            ],
            '50th_percentile': [
                115.188875, 110.17325, 110.0795, 113.688875, 113.126375, 111.438875, 112.001375, 110.501375, 106.142,
                103.282625, 102.063875, 100.470125, 97.563875, 92.4545, 90.48575, 89.54825, 90.157625, 92.688875,
                95.876375, 99.626375, 101.876375, 102.67325, 101.36075, 100.61075, 100.42325, 103.98575, 96.345125,
                95.407625,
            ],
            '75th_percentile': [
                121.5873125, 115.8685625, 113.220125, 114.720125, 113.8998125, 112.188875, 112.657625, 111.2045,
                106.751375, 103.98575, 103.7045, 102.67325, 99.720125, 93.9779375, 92.1029375, 90.67325, 90.5795,
                93.063875, 96.157625, 99.907625, 102.11075, 102.86075, 101.54825, 100.845125, 100.657625, 104.313875,
                96.48575, 95.4545,
            ],
            '99th_percentile': [
                133.8685625, 127.657625, 124.9154375, 121.2123125, 118.7279375, 116.1498125, 114.5795, 113.642,
                109.8685625, 110.2904375, 111.4623125, 116.6185625, 109.42325, 102.532625, 100.4466875, 96.7435625,
                94.517, 96.9545, 97.282625, 100.470125, 102.7435625, 103.3529375, 102.063875, 101.3373125, 101.407625,
                106.98575, 97.845125, 95.970125,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4413772,
        longitude: -122.5338303,
        timestamp: '2025-08-29T05:44:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 122.56248514983812,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414667,
        longitude: -122.5336667,
        timestamp: '2025-08-29T05:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414667,
        longitude: -122.5336667,
        timestamp: '2025-08-29T05:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414667,
        longitude: -122.5336667,
        timestamp: '2025-08-29T05:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414667,
        longitude: -122.5336667,
        timestamp: '2025-08-29T05:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414667,
        longitude: -122.5336667,
        timestamp: '2025-08-29T05:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b13af58219017c185aa4051833071901491519014911185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414667,
        longitude: -122.5336667,
        timestamp: '2025-08-29T05:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.642, 116.642, 114.392, 114.392, 113.642, 112.142, 112.142, 110.642, 106.142, 103.892, 103.892,
                106.142, 100.142, 94.142, 92.642, 90.392, 90.392, 93.392, 95.642, 99.392, 101.642, 102.392, 101.642,
                100.892, 100.142, 103.892, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                109.892, 106.892, 108.392, 112.892, 112.142, 110.642, 111.392, 109.892, 105.392, 102.392, 100.892,
                99.392, 96.392, 91.142, 89.642, 88.892, 89.642, 92.642, 95.642, 99.392, 101.642, 102.392, 100.892,
                100.142, 100.142, 103.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                115.142, 109.892, 109.892, 113.642, 112.892, 111.392, 112.142, 110.642, 106.142, 103.142, 102.392,
                100.892, 97.892, 92.642, 90.392, 89.642, 90.392, 92.642, 95.642, 99.392, 101.642, 102.392, 101.642,
                100.892, 100.142, 103.892, 96.392, 95.642,
            ],
            '75th_percentile': [
                121.892, 115.892, 112.892, 114.392, 113.642, 112.142, 112.892, 111.392, 106.892, 103.892, 103.892,
                102.392, 99.392, 94.142, 91.892, 90.392, 90.392, 93.392, 96.392, 100.142, 102.392, 103.142, 101.642,
                100.892, 100.892, 104.642, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414667,
        longitude: -122.5336667,
        timestamp: '2025-08-29T06:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 127.142,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414667,
        longitude: -122.5336667,
        timestamp: '2025-08-29T06:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414667,
        longitude: -122.5336667,
        timestamp: '2025-08-29T06:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414667,
        longitude: -122.5336667,
        timestamp: '2025-08-29T06:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414667,
        longitude: -122.5336667,
        timestamp: '2025-08-29T06:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b141fc8219017c185aa5050b07190171151901711118561404',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414667,
        longitude: -122.5336667,
        timestamp: '2025-08-29T06:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                124.142, 118.142, 115.142, 115.142, 113.642, 111.392, 112.142, 110.642, 106.142, 103.892, 103.142,
                103.142, 100.892, 94.892, 91.892, 90.392, 90.392, 92.642, 96.392, 99.392, 100.892, 101.642, 100.892,
                100.142, 100.142, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                109.892, 106.892, 108.392, 112.142, 112.142, 110.642, 110.642, 109.892, 105.392, 102.392, 100.892,
                99.392, 96.392, 91.142, 89.642, 88.892, 89.642, 92.642, 96.392, 99.392, 100.142, 101.642, 100.892,
                100.142, 100.142, 103.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                115.142, 110.642, 109.892, 113.642, 112.892, 111.392, 111.392, 109.892, 106.142, 103.142, 101.642,
                100.892, 97.892, 92.642, 90.392, 89.642, 90.392, 92.642, 96.392, 99.392, 100.892, 101.642, 100.892,
                100.142, 100.142, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                122.642, 116.642, 113.642, 114.392, 113.642, 112.142, 112.142, 110.642, 106.892, 103.892, 103.142,
                103.142, 100.142, 94.892, 91.892, 91.142, 90.392, 92.642, 96.392, 100.142, 100.892, 102.392, 101.642,
                100.892, 100.142, 104.642, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414628,
        longitude: -122.5337932,
        timestamp: '2025-08-29T06:14:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                116.52464705882582, 112.0904375000021, 111.80510661764916, 113.91652205882572, 113.07663235294334,
                111.28948161764913, 111.57685294117856, 110.21598897059027, 106.02641176470772, 103.30358088235464,
                102.57745955882517, 101.61315808823689, 98.64983088235437, 93.40247794117757, 91.00159558823623,
                90.04937132353028, 90.31986764705972, 92.66979411764812, 96.29620955882483, 99.59284558823678,
                100.64747794117801, 101.77016176470747, 101.22762500000157, 100.47878308823681, 100.15876470588385,
                104.3719448529429, 96.23041911764834, 95.4096654411777,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.45356249999999, 103.63371875, 106.53996875, 110.52434375, 110.33684375, 108.78996875, 109.49309375,
                108.157625, 104.14934375, 101.267, 99.83684375, 97.86809375, 94.77434375, 89.89934375, 88.470125,
                88.30559375, 89.17325, 91.79825, 95.47746875, 98.80559375, 99.67325, 100.96184375, 100.657625, 99.86075,
                99.345125, 103.282625, 95.876375, 95.17325,
            ],
            '25th_percentile': [
                109.90371875, 106.57559375, 108.438875, 112.376375, 112.001375, 110.407625, 110.876375, 109.61075,
                105.345125, 102.438875, 101.09121875, 99.438875, 96.345125, 91.282625, 89.407625, 89.032625, 89.8295,
                92.36075, 96.017, 99.29825, 100.282625, 101.4545, 101.032625, 100.282625, 99.86075, 103.98575,
                96.063875, 95.313875,
            ],
            '50th_percentile': [
                115.376375, 110.220125, 110.126375, 113.313875, 112.61075, 111.063875, 111.438875, 110.0795, 105.907625,
                103.001375, 101.8998125, 100.7045, 97.7045, 92.501375, 90.438875, 89.54825, 90.157625, 92.642, 96.29825,
                99.532625, 100.61075, 101.73575, 101.220125, 100.470125, 100.142, 104.313875, 96.2045, 95.407625,
            ],
            '75th_percentile': [
                122.34903125, 116.58340625, 113.7591875, 114.532625, 113.501375, 111.813875, 112.095125, 110.642,
                106.517, 103.657625, 103.470125, 103.08340625, 100.08340625, 94.845125, 92.220125, 90.767, 90.61465625,
                92.92325, 96.5795, 99.813875, 100.98575, 102.017, 101.407625, 100.657625, 100.41153125, 104.642,
                96.29825, 95.4545,
            ],
            '99th_percentile': [
                134.8323125, 129.27528125, 126.09059375, 123.3948125, 120.27621875, 116.75965624999999, 116.01059375,
                115.1016875, 109.331375, 109.22309374999999, 109.58778124999999, 113.08324999999999, 110.69075,
                102.53356249999999, 97.4260625, 95.10434375, 93.18153124999999, 94.04825, 97.23575, 100.68153124999999,
                102.08778124999999, 102.9545, 102.017, 101.36075, 101.267, 106.35715624999999, 97.188875, 95.970125,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414628,
        longitude: -122.5337932,
        timestamp: '2025-08-29T06:14:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 122.58668030373207,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414628,
        longitude: -122.5337932,
        timestamp: '2025-08-29T06:44:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                119.1243920387803, 114.05913792597164, 112.84209547591284, 114.16329847238762, 113.12598942420898,
                111.41045255581878, 111.49241495299857, 109.91249059929697, 105.75300910693484, 102.99553628084773,
                101.96357021151749, 100.6088772032918, 97.56012940658186, 92.96136692127018, 90.6718729435967,
                89.81088219741568, 90.29136471797976, 92.81126777320905, 96.47902996474866, 100.11247591069481,
                101.33453084606504, 102.51395211516028, 101.66204994124719, 100.86952643948452, 100.2518891010591,
                104.91575881316275, 96.49065232080036, 95.42178113983672,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.9935625, 103.376375, 106.1185625, 110.17325, 110.220125, 108.7904375, 109.2123125, 107.8998125,
                103.751375, 101.0795, 99.1810625, 97.001375, 94.0248125, 89.688875, 88.282625, 88.095125, 89.2904375,
                92.1029375, 95.782625, 99.392, 100.4466875, 101.8295, 101.0795, 100.2591875, 99.2045, 104.032625,
                96.063875, 95.220125,
            ],
            '25th_percentile': [
                112.095125, 107.6185625, 108.532625, 112.23575, 111.720125, 110.2435625, 110.642, 109.23575,
                104.9466875, 102.2045, 100.517, 98.595125, 95.501375, 90.9779375, 89.267, 88.845125, 89.8295, 92.501375,
                96.251375, 99.86075, 101.0795, 102.29825, 101.501375, 100.7045, 99.9310625, 104.642, 96.345125,
                95.36075,
            ],
            '50th_percentile': [
                118.61075, 113.126375, 111.2045, 113.36075, 112.517, 110.970125, 111.251375, 109.751375, 105.532625,
                102.720125, 101.36075, 99.813875, 96.720125, 92.032625, 90.063875, 89.407625, 90.11075, 92.73575,
                96.438875, 100.095125, 101.313875, 102.48575, 101.642, 100.845125, 100.282625, 104.876375, 96.48575,
                95.407625,
            ],
            '75th_percentile': [
                125.2904375, 119.0795, 115.9154375, 115.142, 113.782625, 111.907625, 112.04825, 110.36075, 106.188875,
                103.42325, 102.9545, 102.251375, 99.063875, 94.4466875, 91.7045, 90.392, 90.532625, 93.017, 96.67325,
                100.3295, 101.595125, 102.720125, 101.8295, 101.032625, 100.61075, 105.157625, 96.5795, 95.4779375,
            ],
            '99th_percentile': [
                139.0248125, 132.8841875, 128.267, 124.61075, 122.220125, 118.8216875, 116.595125, 114.5091875,
                111.438875, 109.04825, 108.9310625, 107.782625, 105.9545, 101.7123125, 96.438875, 93.7904375,
                92.6654375, 94.1654375, 97.3529375, 100.98575, 102.251375, 103.3295, 102.3216875, 101.4310625,
                101.2435625, 105.907625, 97.3060625, 95.782625,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414628,
        longitude: -122.5337932,
        timestamp: '2025-08-29T06:44:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 123.67013789317593,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.53365,
        timestamp: '2025-08-29T06:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 129.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.53365,
        timestamp: '2025-08-29T06:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.53365,
        timestamp: '2025-08-29T06:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.53365,
        timestamp: '2025-08-29T06:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.53365,
        timestamp: '2025-08-29T06:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b149048219017c185aa505150719016608011519016711185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.53365,
        timestamp: '2025-08-29T06:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                127.142, 121.142, 118.142, 115.892, 114.392, 112.142, 112.142, 109.892, 106.142, 103.142, 102.392,
                101.642, 98.642, 94.142, 91.142, 89.642, 90.392, 92.642, 96.392, 100.142, 101.642, 102.392, 101.642,
                100.892, 100.142, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                112.142, 107.642, 108.392, 112.142, 111.392, 110.642, 110.642, 109.142, 104.642, 102.392, 100.892,
                98.642, 95.642, 91.142, 89.642, 88.892, 89.642, 92.642, 96.392, 100.142, 100.892, 102.392, 101.642,
                100.892, 100.142, 104.642, 96.392, 95.642,
            ],
            '50th_percentile': [
                118.142, 112.892, 111.392, 113.642, 112.892, 111.392, 111.392, 109.892, 105.392, 102.392, 101.642,
                100.142, 96.392, 91.892, 90.392, 89.642, 90.392, 92.642, 96.392, 100.142, 101.642, 102.392, 101.642,
                100.892, 100.142, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                125.642, 118.892, 115.892, 115.142, 113.642, 112.142, 112.142, 110.642, 106.142, 103.142, 103.142,
                102.392, 98.642, 94.142, 91.892, 90.392, 90.392, 93.392, 96.392, 100.142, 101.642, 102.392, 101.642,
                100.892, 100.892, 105.392, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.53365,
        timestamp: '2025-08-29T07:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 132.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.53365,
        timestamp: '2025-08-29T07:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 10.5,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.53365,
        timestamp: '2025-08-29T07:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.53365,
        timestamp: '2025-08-29T07:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.53365,
        timestamp: '2025-08-29T07:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1500d8219017c185aa60506071901750801151901761118591401',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.53365,
        timestamp: '2025-08-29T07:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.892, 124.142, 119.642, 115.892, 114.392, 112.142, 112.142, 110.642, 106.892, 104.642, 103.142,
                101.642, 100.142, 94.142, 90.392, 89.642, 89.642, 91.142, 94.892, 98.642, 99.392, 100.892, 100.142,
                100.142, 99.392, 103.892, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                111.392, 106.892, 108.392, 112.142, 111.392, 109.892, 110.642, 109.892, 106.142, 103.142, 101.642,
                99.392, 96.392, 91.142, 88.892, 88.892, 88.892, 91.142, 94.892, 97.892, 98.642, 100.142, 100.142,
                99.392, 99.392, 103.142, 96.392, 95.642,
            ],
            '50th_percentile': [
                118.142, 112.142, 110.642, 112.892, 112.142, 110.642, 111.392, 110.642, 106.142, 103.892, 102.392,
                100.892, 97.892, 91.892, 89.642, 88.892, 89.642, 91.142, 94.892, 98.642, 99.392, 100.892, 100.142,
                100.142, 99.392, 103.892, 96.392, 95.642,
            ],
            '75th_percentile': [
                125.642, 119.642, 116.642, 115.142, 113.642, 111.392, 112.142, 111.392, 106.892, 104.642, 103.142,
                102.392, 99.392, 94.142, 91.142, 89.642, 89.642, 91.892, 95.642, 98.642, 100.142, 100.892, 100.892,
                100.142, 99.392, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414813,
        longitude: -122.5337707,
        timestamp: '2025-08-29T07:14:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                119.21125675675917, 113.96445152761679, 112.59450073443223, 113.9969500587566, 112.83923119859203,
                111.19524618096564, 111.58313542890926, 110.58504494712308, 106.5757727673344, 104.07101733255166,
                102.82467112221082, 101.22629421269254, 98.50936192714596, 92.99056051703985, 90.35123913043569,
                89.37661368977757, 89.47835061692211, 91.46527776145808, 94.98024177438428, 98.4140696239732,
                99.4365064629862, 100.7920807873106, 100.43680023501915, 99.82285340775708, 99.3656155992964,
                103.89177967097704, 96.21898663337379, 95.42062441245717,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.688875, 103.3060625, 105.813875, 109.892, 109.563875, 108.4154375, 109.4466875, 108.392, 104.595125,
                102.063875, 100.2123125, 98.267, 95.17325, 90.0873125, 88.3060625, 87.86075, 88.470125, 90.5795,
                94.04825, 97.4466875, 98.220125, 99.813875, 99.67325, 99.0404375, 98.54825, 102.67325, 95.8295,
                95.17325,
            ],
            '25th_percentile': [
                111.345125, 106.79825, 108.0404375, 111.9779375, 111.2045, 109.938875, 110.688875, 109.79825, 105.86075,
                103.282625, 101.54825, 99.5795, 96.48575, 91.188875, 89.17325, 88.563875, 88.98575, 91.142, 94.61075,
                97.98575, 99.017, 100.517, 100.188875, 99.5795, 99.063875, 103.42325, 96.063875, 95.313875,
            ],
            '50th_percentile': [
                118.001375, 112.001375, 110.220125, 112.98575, 112.04825, 110.642, 111.345125, 110.407625, 106.42325,
                103.845125, 102.29825, 100.657625, 97.657625, 92.0795, 89.8295, 89.032625, 89.313875, 91.42325,
                94.938875, 98.4545, 99.48575, 100.79825, 100.42325, 99.813875, 99.29825, 103.845125, 96.157625,
                95.407625,
            ],
            '75th_percentile': [
                125.782625, 119.688875, 116.17325, 114.9545, 113.313875, 111.626375, 112.04825, 111.063875, 107.032625,
                104.4545, 103.42325, 102.2748125, 99.626375, 93.9310625, 91.188875, 89.782625, 89.688875, 91.7045,
                95.313875, 98.782625, 99.86075, 101.126375, 100.657625, 100.04825, 99.626375, 104.17325, 96.251375,
                95.501375,
            ],
            '99th_percentile': [
                142.3998125, 135.8841875, 130.79825, 125.2435625, 123.5795, 119.407625, 117.0404375, 116.3841875,
                111.0404375, 109.7279375, 109.9623125, 108.626375, 110.8998125, 101.5248125, 95.1029375, 93.86075,
                92.4545, 92.73575, 96.1341875, 99.5091875, 100.563875, 101.782625, 101.267, 100.7045, 100.4935625,
                106.9623125, 97.892, 95.9466875,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414813,
        longitude: -122.5337707,
        timestamp: '2025-08-29T07:14:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 123.63096091263799,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414813,
        longitude: -122.5337707,
        timestamp: '2025-08-29T07:44:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                121.0483050176081, 115.48118353873464, 113.41961883803033, 114.18199779929797, 112.79913028169229,
                110.76386399648094, 110.96214744718516, 110.17748635563584, 106.6196078345089, 104.18804973591723,
                102.92490052817068, 101.06558054577623, 98.12120334507183, 92.90734991197291, 90.56926672535305,
                89.64893221831073, 89.73976628521214, 91.61168529929678, 95.0529264964801, 98.62037808098735,
                99.64865713028318, 100.87742033450861, 100.29747975352267, 99.75792209507192, 99.1778714788747,
                103.82933494718482, 96.17924691901538, 95.36157526408574,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.876375, 102.88465624999999, 105.4398125, 109.751375, 109.282625, 107.73575, 108.532625,
                108.08778124999999, 104.5023125, 102.345125, 100.61075, 98.2679375, 95.17325, 90.157625,
                88.54090624999999, 88.23575, 88.77528124999999, 90.907625, 94.376375, 97.91590624999999, 98.8295,
                100.142, 99.767, 99.22840624999999, 98.29090624999999, 103.001375, 95.85340624999999, 95.17325,
            ],
            '25th_percentile': [
                113.0795, 108.1341875, 108.29825, 111.813875, 111.017, 109.282625, 110.032625, 109.42325, 105.907625,
                103.470125, 101.8295, 99.5795, 96.47403125, 91.188875, 89.36075, 88.845125, 89.313875, 91.3295,
                94.79825, 98.407625, 99.438875, 100.657625, 100.095125, 99.5795, 98.8295, 103.563875, 96.063875,
                95.313875,
            ],
            '50th_percentile': [
                120.251375, 114.2279375, 111.767, 112.98575, 111.86075, 110.0795, 110.7123125, 110.032625, 106.517,
                104.0795, 102.438875, 100.3529375, 97.42325, 92.0795, 90.017, 89.220125, 89.595125, 91.517, 95.032625,
                98.595125, 99.626375, 100.845125, 100.282625, 99.720125, 99.157625, 103.79825, 96.157625, 95.36075,
            ],
            '75th_percentile': [
                128.032625, 121.61075, 117.532625, 115.79825, 113.73575, 111.2045, 111.438875, 110.73575, 107.17325,
                104.642, 103.517, 101.8295, 98.970125, 93.907625, 91.15371875, 89.92325, 89.92325, 91.79825, 95.267,
                98.8295, 99.907625, 101.0795, 100.470125, 99.907625, 99.48575, 104.0795, 96.251375, 95.407625,
            ],
            '99th_percentile': [
                142.2816875, 135.08684374999999, 128.9204375, 124.25778125, 122.14840625, 119.171375, 116.6410625,
                113.5004375, 110.05465625, 107.63918749999999, 109.79825, 111.2495, 107.89934375, 102.626375, 97.466375,
                96.1566875, 92.85246875, 93.29825, 96.11075, 99.438875, 100.563875, 101.73575, 100.98575, 100.39934375,
                100.3285625, 104.876375, 96.720125, 95.595125,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414813,
        longitude: -122.5337707,
        timestamp: '2025-08-29T07:44:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 124.55796664835782,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T07:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 132.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T07:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 10.5,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T07:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T07:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T07:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b157148219017c185aa40503071901791519017911185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T07:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.892, 124.142, 118.142, 115.892, 114.392, 111.392, 111.392, 110.642, 106.892, 104.642, 103.142,
                102.392, 99.392, 94.142, 91.142, 89.642, 89.642, 91.892, 94.892, 98.642, 99.392, 100.892, 100.142,
                100.142, 99.392, 103.892, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                112.892, 108.392, 108.392, 112.142, 111.392, 109.142, 109.892, 109.142, 106.142, 103.142, 101.642,
                99.392, 96.392, 91.142, 89.642, 88.892, 89.642, 91.142, 94.892, 98.642, 99.392, 100.892, 100.142,
                99.392, 98.642, 103.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                120.392, 114.392, 111.392, 112.892, 112.142, 109.892, 110.642, 109.892, 106.142, 103.892, 102.392,
                100.142, 97.142, 91.892, 90.392, 89.642, 89.642, 91.892, 94.892, 98.642, 99.392, 100.892, 100.142,
                100.142, 99.392, 103.892, 96.392, 95.642,
            ],
            '75th_percentile': [
                127.892, 121.892, 117.392, 115.892, 113.642, 111.392, 111.392, 110.642, 106.892, 104.642, 103.892,
                101.642, 98.642, 94.142, 91.142, 89.642, 89.642, 91.892, 95.642, 98.642, 100.142, 100.892, 100.142,
                100.142, 99.392, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T08:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 134.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T08:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 11.25,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T08:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T08:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T08:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b15e1d8219017c185aa4051837071901451519014511185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T08:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                133.142, 125.642, 120.392, 116.642, 114.392, 112.892, 112.892, 112.142, 108.392, 106.142, 104.642,
                103.142, 100.142, 94.892, 91.892, 90.392, 90.392, 91.892, 94.892, 98.642, 99.392, 100.892, 100.142,
                99.392, 98.642, 103.892, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                115.142, 109.142, 108.392, 111.392, 111.392, 109.892, 111.392, 110.642, 107.642, 105.392, 103.892,
                101.642, 97.892, 92.642, 90.392, 89.642, 90.392, 91.892, 94.892, 97.892, 99.392, 100.892, 100.142,
                99.392, 98.642, 103.142, 96.392, 95.642,
            ],
            '50th_percentile': [
                121.892, 115.892, 112.892, 112.892, 112.142, 110.642, 112.142, 111.392, 108.392, 105.392, 103.892,
                102.392, 99.392, 93.392, 91.142, 90.392, 90.392, 91.892, 94.892, 98.642, 99.392, 100.892, 100.142,
                99.392, 98.642, 103.892, 96.392, 95.642,
            ],
            '75th_percentile': [
                130.142, 123.392, 118.892, 116.642, 114.392, 112.142, 112.892, 112.142, 108.392, 106.142, 105.392,
                103.142, 100.142, 94.892, 92.642, 91.142, 91.142, 92.642, 95.642, 98.642, 100.142, 100.892, 100.892,
                100.142, 99.392, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414863,
        longitude: -122.533788,
        timestamp: '2025-08-29T08:14:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.84631264845855, 116.82744017221128, 114.16107660332756, 114.44989786223493, 113.08128147268619,
                111.46543007719917, 112.20268141330372, 111.6381772565341, 108.16419418052445, 105.7806394002393,
                104.4098518408568, 102.6926791864624, 99.54904795130783, 94.14678770783956, 91.75911327197242,
                90.5898548099771, 90.69724421021463, 92.19496169833826, 95.1444680819489, 98.53950964964507,
                99.5151999703102, 100.840337292163, 100.30110777909886, 99.72051469715107, 98.9264232482199,
                103.83911252969287, 96.25644106294659, 95.38106992280403,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.88715624999999, 102.64559374999999, 105.36434374999999, 109.62996874999999, 109.282625, 108.3835625,
                109.751375, 109.517, 106.142, 104.14559374999999, 102.45809374999999, 100.30184374999999, 97.2273125,
                91.79825, 89.6804375, 88.751375, 89.36075, 91.282625, 94.25496874999999, 97.563875, 98.56746874999999,
                99.9545, 99.626375, 99.08309374999999, 98.14559374999999, 102.767, 95.876375, 95.17325,
            ],
            '25th_percentile': [
                114.87246875, 109.29434375, 108.532625, 111.73184375, 111.017, 109.845125, 111.251375, 110.92325,
                107.54825, 105.2045, 103.61075, 101.4545, 98.23184375, 92.970125, 90.720125, 89.782625, 90.251375,
                91.892, 94.845125, 98.17325, 99.2045, 100.563875, 100.095125, 99.532625, 98.642, 103.470125, 96.11075,
                95.267,
            ],
            '50th_percentile': [
                122.220125, 116.032625, 112.6810625, 113.0795, 112.04825, 110.73575, 111.907625, 111.532625, 108.017,
                105.67325, 104.220125, 102.2045, 99.157625, 93.67325, 91.42325, 90.345125, 90.5795, 92.126375,
                95.126375, 98.595125, 99.532625, 100.845125, 100.282625, 99.720125, 98.876375, 103.751375, 96.2045,
                95.36075,
            ],
            '75th_percentile': [
                130.1185625, 123.38028125, 118.938875, 116.36075, 114.33340625, 112.13028125, 112.751375, 112.23575,
                108.5795, 106.188875, 105.063875, 103.282625, 100.36465625, 94.751375, 92.501375, 91.142, 91.001375,
                92.407625, 95.407625, 98.876375, 99.813875, 101.126375, 100.517, 99.907625, 99.2045, 104.0795,
                96.345125, 95.407625,
            ],
            '99th_percentile': [
                143.5566875, 137.03871875000002, 131.01715625000003, 125.54825, 123.4941875, 119.78637500000002,
                118.1504375, 115.4785625, 111.7285625, 108.56871875, 108.13840625, 109.04356250000001, 105.27903125,
                100.6191875, 96.35965625000001, 93.767, 92.81028125, 93.70090625, 96.27903125, 99.438875, 100.470125,
                101.73575, 101.06028125, 100.42325, 100.02903125, 106.0566875, 97.487, 96.41965625,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414863,
        longitude: -122.533788,
        timestamp: '2025-08-29T08:14:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.86597018767633,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414863,
        longitude: -122.533788,
        timestamp: '2025-08-29T08:44:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.46867790152655, 116.64364859320276, 114.03744255568802, 113.99628267878298, 112.65559173505491,
                111.14537045721194, 111.8033789566258, 111.23994475381217, 107.84296351113909, 105.71506931418706,
                104.47944871043552, 102.68099838804386, 99.45107458968494, 94.16480553927431, 91.30323241500683,
                90.22977842907477, 90.22016163540536, 92.0622447245028, 95.34915489449129, 98.91973300117378,
                99.87921424384677, 101.14450952520674, 100.40346688159592, 99.76496673505426, 98.87379220398739,
                103.86408382180711, 96.27346614888758, 95.3928975674104,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.925125, 102.67325, 105.041375, 109.21325, 108.91137499999999, 107.876375, 109.21325, 109.1195,
                105.767, 103.8695, 102.345125, 100.04825, 96.907625, 91.1195, 89.057, 88.3295, 89.0795, 91.23575,
                94.58825, 98.220125, 99.063875, 100.42325, 99.86075, 99.2045, 98.103875, 102.885125, 95.876375,
                95.17325,
            ],
            '25th_percentile': [
                114.9545, 109.282625, 108.438875, 111.251375, 110.642, 109.470125, 110.8295, 110.501375, 107.126375,
                105.017, 103.470125, 101.17325, 97.98575, 92.313875, 89.970125, 89.126375, 89.688875, 91.751375,
                95.0795, 98.688875, 99.626375, 100.892, 100.188875, 99.5795, 98.54825, 103.470125, 96.11075, 95.267,
            ],
            '50th_percentile': [
                122.220125, 116.267, 112.79825, 112.7045, 111.5795, 110.313875, 111.48575, 111.063875, 107.688875,
                105.5795, 104.032625, 101.92325, 98.688875, 93.157625, 90.67325, 89.595125, 89.970125, 91.938875,
                95.313875, 98.876375, 99.86075, 101.126375, 100.376375, 99.720125, 98.8295, 103.751375, 96.2045,
                95.36075,
            ],
            '75th_percentile': [
                129.48575, 122.92325, 118.42325, 115.61075, 113.642, 111.813875, 112.282625, 111.720125, 108.29825,
                106.095125, 105.157625, 103.42325, 100.188875, 94.98575, 91.892, 90.86075, 90.48575, 92.220125,
                95.501375, 99.063875, 100.095125, 101.36075, 100.517, 99.86075, 99.11075, 104.032625, 96.29825,
                95.407625,
            ],
            '99th_percentile': [
                145.683875, 140.07575, 133.6895, 127.117625, 124.80950000000001, 121.9145, 119.162, 117.10325,
                113.242625, 110.805125, 109.652, 109.78512500000001, 107.310125, 104.17325, 97.305125, 95.54825,
                93.64137500000001, 93.78762499999999, 96.367625, 99.742625, 100.657625, 101.898875, 100.98575, 100.3295,
                100.023875, 105.857, 97.28075, 96.033875,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414863,
        longitude: -122.533788,
        timestamp: '2025-08-29T08:44:11.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.54603176792382,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T08:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 135.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T08:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 10.5,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T08:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T08:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T08:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b165248219017c185aa50518400719013b08011519013c11185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T08:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                133.892, 127.142, 121.142, 116.642, 114.392, 112.142, 112.142, 111.392, 108.392, 106.142, 104.642,
                103.142, 100.142, 95.642, 92.642, 91.892, 91.892, 93.392, 96.392, 100.142, 100.892, 101.642, 101.642,
                106.142, 103.142, 112.142, 101.642, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                114.392, 109.142, 108.392, 111.392, 110.642, 109.892, 110.642, 110.642, 106.892, 105.392, 103.142,
                100.892, 97.892, 92.642, 89.642, 88.892, 89.642, 91.892, 94.892, 98.642, 99.392, 100.892, 100.142,
                99.392, 98.642, 103.142, 96.392, 95.642,
            ],
            '50th_percentile': [
                121.892, 115.892, 112.892, 112.892, 111.392, 110.642, 111.392, 111.392, 107.642, 105.392, 103.892,
                101.642, 98.642, 93.392, 90.392, 89.642, 89.642, 91.892, 95.642, 98.642, 100.142, 100.892, 100.142,
                99.392, 98.642, 103.892, 96.392, 95.642,
            ],
            '75th_percentile': [
                129.392, 122.642, 118.142, 115.892, 113.642, 112.142, 112.142, 111.392, 108.392, 106.142, 105.392,
                103.892, 100.142, 94.892, 91.892, 91.142, 90.392, 91.892, 95.642, 99.392, 100.142, 101.642, 100.892,
                100.142, 99.392, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T09:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 134.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T09:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 11.25,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T09:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T09:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T09:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b16c2c8219017c185aa40505071901771519017711185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.53375,
        timestamp: '2025-08-29T09:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                133.142, 126.392, 121.142, 116.642, 114.392, 112.142, 111.392, 110.642, 106.892, 105.392, 104.642,
                103.142, 100.142, 94.892, 91.892, 90.392, 90.392, 91.892, 94.892, 98.642, 99.392, 100.892, 100.142,
                100.142, 98.642, 103.892, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                112.892, 107.642, 106.892, 109.892, 109.142, 108.392, 109.892, 109.142, 106.142, 104.642, 103.142,
                100.892, 97.892, 91.892, 89.642, 88.892, 89.642, 91.892, 94.892, 97.892, 99.392, 100.892, 100.142,
                99.392, 98.642, 103.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                120.392, 113.642, 110.642, 111.392, 110.642, 109.142, 110.642, 109.892, 106.892, 104.642, 103.892,
                101.642, 98.642, 92.642, 90.392, 89.642, 89.642, 91.892, 94.892, 98.642, 99.392, 100.892, 100.142,
                100.142, 98.642, 103.892, 96.392, 95.642,
            ],
            '75th_percentile': [
                128.642, 121.142, 117.392, 115.142, 112.892, 110.642, 111.392, 110.642, 106.892, 105.392, 104.642,
                103.142, 99.392, 94.142, 91.142, 90.392, 90.392, 91.892, 94.892, 98.642, 100.142, 101.642, 100.892,
                100.142, 99.392, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415137,
        longitude: -122.5337243,
        timestamp: '2025-08-29T09:14:09.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                121.58739590747578, 115.56887944840079, 112.88260275800923, 112.99731583630104, 111.71995818505545,
                110.20305427046462, 110.83839679715503, 110.12415080071372, 106.86936877224382, 105.0870066725996,
                104.17836565836467, 102.54257829181654, 99.1645756227772, 93.8444021352324, 90.99203336299021,
                89.98536076512538, 90.06988033807913, 91.78968683274115, 94.89733807829296, 98.4810235765138,
                99.60163078291957, 101.02133718861361, 100.45049644128261, 99.85674644128258, 98.95828113879142,
                103.93792971530415, 96.3378963523144, 95.37387277580189,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.36075, 101.8960625, 104.0523125, 107.688875, 107.493875, 106.79825, 108.0366875, 107.767625,
                104.642, 103.376375, 102.017, 100.04825, 96.86075, 91.282625, 88.9585625, 88.376375, 89.072, 91.0210625,
                94.188875, 97.7045, 98.782625, 100.188875, 99.767, 99.2045, 98.1929375, 102.9741875, 95.92325,
                95.1460625,
            ],
            '25th_percentile': [
                112.9623125, 107.407625, 106.938875, 109.98575, 109.376375, 108.438875, 109.7045, 109.23575, 106.142,
                104.407625, 103.142, 101.032625, 97.845125, 92.126375, 89.7591875, 88.98575, 89.595125, 91.517,
                94.657625, 98.17325, 99.345125, 100.751375, 100.23575, 99.67325, 98.688875, 103.657625, 96.2045,
                95.313875,
            ],
            '50th_percentile': [
                120.392, 114.11075, 110.970125, 111.251375, 110.407625, 109.188875, 110.36075, 109.892, 106.657625,
                104.876375, 103.751375, 101.73575, 98.501375, 92.8295, 90.29825, 89.407625, 89.8295, 91.7045, 94.845125,
                98.4545, 99.5795, 101.032625, 100.42325, 99.86075, 98.92325, 103.938875, 96.29825, 95.36075,
            ],
            '75th_percentile': [
                128.6185625, 121.6810625, 117.5795, 115.001375, 112.657625, 110.6654375, 111.2748125, 110.595125,
                107.1966875, 105.438875, 104.782625, 103.42325, 99.767, 94.657625, 91.4935625, 90.345125, 90.251375,
                91.9623125, 95.0795, 98.73575, 99.86075, 101.267, 100.657625, 100.04825, 99.157625, 104.17325, 96.48575,
                95.4545,
            ],
            '99th_percentile': [
                146.0129375, 140.171375, 134.81543750000003, 128.5360625, 125.28200000000001, 122.24731249999999,
                119.43481249999999, 116.61012500000001, 112.758875, 110.15356249999999, 110.56325000000001, 109.80575,
                105.821375, 102.180125, 97.93418750000001, 95.9579375, 93.09106249999999, 93.41918749999999, 95.8295,
                99.392, 100.563875, 102.157625, 101.24731249999999, 100.563875, 100.07543749999999, 105.063875,
                96.93481249999999, 95.595125,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415137,
        longitude: -122.5337243,
        timestamp: '2025-08-29T09:14:09.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 124.63363790905979,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415137,
        longitude: -122.5337243,
        timestamp: '2025-08-29T09:44:09.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.36108362989572, 116.23374822064281, 113.25788078292024, 112.68153514235084, 111.33567215302693,
                109.6432789145927, 109.9581699288276, 109.37876601423682, 106.42691992882743, 104.87020284697681,
                104.450274021354, 103.00521174377386, 99.52283852313312, 94.19821663701177, 91.37337233096177,
                90.2276316725987, 90.26310765124639, 92.00743594306145, 95.13176868327518, 98.73919750889819,
                99.79635943060642, 101.26983585409405, 100.7879630782933, 100.20155293594453, 99.23986476868468,
                104.35758051601593, 96.36975800711868, 95.39066548042823,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                105.0835625, 102.056375, 103.2554375, 106.751375, 106.697, 106.04825, 107.1929375, 107.1929375,
                104.407625, 103.2554375, 102.4585625, 100.4898125, 97.1148125, 91.563875, 89.2866875, 88.61075, 89.267,
                91.3295, 94.376375, 98.0795, 99.063875, 100.563875, 100.1616875, 99.626375, 98.501375, 103.3491875,
                96.017, 95.17325,
            ],
            '25th_percentile': [
                114.5560625, 108.532625, 106.7045, 109.23575, 108.626375, 107.688875, 108.767, 108.532625, 105.626375,
                104.267, 103.563875, 101.642, 98.267, 92.6654375, 90.251375, 89.267, 89.8295, 91.751375, 94.892,
                98.501375, 99.5795, 101.032625, 100.61075, 100.001375, 98.970125, 104.032625, 96.251375, 95.313875,
            ],
            '50th_percentile': [
                122.0795, 115.517, 112.142, 110.92325, 109.892, 108.532625, 109.517, 109.142, 106.23575, 104.688875,
                104.126375, 102.29825, 98.970125, 93.392, 90.86075, 89.73575, 90.063875, 91.938875, 95.126375,
                98.688875, 99.813875, 101.267, 100.79825, 100.188875, 99.2045, 104.36075, 96.345125, 95.36075,
            ],
            '75th_percentile': [
                130.04825, 123.017, 118.3998125, 115.3998125, 113.0795, 110.4545, 110.36075, 109.79825, 106.79825,
                105.2045, 104.970125, 103.6341875, 100.1654375, 94.9623125, 91.9623125, 90.767, 90.48575, 92.17325,
                95.313875, 98.92325, 100.001375, 101.501375, 100.98575, 100.376375, 99.48575, 104.642, 96.48575,
                95.4545,
            ],
            '99th_percentile': [
                146.46012500000003, 139.29106250000004, 132.4735625, 127.33512500000002, 124.52543750000004,
                121.80387500000002, 118.08106250000003, 115.57700000000003, 112.62387500000003, 110.4545, 109.4110625,
                110.56325000000001, 107.34200000000004, 102.4735625, 97.79825, 95.44981250000001, 92.96543750000001,
                93.6141875, 96.23168749999999, 99.626375, 100.657625, 102.11075, 101.4545, 100.82543749999999,
                100.188875, 105.60668749999999, 96.907625, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415137,
        longitude: -122.5337243,
        timestamp: '2025-08-29T09:44:09.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.04080910739404,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.5337333,
        timestamp: '2025-08-29T09:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 134.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.5337333,
        timestamp: '2025-08-29T09:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 11.25,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.5337333,
        timestamp: '2025-08-29T09:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.5337333,
        timestamp: '2025-08-29T09:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.5337333,
        timestamp: '2025-08-29T09:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b173348219017c185aa405181d0719015f1519015f11185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.5337333,
        timestamp: '2025-08-29T09:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                133.142, 126.392, 120.392, 116.642, 114.392, 111.392, 110.642, 109.892, 106.892, 105.392, 104.642,
                103.892, 100.142, 94.892, 91.892, 90.392, 90.392, 91.892, 94.892, 98.642, 100.142, 101.642, 100.892,
                100.142, 99.392, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                114.392, 108.392, 106.892, 109.142, 108.392, 107.642, 109.142, 108.392, 105.392, 104.642, 103.892,
                101.642, 98.642, 92.642, 90.392, 89.642, 89.642, 91.892, 94.892, 98.642, 99.392, 100.892, 100.892,
                100.142, 98.642, 103.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                121.892, 115.142, 112.142, 110.642, 109.892, 108.392, 109.892, 109.142, 106.142, 104.642, 103.892,
                102.392, 99.392, 93.392, 91.142, 89.642, 90.392, 91.892, 94.892, 98.642, 100.142, 101.642, 100.892,
                100.142, 99.392, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                130.142, 123.392, 118.142, 115.142, 112.892, 110.642, 110.642, 109.892, 106.892, 105.392, 104.642,
                103.892, 100.142, 94.892, 91.892, 91.142, 90.392, 91.892, 95.642, 98.642, 100.142, 101.642, 100.892,
                100.142, 99.392, 104.642, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.5337333,
        timestamp: '2025-08-29T10:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 133.142,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.5337333,
        timestamp: '2025-08-29T10:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.5337333,
        timestamp: '2025-08-29T10:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.5337333,
        timestamp: '2025-08-29T10:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.5337333,
        timestamp: '2025-08-29T10:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b17a3c8219017c185aa50518900718d30818191518ec11185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415,
        longitude: -122.5337333,
        timestamp: '2025-08-29T10:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                131.642, 124.892, 119.642, 116.642, 114.392, 112.142, 112.142, 111.392, 109.142, 106.892, 107.642,
                106.892, 102.392, 97.142, 93.392, 91.892, 91.142, 93.392, 96.392, 100.142, 100.892, 102.392, 101.642,
                100.892, 99.392, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                114.392, 110.642, 111.392, 112.142, 110.642, 109.892, 110.642, 110.642, 107.642, 106.142, 106.892,
                105.392, 100.142, 95.642, 91.892, 90.392, 90.392, 92.642, 95.642, 99.392, 100.142, 101.642, 101.642,
                100.892, 99.392, 104.642, 96.392, 95.642,
            ],
            '50th_percentile': [
                121.142, 115.142, 113.642, 113.642, 111.392, 110.642, 111.392, 111.392, 108.392, 106.892, 107.642,
                106.142, 100.892, 96.392, 93.392, 91.142, 91.142, 92.642, 96.392, 100.142, 100.892, 102.392, 101.642,
                100.892, 99.392, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                128.642, 121.892, 118.142, 115.892, 113.642, 112.142, 112.142, 112.142, 109.142, 106.892, 108.392,
                107.642, 102.392, 97.142, 94.142, 91.892, 91.892, 93.392, 96.392, 100.142, 100.892, 102.392, 101.642,
                100.892, 99.392, 105.392, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415003,
        longitude: -122.5337573,
        timestamp: '2025-08-29T10:30:04.000Z',
        sensorPosition: null,
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        units: 'hex',
        value: '626d5f70726f746f636f6c2076302e31332e332c20626f7265616c6973206d6f746520386135343735336463362c206461712036306332393638',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: null,
    },
    {
        latitude: 37.4415027,
        longitude: -122.5337313,
        timestamp: '2025-08-29T10:14:09.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.13026273696933, 117.06154235782219, 115.25652162322497, 114.4169925947889, 112.66989914099736,
                111.29375133294042, 111.50218957346175, 111.17684152843803, 108.5709469786749, 106.75015313981224,
                107.6088431575848, 106.47134686019137, 101.53492061611527, 96.64059300947993, 93.34534715639916,
                91.34577295616207, 91.27412751777342, 93.01155716824748, 96.14846104857942, 99.83631279620998,
                100.72738210900624, 102.19083738151816, 101.5089838566366, 100.78236581753704, 99.52696001184977,
                104.72347585900644, 96.55728436019083, 95.43272867298697,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                108.17871875, 107.5416875, 108.97465625, 109.8385625, 108.78715625, 107.80278125, 108.73371875,
                108.55278125, 106.44340625, 104.66215625, 105.17778125, 103.563875, 98.99028125, 93.83403125,
                91.02153125, 89.61528125, 89.970125, 91.98575, 95.24028125, 98.80278125, 99.64653125, 101.17325,
                100.79825, 100.001375, 98.80278125, 103.61075, 96.157625, 95.220125,
            ],
            '25th_percentile': [
                114.392, 110.876375, 111.532625, 112.142, 110.782625, 109.7045, 110.407625, 110.267, 107.782625,
                106.001375, 106.657625, 105.2045, 100.282625, 95.36075, 92.17325, 90.42715625, 90.720125, 92.595125,
                95.8295, 99.532625, 100.42325, 101.92325, 101.313875, 100.61075, 99.29825, 104.407625, 96.438875,
                95.36075,
            ],
            '50th_percentile': [
                121.0248125, 115.4935625, 113.595125, 113.407625, 111.767, 110.688875, 111.2045, 111.017, 108.345125,
                106.563875, 107.4545, 106.142, 100.98575, 96.11075, 92.970125, 90.9779375, 91.04825, 92.876375,
                96.11075, 99.8841875, 100.751375, 102.2045, 101.54825, 100.79825, 99.48575, 104.73575, 96.532625,
                95.407625,
            ],
            '75th_percentile': [
                128.220125, 121.43496875, 117.767, 115.7045, 113.595125, 112.01309375, 112.095125, 111.813875, 109.142,
                107.220125, 108.157625, 107.267, 102.12246875, 97.188875, 94.142, 91.938875, 91.61075, 93.2045,
                96.438875, 100.142, 101.032625, 102.48575, 101.73575, 100.98575, 99.720125, 105.017, 96.67325,
                95.501375,
            ],
            '99th_percentile': [
                143.55434374999996, 136.36278124999998, 131.09918749999997, 126.33153124999998, 123.27762499999997,
                120.68637499999998, 118.07496875, 116.21965624999997, 113.595125, 111.813875, 112.892,
                112.31590624999998, 108.90715624999997, 103.892, 98.90309375, 96.017, 94.73778124999998, 95.73575,
                97.517, 100.77809375, 101.73575, 103.04825, 102.2045, 101.407625, 100.42325, 106.001375, 97.095125,
                95.688875,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415027,
        longitude: -122.5337313,
        timestamp: '2025-08-29T10:14:09.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.69080044217912,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415027,
        longitude: -122.5337313,
        timestamp: '2025-08-29T10:44:09.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                121.08283629893481, 116.2745066726001, 114.04402402135446, 112.9310903024932, 111.88488256227964,
                110.65267615658563, 111.00120818505539, 110.59395729537566, 107.57288300711929, 106.36152846975268,
                106.83400400356054, 105.85452224199464, 101.55119706405848, 96.37303870106886, 93.04886165480531,
                91.46011610320377, 91.48107918149559, 93.2917442170829, 96.44076556939626, 99.94699332740358,
                100.77806539146057, 102.20077446619375, 101.55286521352467, 100.71161743772392, 99.53229137010818,
                104.5865618327419, 96.44376823843541, 95.40801423487663,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                108.228875, 106.5835625, 107.642, 108.392, 108.2241875, 107.400125, 108.3648125, 108.0835625, 105.48575,
                104.407625, 104.3335625, 102.4585625, 98.032625, 93.063875, 90.626375, 89.4545, 90.345125, 92.4273125,
                95.688875, 98.8023125, 99.720125, 101.3335625, 100.938875, 100.001375, 98.876375, 103.282625, 96.017,
                95.126375,
            ],
            '25th_percentile': [
                113.688875, 110.9935625, 110.54825, 110.73575, 110.17325, 109.3295, 109.98575, 109.7045, 106.892,
                105.626375, 105.767, 104.36075, 99.532625, 94.42325, 91.61075, 90.392, 90.9545, 92.970125, 96.2045,
                99.6498125, 100.470125, 101.92325, 101.36075, 100.517, 99.345125, 104.220125, 96.29825, 95.313875,
            ],
            '50th_percentile': [
                120.11075, 114.86075, 112.563875, 111.9545, 111.157625, 110.0795, 110.782625, 110.501375, 107.501375,
                106.142, 106.563875, 105.438875, 100.517, 95.54825, 92.501375, 91.04825, 91.282625, 93.251375,
                96.438875, 100.04825, 100.845125, 102.251375, 101.54825, 100.7045, 99.532625, 104.595125, 96.438875,
                95.407625,
            ],
            '75th_percentile': [
                127.0248125, 120.3216875, 116.407625, 114.1810625, 112.7748125, 111.29825, 111.626375, 111.251375,
                108.11075, 106.845125, 107.73575, 107.1498125, 102.67325, 97.657625, 94.1185625, 92.407625, 91.79825,
                93.48575, 96.67325, 100.282625, 101.0795, 102.48575, 101.73575, 100.938875, 99.720125, 104.92325,
                96.5795, 95.501375,
            ],
            '99th_percentile': [
                141.61700000000002, 134.78825000000003, 128.59325, 123.99668750000001, 120.767, 118.23575,
                115.95387500000001, 114.720125, 110.9579375, 111.71543750000001, 111.46606249999999, 111.50075000000001,
                114.915125, 105.33575000000002, 98.57543749999999, 95.67200000000001, 93.98168749999999, 94.845125,
                97.45043749999999, 100.892, 101.71606249999999, 103.02856249999999, 102.157625, 101.34106249999999,
                100.26293749999999, 106.02856249999999, 97.095125, 95.73575,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415027,
        longitude: -122.5337313,
        timestamp: '2025-08-29T10:44:09.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 124.76519388793952,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5337333,
        timestamp: '2025-08-29T10:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 131.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5337333,
        timestamp: '2025-08-29T10:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5337333,
        timestamp: '2025-08-29T10:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5337333,
        timestamp: '2025-08-29T10:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5337333,
        timestamp: '2025-08-29T10:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b181458219017c185aa605183c071901370809151901401118591401',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5337333,
        timestamp: '2025-08-29T10:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.142, 123.392, 118.142, 115.142, 112.892, 111.392, 111.392, 110.642, 107.642, 106.892, 106.892,
                106.892, 104.642, 97.892, 93.392, 91.892, 91.892, 93.392, 96.392, 100.142, 100.892, 102.392, 101.642,
                100.892, 99.392, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                113.642, 110.642, 110.642, 110.642, 109.892, 109.142, 109.892, 109.892, 106.892, 105.392, 106.142,
                104.642, 99.392, 94.142, 91.892, 90.392, 91.142, 92.642, 96.392, 99.392, 100.142, 101.642, 101.642,
                100.892, 99.392, 103.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                120.392, 115.142, 112.892, 112.142, 111.392, 109.892, 110.642, 110.642, 107.642, 106.142, 106.892,
                105.392, 100.892, 95.642, 92.642, 91.142, 91.142, 93.392, 96.392, 100.142, 100.892, 102.392, 101.642,
                100.892, 99.392, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                127.142, 120.392, 116.642, 114.392, 112.892, 111.392, 111.392, 111.392, 108.392, 106.892, 107.642,
                106.892, 102.392, 97.892, 94.142, 92.642, 91.892, 93.392, 96.392, 100.142, 100.892, 102.392, 101.642,
                100.892, 99.392, 104.642, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5337333,
        timestamp: '2025-08-29T11:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 131.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5337333,
        timestamp: '2025-08-29T11:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5337333,
        timestamp: '2025-08-29T11:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5337333,
        timestamp: '2025-08-29T11:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5337333,
        timestamp: '2025-08-29T11:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1884c8219017c185aa6051835071901460801151901471118591401',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5337333,
        timestamp: '2025-08-29T11:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.142, 123.392, 118.142, 114.392, 112.892, 110.642, 109.892, 109.892, 106.892, 106.142, 106.892,
                106.892, 103.892, 97.142, 94.892, 93.392, 93.392, 94.892, 97.142, 100.892, 101.642, 103.142, 101.642,
                100.892, 100.142, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                112.892, 108.392, 107.642, 108.392, 107.642, 107.642, 108.392, 108.392, 105.392, 103.892, 103.892,
                103.142, 99.392, 94.142, 91.892, 91.142, 91.892, 94.142, 97.142, 100.892, 100.892, 102.392, 101.642,
                100.892, 99.392, 104.642, 96.392, 95.642,
            ],
            '50th_percentile': [
                119.642, 113.642, 110.642, 109.892, 109.142, 108.392, 109.142, 109.142, 106.142, 104.642, 104.642,
                103.892, 100.142, 94.892, 92.642, 91.142, 91.892, 94.142, 97.142, 100.892, 101.642, 103.142, 102.392,
                100.892, 99.392, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                126.392, 119.642, 115.892, 113.642, 112.142, 109.892, 110.642, 109.892, 106.892, 105.392, 106.142,
                105.392, 102.392, 97.142, 94.142, 92.642, 92.642, 94.142, 97.142, 100.892, 101.642, 103.142, 102.392,
                100.892, 100.142, 105.392, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415503,
        longitude: -122.5336215,
        timestamp: '2025-08-29T11:14:10.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                120.44626170023938, 114.8756900177747, 112.3131159656419, 111.50724363151863, 110.34836478080769,
                109.07202073459908, 109.62357953199249, 109.26901792061804, 106.22130983412501, 105.11669268365102,
                105.26798119076005, 104.50648459715812, 101.16941780213423, 95.81261611374529, 93.33012944312901,
                92.23312114929008, 92.55585885663606, 94.46823667061724, 97.32933338270273, 100.7956952014233,
                101.55930228080723, 102.8713579680111, 101.99478436019115, 101.03051451421952, 99.77377577014363,
                104.74558042061784, 96.56622615521452, 95.40868024289219,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                106.29621875, 104.0795, 104.74934375, 106.06840625, 105.720125, 105.2916875, 106.7045, 106.188875,
                103.376375, 102.83403125, 102.61325, 100.938875, 97.7045, 92.220125, 90.017, 89.7760625, 91.04825,
                93.157625, 96.45903125, 99.626375, 100.3295, 101.782625, 101.24028125, 100.23575, 98.970125, 103.470125,
                96.157625, 95.17325,
            ],
            '25th_percentile': [
                113.0091875, 108.11075, 107.313875, 108.5795, 107.970125, 107.267, 108.38028125, 108.017, 105.157625,
                104.06778125, 104.0795, 102.67325, 99.157625, 93.86075, 91.470125, 90.720125, 91.657625, 93.813875,
                97.001375, 100.517, 101.17325, 102.626375, 101.782625, 100.845125, 99.48575, 104.4545, 96.438875,
                95.313875,
            ],
            '50th_percentile': [
                119.4310625, 113.54825, 110.6185625, 110.126375, 109.23575, 108.29825, 109.3060625, 109.04825,
                105.86075, 104.688875, 104.876375, 103.7045, 100.142, 95.0795, 92.501375, 91.470125, 92.032625,
                94.0716875, 97.23575, 100.845125, 101.642, 102.907625, 102.017, 101.0795, 99.720125, 104.782625,
                96.532625, 95.407625,
            ],
            '75th_percentile': [
                126.345125, 119.93496875, 115.85684375, 113.313875, 111.767, 109.845125, 110.36075, 110.126375,
                106.751375, 105.438875, 105.86075, 105.392, 101.970125, 97.15371875, 94.23575, 92.92325, 92.8295,
                94.470125, 97.470125, 101.0795, 101.970125, 103.188875, 102.2045, 101.220125, 100.001375, 105.063875,
                96.67325, 95.4545,
            ],
            '99th_percentile': [
                143.03215624999999, 136.18840624999999, 131.01106249999992, 125.18590624999996, 122.09168749999995,
                118.96512499999997, 116.73481249999995, 116.0795, 114.438875, 114.64559374999996, 111.75340624999998,
                116.61434374999996, 114.65309375, 105.017, 104.92934374999997, 101.4610625, 99.37184375, 101.642,
                99.86028124999997, 102.19090624999998, 102.720125, 103.7045, 102.65309375, 101.642, 100.82496875,
                105.8673125, 97.21559375, 95.80934375,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415503,
        longitude: -122.5336215,
        timestamp: '2025-08-29T11:14:10.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 123.76791782774484,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415503,
        longitude: -122.5336215,
        timestamp: '2025-08-29T11:44:10.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                117.76050192535776, 112.06296786137646, 109.62030272512042, 109.24063744076022, 108.17739691943318,
                106.88328036137624, 107.8408299763052, 107.00057893957529, 104.43733841824815, 104.08572037914861,
                104.79562114929082, 103.73465773104432, 101.03551303317688, 96.24932005331877, 93.60987988744182,
                92.3545851599536, 92.70775829383987, 94.66312337085422, 97.64451777251317, 100.94937188981194,
                101.71053524881671, 102.90112692535706, 102.11025014810583, 101.13581664692094, 100.17943335308203,
                104.93352473341405, 96.39544342417187, 95.42350918246564,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.80278125, 101.126375, 101.74934375, 102.9545, 102.532625, 102.11075, 104.220125, 103.57746875,
                101.42778125, 101.61528125, 101.80278125, 100.1354375, 97.142, 91.98575, 90.08403125, 90.11075, 91.517,
                93.74028125, 96.92778125, 100.188875, 100.77153125, 102.251375, 101.52153125, 100.61075, 99.48575,
                103.938875, 96.063875, 95.220125,
            ],
            '25th_percentile': [
                110.688875, 105.438875, 104.595125, 106.095125, 105.5795, 104.8295, 106.23575, 105.626375, 103.282625,
                102.98965625, 103.3295, 101.73575, 98.595125, 93.767, 91.470125, 90.9545, 92.0795, 94.282625, 97.42325,
                100.751375, 101.4545, 102.720125, 101.92325, 100.98575, 99.9545, 104.595125, 96.251375, 95.36075,
            ],
            '50th_percentile': [
                116.6185625, 110.6654375, 108.0873125, 108.063875, 107.313875, 106.376375, 107.501375, 106.845125,
                104.17325, 103.61075, 104.267, 102.9545, 99.9545, 95.1966875, 92.8295, 91.7045, 92.407625, 94.517,
                97.61075, 100.938875, 101.688875, 102.907625, 102.11075, 101.126375, 100.188875, 104.92325, 96.392,
                95.407625,
            ],
            '75th_percentile': [
                123.86075, 117.345125, 113.55996875, 111.12246875, 109.61075, 108.2045, 109.142, 108.157625, 105.29825,
                104.54825, 105.67325, 104.92325, 102.345125, 97.85684375, 94.845125, 93.21621875, 93.017, 94.845125,
                97.79825, 101.126375, 101.970125, 103.095125, 102.29825, 101.313875, 100.376375, 105.2045, 96.48575,
                95.501375,
            ],
            '99th_percentile': [
                140.88246874999996, 132.79278124999996, 126.45856249999997, 122.91574999999996, 119.72824999999996,
                117.27809375, 113.82246874999998, 112.40965624999998, 110.58809374999998, 115.07496875,
                112.85824999999998, 113.07153124999994, 117.52465624999994, 109.05434374999997, 103.83153124999998,
                99.79324999999997, 96.6329375, 97.73121875, 98.48121875, 101.688875, 102.532625, 103.61075, 102.67325,
                101.71559375, 101.01246875, 106.095125, 97.04825, 95.71559375,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415503,
        longitude: -122.5336215,
        timestamp: '2025-08-29T11:44:10.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 121.53241847752275,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415167,
        longitude: -122.5336333,
        timestamp: '2025-08-29T11:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 129.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415167,
        longitude: -122.5336333,
        timestamp: '2025-08-29T11:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415167,
        longitude: -122.5336333,
        timestamp: '2025-08-29T11:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415167,
        longitude: -122.5336333,
        timestamp: '2025-08-29T11:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415167,
        longitude: -122.5336333,
        timestamp: '2025-08-29T11:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b18f548219017c185aa50518230719015608031519015911185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415167,
        longitude: -122.5336333,
        timestamp: '2025-08-29T11:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                127.892, 121.142, 115.892, 112.892, 110.642, 108.392, 108.392, 107.642, 104.642, 105.392, 106.142,
                105.392, 104.642, 99.392, 95.642, 93.392, 92.642, 94.892, 97.892, 100.892, 101.642, 103.142, 102.392,
                100.892, 100.142, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                110.642, 105.392, 104.642, 106.142, 105.392, 104.642, 106.142, 105.392, 103.142, 103.142, 103.142,
                101.642, 98.642, 94.142, 91.892, 91.142, 91.892, 94.142, 97.142, 100.892, 101.642, 102.392, 101.642,
                100.892, 100.142, 104.642, 96.392, 95.642,
            ],
            '50th_percentile': [
                116.642, 110.642, 108.392, 108.392, 107.642, 106.142, 107.642, 106.892, 103.892, 103.892, 104.642,
                103.142, 100.142, 95.642, 92.642, 91.892, 92.642, 94.892, 97.892, 100.892, 101.642, 103.142, 102.392,
                100.892, 100.142, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                124.142, 117.392, 113.642, 111.392, 109.892, 108.392, 109.142, 108.392, 105.392, 104.642, 105.392,
                104.642, 102.392, 97.892, 94.892, 93.392, 93.392, 94.892, 97.892, 100.892, 101.642, 103.142, 102.392,
                101.642, 100.142, 105.392, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415167,
        longitude: -122.5336333,
        timestamp: '2025-08-29T12:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 128.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415167,
        longitude: -122.5336333,
        timestamp: '2025-08-29T12:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 8.25,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415167,
        longitude: -122.5336333,
        timestamp: '2025-08-29T12:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415167,
        longitude: -122.5336333,
        timestamp: '2025-08-29T12:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415167,
        longitude: -122.5336333,
        timestamp: '2025-08-29T12:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1965c8219017c185aa50518690718d908183a1519011311185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415167,
        longitude: -122.5336333,
        timestamp: '2025-08-29T12:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                127.142, 120.392, 115.892, 112.142, 112.142, 114.392, 109.142, 108.392, 108.392, 106.892, 106.142,
                105.392, 103.142, 99.392, 98.642, 99.392, 100.142, 100.142, 103.892, 106.142, 103.892, 104.642, 103.892,
                102.392, 100.892, 106.142, 97.142, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                109.892, 104.642, 104.642, 106.142, 108.392, 109.892, 106.892, 106.142, 106.142, 105.392, 104.642,
                103.142, 100.892, 97.142, 94.892, 94.142, 94.142, 95.642, 99.392, 102.392, 102.392, 103.892, 102.392,
                101.642, 100.892, 105.392, 96.392, 95.642,
            ],
            '50th_percentile': [
                115.142, 109.142, 106.892, 108.392, 109.892, 112.142, 107.642, 107.642, 107.642, 106.892, 105.392,
                104.642, 102.392, 98.642, 98.642, 99.392, 99.392, 100.142, 103.142, 104.642, 103.892, 104.642, 103.142,
                102.392, 100.892, 105.392, 96.392, 95.642,
            ],
            '75th_percentile': [
                121.142, 115.142, 112.142, 110.642, 112.142, 115.142, 109.892, 109.142, 109.142, 107.642, 106.892,
                106.142, 103.892, 100.142, 100.142, 101.642, 101.642, 101.642, 106.142, 107.642, 104.642, 105.392,
                103.892, 103.142, 101.642, 106.142, 97.142, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415305,
        longitude: -122.5332783,
        timestamp: '2025-08-29T12:14:10.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                116.43644979265629, 110.84810559834325, 108.99154457938582, 109.05036048578393, 110.3554182464475,
                112.41541898696893, 108.28486507701611, 107.81989173578386, 107.74730213270327, 106.65262648104445,
                105.8358684834141, 104.69776125592587, 102.32202073459874, 98.34236655805823, 97.53716069312927,
                98.24128539692076, 98.34758723341365, 99.1800072571104, 102.91240136256084, 105.13118838862731,
                103.76070556872203, 104.48965625000169, 103.44657642180259, 102.31052414099685, 101.02190595379298,
                105.75228213862735, 96.77777458530933, 95.50570704976423,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.876375, 101.19340625, 101.220125, 103.376375, 104.89653125, 105.9948125, 104.80278125, 104.09965625,
                102.813875, 102.813875, 102.6666875, 101.28715625, 98.220125, 93.27153125, 91.376375, 91.23575,
                92.407625, 94.657625, 97.79825, 101.17325, 101.782625, 102.9545, 102.157625, 101.14653125, 99.86075,
                104.782625, 96.251375, 95.220125,
            ],
            '25th_percentile': [
                109.55215625, 104.72403125, 104.407625, 106.31778125, 108.23965625, 109.7045, 106.751375, 106.376375,
                106.04825, 105.33340625, 104.782625, 103.282625, 100.98575, 96.86075, 95.25528125, 94.3295, 94.470125,
                96.017, 99.438875, 102.11075, 102.626375, 103.657625, 102.720125, 101.688875, 100.61075, 105.392,
                96.532625, 95.407625,
            ],
            '50th_percentile': [
                114.9545, 109.142, 107.17325, 108.157625, 109.938875, 112.142, 108.017, 107.501375, 107.876375,
                106.61075, 105.532625, 104.4545, 102.017, 98.4779375, 98.17325, 99.345125, 99.2045, 99.767, 103.04825,
                104.782625, 103.79825, 104.407625, 103.376375, 102.157625, 100.938875, 105.720125, 96.6966875,
                95.501375,
            ],
            '75th_percentile': [
                121.38809375, 115.13028125, 112.38809375, 110.60684375, 111.9545, 114.68496875, 109.48184375,
                109.001375, 109.470125, 107.93496875, 106.7045, 105.720125, 103.43496875, 99.767, 99.9545, 101.501375,
                101.595125, 101.54825, 105.87246875, 107.688875, 104.688875, 105.157625, 103.98575, 102.813875,
                101.407625, 106.04825, 96.9545, 95.595125,
            ],
            '99th_percentile': [
                139.60934374999994, 133.04731249999995, 127.64403124999998, 123.09715624999998, 120.8673125, 120.9545,
                114.76559374999994, 112.9454375, 112.45653124999998, 112.25496874999996, 110.7423125, 110.52809375,
                108.93434375, 104.78871874999997, 102.907625, 104.032625, 104.43434375, 104.1798125, 109.188875,
                111.80028124999998, 106.5235625, 107.01246875, 106.16871875, 104.44090624999998, 103.02809375,
                107.57496875, 97.938875, 95.90309375,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415305,
        longitude: -122.5332783,
        timestamp: '2025-08-29T12:14:10.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 121.92832957081633,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415305,
        longitude: -122.5332783,
        timestamp: '2025-08-29T12:44:10.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                116.84187056213244, 110.75161538461741, 107.7934423076942, 107.5027618343214, 106.29937795858172,
                105.18214423077099, 106.84612352071191, 105.89547633136274, 105.26995857988344, 103.92661538461708,
                104.69874926035676, 103.93038757396617, 100.92439644970564, 96.72644896449832, 94.89327588757514,
                93.42184467455729, 94.15858653846266, 96.30690384615511, 98.64965532544518, 101.29717751479446,
                101.84098298816727, 103.09418195266436, 102.19262869822646, 100.86376405325596, 100.3092522189364,
                104.59584615384789, 96.51165606509002, 95.57337943787104,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                104.47512499999999, 100.91262499999999, 100.77199999999999, 101.19387499999999, 100.95949999999999,
                100.7045, 103.42325, 103.142, 101.14699999999999, 101.36075, 101.8295, 100.23575, 97.35012499999999,
                92.92325, 91.42325, 90.9545, 92.126375, 94.25637499999999, 97.16262499999999, 99.31887499999999,
                99.813875, 101.8295, 100.91262499999999, 99.11075, 99.251375, 102.78762499999999, 95.89699999999999,
                95.220125,
            ],
            '25th_percentile': [
                110.595125, 105.017, 103.282625, 104.595125, 103.98575, 103.282625, 105.48575, 104.73575, 103.142,
                102.720125, 103.376375, 102.157625, 99.251375, 94.938875, 93.29825, 92.220125, 93.063875, 95.0795,
                98.032625, 100.376375, 100.7045, 102.5795, 101.73575, 100.188875, 99.9545, 103.845125, 96.2045,
                95.36075,
            ],
            '50th_percentile': [
                116.17325, 109.376375, 106.188875, 106.61075, 105.626375, 104.782625, 106.42325, 105.626375, 104.313875,
                103.470125, 104.267, 103.470125, 100.517, 96.438875, 94.517, 93.157625, 93.626375, 95.642, 98.501375,
                101.501375, 101.8295, 103.04825, 102.2045, 101.0795, 100.282625, 104.642, 96.392, 95.501375,
            ],
            '75th_percentile': [
                122.0795, 115.23575, 111.157625, 109.42325, 107.73575, 106.61075, 107.8295, 106.7045, 106.751375,
                104.642, 105.67325, 105.11075, 102.157625, 98.126375, 96.345125, 94.42325, 94.845125, 97.04825, 99.017,
                102.017, 102.67325, 103.470125, 102.532625, 101.4545, 100.563875, 105.2045, 96.720125, 95.688875,
            ],
            '99th_percentile': [
                136.08012499999998, 130.095125, 124.42887499999999, 120.54574999999997, 118.08012499999998,
                115.34074999999999, 113.73199999999997, 111.465125, 116.96074999999999, 111.2045, 111.25699999999999,
                112.43074999999996, 107.67949999999999, 103.17387499999998, 100.262, 97.8245, 98.55387499999999,
                101.36637499999999, 101.340125, 103.563875, 104.996375, 105.251375, 104.1995, 102.67887499999999,
                101.876375, 106.23575, 97.61075, 96.11075,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4415305,
        longitude: -122.5332783,
        timestamp: '2025-08-29T12:44:10.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 120.63017758052791,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5331167,
        timestamp: '2025-08-29T12:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 127.142,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5331167,
        timestamp: '2025-08-29T12:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 8.25,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5331167,
        timestamp: '2025-08-29T12:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5331167,
        timestamp: '2025-08-29T12:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5331167,
        timestamp: '2025-08-29T12:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b19d648219017c185aa405020719017a1519017a11185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5331167,
        timestamp: '2025-08-29T12:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                124.892, 118.142, 112.892, 110.642, 108.392, 106.892, 107.642, 106.142, 106.892, 104.642, 105.392,
                104.642, 101.642, 97.892, 95.642, 94.142, 94.892, 97.142, 98.642, 101.642, 102.392, 103.142, 102.392,
                102.392, 100.892, 113.642, 98.642, 96.392,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                110.642, 105.392, 103.142, 104.642, 103.892, 103.142, 105.392, 104.642, 103.142, 102.392, 103.142,
                102.392, 99.392, 94.892, 93.392, 92.642, 93.392, 94.892, 97.892, 100.142, 100.892, 102.392, 101.642,
                100.142, 100.142, 103.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                115.892, 109.142, 106.142, 106.892, 105.392, 104.642, 106.142, 105.392, 104.642, 103.142, 104.642,
                103.142, 100.892, 96.392, 94.892, 93.392, 93.392, 95.642, 98.642, 101.642, 101.642, 103.142, 102.392,
                100.892, 100.142, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                121.892, 115.142, 111.392, 109.892, 107.642, 106.892, 107.642, 106.892, 106.892, 104.642, 105.392,
                105.392, 102.392, 97.892, 96.392, 94.142, 94.892, 97.142, 99.392, 102.392, 102.392, 103.142, 102.392,
                101.642, 100.892, 105.392, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5331167,
        timestamp: '2025-08-29T13:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5331167,
        timestamp: '2025-08-29T13:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 6.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5331167,
        timestamp: '2025-08-29T13:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5331167,
        timestamp: '2025-08-29T13:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5331167,
        timestamp: '2025-08-29T13:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1a46c8219017c185aa6051876071870081896151901061118591401',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414833,
        longitude: -122.5331167,
        timestamp: '2025-08-29T13:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                121.892, 115.142, 111.392, 108.392, 108.392, 107.642, 112.142, 117.392, 108.392, 108.392, 107.642,
                105.392, 105.392, 101.642, 101.642, 101.642, 100.892, 101.642, 104.642, 108.392, 104.642, 104.642,
                103.892, 102.392, 101.642, 105.392, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                109.142, 103.892, 102.392, 103.142, 104.642, 103.892, 106.892, 113.642, 106.142, 106.142, 106.142,
                103.892, 103.142, 99.392, 98.642, 99.392, 98.642, 99.392, 102.392, 103.142, 102.392, 103.142, 102.392,
                101.642, 100.892, 104.642, 96.392, 95.642,
            ],
            '50th_percentile': [
                112.142, 106.142, 104.642, 105.392, 106.892, 106.142, 108.392, 115.892, 107.642, 107.642, 107.642,
                105.392, 104.642, 100.892, 101.642, 101.642, 100.142, 100.892, 103.892, 105.392, 103.892, 104.642,
                103.142, 102.392, 101.642, 105.392, 96.392, 95.642,
            ],
            '75th_percentile': [
                118.142, 111.392, 109.142, 107.642, 108.392, 109.142, 112.142, 118.892, 109.142, 109.892, 109.142,
                106.892, 106.142, 102.392, 103.142, 103.142, 102.392, 102.392, 105.392, 109.142, 105.392, 105.392,
                104.642, 102.392, 101.642, 105.392, 97.142, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414028,
        longitude: -122.5329933,
        timestamp: '2025-08-29T13:14:10.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                114.22108653846371, 108.49218491124452, 106.2653727810669, 105.87356434911422, 106.82276923077106,
                106.53985502958754, 109.83380843195467, 116.15949260355256, 107.96213683432143, 107.91936686390723,
                107.61093491124447, 105.3382463017769, 104.47275073964668, 100.87347189349265, 101.0819408284039,
                101.1250436390548, 100.0639489644985, 100.90309467455772, 103.7345110946762, 106.29604955621481,
                104.08244008875906, 104.60999186390704, 103.64048372781231, 102.23573150887731, 101.57559837278261,
                105.34412647929169, 96.54388609467581, 95.56356065088879,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                105.2045, 100.61075, 99.5795, 99.532625, 100.95949999999999, 100.657625, 104.99074999999999, 108.5945,
                103.72512499999999, 103.792625, 104.12075, 101.66262499999999, 99.032, 95.70949999999999,
                94.53762499999999, 93.80825, 93.532625, 95.52199999999999, 98.4545, 100.61075, 100.845125,
                102.17824999999999, 101.75637499999999, 100.657625, 100.25637499999999, 103.79825, 95.92325, 95.267,
            ],
            '25th_percentile': [
                108.813875, 103.61075, 102.251375, 103.04825, 104.688875, 103.938875, 106.98575, 113.595125, 106.3295,
                106.04825, 106.470125, 104.0795, 103.04825, 99.532625, 99.017, 99.532625, 98.688875, 99.438875,
                102.345125, 103.142, 102.438875, 103.001375, 102.438875, 101.36075, 100.845125, 104.782625, 96.2045,
                95.4545,
            ],
            '50th_percentile': [
                112.282625, 106.376375, 104.642, 105.017, 106.61075, 106.188875, 108.48575, 116.032625, 107.782625,
                107.73575, 107.54825, 105.29825, 104.54825, 100.892, 101.54825, 101.595125, 100.470125, 101.220125,
                103.938875, 105.48575, 104.17325, 104.407625, 103.42325, 102.063875, 101.407625, 105.2045, 96.392,
                95.54825,
            ],
            '75th_percentile': [
                118.04825, 111.626375, 109.095125, 107.688875, 108.5795, 108.9545, 112.23575, 118.42325, 109.376375,
                109.657625, 108.767, 106.517, 105.9545, 102.392, 103.23575, 103.470125, 102.251375, 102.67325,
                105.67325, 108.86075, 105.345125, 105.813875, 104.4545, 102.767, 101.970125, 105.67325, 96.86075,
                95.688875,
            ],
            '99th_percentile': [
                133.78324999999998, 126.76887499999998, 122.69449999999999, 118.72137499999998, 116.67012499999997,
                114.54387499999999, 119.90824999999998, 124.52262499999999, 113.37762499999998, 113.17887499999999,
                111.21012499999999, 109.517, 109.470125, 104.85575, 106.38199999999999, 106.52262499999999, 105.23075,
                106.121375, 109.121375, 115.938875, 108.392, 108.840125, 108.12762499999998, 106.0745, 105.137,
                108.67887499999999, 97.777625, 96.063875,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414028,
        longitude: -122.5329933,
        timestamp: '2025-08-29T13:14:10.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 121.87680629559571,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414028,
        longitude: -122.5329933,
        timestamp: '2025-08-29T13:44:10.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                112.71657890071131, 106.94618882978907, 104.27520035461163, 102.86008510638462, 102.05944237588812,
                101.06082757092354, 103.22189804964705, 102.45150797872503, 99.60299290780287, 99.27115558510782,
                99.44940248227094, 98.67973271276736, 97.0260314716325, 95.09839406028487, 94.25021143617134,
                94.08232579787345, 95.72860239361825, 97.44519148936303, 100.74710859929229, 103.24295301418606,
                103.5531258865265, 105.0222637411365, 104.83437588652656, 103.76938253546268, 103.07268484042719,
                107.33941799645578, 96.97117774822824, 95.65762500000122,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                102.71074999999999, 98.7779375, 97.61075, 96.532625, 96.5795, 96.5279375, 99.08496875, 99.29825,
                96.78809375, 96.251375, 95.642, 94.77246875, 93.626375, 92.782625, 92.38184375, 92.8295, 94.7045,
                96.64746875, 100.04825, 102.13184375, 102.48575, 104.33496875, 104.17325, 103.04825, 102.532625,
                105.97559375, 96.22559375, 95.313875,
            ],
            '25th_percentile': [
                107.46621875, 101.876375, 100.05996875, 99.48575, 99.532625, 98.8295, 101.54825, 101.032625, 98.267,
                97.845125, 97.61075, 96.54434375, 95.032625, 93.96621875, 93.392, 93.532625, 95.36075, 97.142,
                100.563875, 102.767, 103.001375, 104.782625, 104.595125, 103.563875, 102.907625, 106.563875, 96.532625,
                95.501375,
            ],
            '50th_percentile': [
                110.876375, 104.9466875, 102.345125, 101.5716875, 101.1498125, 100.1654375, 102.767, 101.970125,
                99.1341875, 98.688875, 98.688875, 97.98575, 96.251375, 94.657625, 93.9545, 93.907625, 95.642, 97.42325,
                100.751375, 103.282625, 103.7045, 104.970125, 104.782625, 103.79825, 103.04825, 107.501375, 96.767,
                95.595125,
            ],
            '75th_percentile': [
                116.8295, 110.67715625, 107.2904375, 105.063875, 103.845125, 102.47403125, 104.267, 103.23575,
                100.188875, 100.001375, 100.73965625, 99.94278125, 98.36075, 95.63028125, 94.83340625, 94.376375,
                96.017, 97.657625, 100.938875, 103.751375, 104.032625, 105.2045, 105.11075, 103.98575, 103.23575,
                108.017, 97.42325, 95.8295,
            ],
            '99th_percentile': [
                131.92793749999998, 125.02559374999998, 120.81856249999998, 117.27481249999997, 114.35449999999999,
                111.720125, 111.33809374999998, 115.10449999999999, 107.37012499999999, 109.15606249999999,
                108.83262499999998, 107.64668749999998, 106.40215624999999, 102.70371875, 98.74043749999998,
                97.63653124999999, 97.40215624999999, 99.11543749999998, 101.407625, 104.267, 104.595125, 105.907625,
                105.532625, 104.36075, 103.7045, 108.74590624999999, 98.313875, 96.18340624999999,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4414028,
        longitude: -122.5329933,
        timestamp: '2025-08-29T13:44:10.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 118.0024105074709,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44125,
        longitude: -122.5329333,
        timestamp: '2025-08-29T13:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 121.892,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44125,
        longitude: -122.5329333,
        timestamp: '2025-08-29T13:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 6.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44125,
        longitude: -122.5329333,
        timestamp: '2025-08-29T13:44:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44125,
        longitude: -122.5329333,
        timestamp: '2025-08-29T13:44:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44125,
        longitude: -122.5329333,
        timestamp: '2025-08-29T13:44:00.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1ab748219017c185aa705181e0719015e1519015e111854130314031603',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44125,
        longitude: -122.5329333,
        timestamp: '2025-08-29T13:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                118.892, 112.892, 109.142, 106.142, 103.892, 102.392, 103.892, 103.892, 100.892, 100.142, 100.892,
                100.142, 98.642, 95.642, 94.142, 94.142, 95.642, 97.142, 100.892, 103.142, 103.892, 105.392, 104.642,
                103.892, 103.142, 107.642, 97.142, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                107.642, 101.642, 100.142, 99.392, 99.392, 98.642, 101.642, 100.892, 98.642, 97.892, 97.892, 96.392,
                94.892, 94.142, 93.392, 93.392, 95.642, 97.142, 100.892, 103.142, 103.142, 104.642, 104.642, 103.892,
                103.142, 106.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                110.642, 104.642, 102.392, 101.642, 100.892, 100.142, 103.142, 101.642, 99.392, 98.642, 98.642, 97.892,
                96.392, 94.892, 94.142, 94.142, 95.642, 97.142, 100.892, 103.142, 103.892, 104.642, 104.642, 103.892,
                103.142, 107.642, 97.142, 95.642,
            ],
            '75th_percentile': [
                116.642, 110.642, 106.892, 105.392, 103.892, 102.392, 104.642, 103.142, 100.142, 100.142, 100.892,
                100.142, 98.642, 95.642, 94.892, 94.142, 96.392, 97.892, 100.892, 103.892, 103.892, 105.392, 105.392,
                103.892, 103.142, 108.392, 97.142, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44125,
        longitude: -122.5329333,
        timestamp: '2025-08-29T14:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 129.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44125,
        longitude: -122.5329333,
        timestamp: '2025-08-29T14:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44125,
        longitude: -122.5329333,
        timestamp: '2025-08-29T14:14:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 36,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44125,
        longitude: -122.5329333,
        timestamp: '2025-08-29T14:14:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44125,
        longitude: -122.5329333,
        timestamp: '2025-08-29T14:14:00.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1b27d8219017c185aa805189f07100818cd1518dd111857130114021601',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44125,
        longitude: -122.5329333,
        timestamp: '2025-08-29T14:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                118.142, 112.142, 113.642, 115.142, 112.892, 117.392, 116.642, 115.892, 113.642, 112.892, 112.142,
                112.142, 112.142, 112.892, 114.392, 115.142, 115.142, 115.892, 115.892, 118.142, 118.892, 117.392,
                114.392, 115.142, 114.392, 118.892, 106.892, 100.142,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                109.142, 104.642, 106.892, 108.392, 107.642, 109.892, 109.142, 108.392, 105.392, 105.392, 106.142,
                106.142, 103.142, 102.392, 102.392, 102.392, 102.392, 104.642, 106.142, 108.392, 106.142, 106.142,
                106.142, 104.642, 103.892, 108.392, 97.142, 95.642,
            ],
            '50th_percentile': [
                112.142, 106.892, 109.892, 111.392, 109.892, 112.142, 112.892, 111.392, 108.392, 107.642, 107.642,
                108.392, 106.142, 105.392, 105.392, 106.142, 106.142, 106.892, 108.392, 111.392, 110.642, 109.142,
                107.642, 106.892, 105.392, 109.892, 97.142, 95.642,
            ],
            '75th_percentile': [
                115.892, 110.642, 113.642, 115.892, 113.642, 115.892, 115.892, 116.642, 113.642, 112.892, 112.142,
                112.142, 110.642, 111.392, 112.892, 113.642, 112.892, 113.642, 115.142, 118.142, 118.892, 115.892,
                113.642, 113.642, 112.142, 117.392, 103.892, 97.142,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410038,
        longitude: -122.532852,
        timestamp: '2025-08-29T14:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                113.1650399408305, 108.21376405325628, 110.63889349112618, 112.51117529585997, 111.03513979290135,
                113.60211464497243, 113.34921153846354, 112.60531360946942, 110.1725843195285, 109.41215532544562,
                109.38636020710243, 109.3348809171616, 107.7012455621319, 107.72892677514965, 108.08096079881828,
                108.43654511834491, 108.35560946745733, 109.49364571006093, 110.75355695266457, 113.16675961538657,
                112.76563165680668, 111.66448520710247, 110.3134312130196, 109.9099178994101, 108.87639349112602,
                113.59945192307889, 101.43835724852208, 97.79575369822608,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                105.67325, 101.261375, 101.85012499999999, 104.05324999999999, 104.642, 106.25637499999999, 105.05825,
                104.126375, 102.55324999999999, 102.828875, 103.188875, 101.703875, 99.9545, 99.392, 98.636375,
                98.38137499999999, 98.313875, 99.532625, 102.11075, 103.72512499999999, 103.79825, 104.0795, 104.032625,
                103.58449999999999, 102.45949999999999, 107.642, 96.29825, 95.313875,
            ],
            '25th_percentile': [
                109.23575, 104.642, 106.563875, 108.5795, 107.970125, 109.892, 109.61075, 108.2045, 105.767, 105.157625,
                105.86075, 105.907625, 103.517, 102.48575, 102.345125, 102.813875, 102.5795, 104.688875, 106.376375,
                108.5795, 106.657625, 106.563875, 106.001375, 104.970125, 103.79825, 108.532625, 96.813875, 95.501375,
            ],
            '50th_percentile': [
                111.9545, 107.032625, 109.938875, 111.720125, 109.98575, 112.282625, 112.61075, 111.345125, 108.9545,
                108.017, 107.876375, 108.2045, 105.907625, 105.626375, 105.720125, 106.001375, 106.142, 107.220125,
                108.626375, 111.767, 110.642, 109.42325, 107.970125, 106.98575, 105.813875, 109.79825, 97.470125,
                95.688875,
            ],
            '75th_percentile': [
                116.267, 111.017, 114.063875, 115.892, 114.11075, 116.220125, 116.17325, 116.8295, 113.782625, 113.0795,
                112.7045, 112.517, 111.67325, 112.3295, 113.313875, 114.251375, 113.782625, 115.23575, 115.751375,
                118.517, 118.563875, 116.126375, 114.157625, 114.345125, 113.92325, 118.98575, 106.001375, 98.54825,
            ],
            '99th_percentile': [
                129.86075, 123.32262499999996, 122.41887499999999, 123.67325, 119.69449999999999, 127.470125,
                126.37699999999998, 123.6995, 123.21012499999999, 120.6995, 119.9495, 119.9495, 120.438875, 121.965125,
                123.29825, 124.262, 124.683875, 125.012, 124.4495, 127.04825, 128.17325, 126.76324999999997,
                123.49324999999996, 123.70512499999998, 122.73762499999998, 128.058875, 115.496375, 108.14449999999997,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410038,
        longitude: -122.532852,
        timestamp: '2025-08-29T14:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.17143394365128,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410038,
        longitude: -122.532852,
        timestamp: '2025-08-29T14:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                120.57501726682649, 115.08704501180857, 114.3344439197188, 113.54448671782977, 112.75856951003753,
                113.84792901416982, 116.34243167060438, 118.18793417945922, 116.00163326446503, 112.10796443329606,
                111.03321531877421, 109.83665761511416, 108.45248922668434, 108.0554076151141, 107.57182585596416,
                107.87554486422862, 108.96357615112358, 110.29754899646012, 109.82121708973048, 110.74399601535038,
                110.50253719008472, 110.5745929752087, 109.6851855076762, 109.33459149941172, 108.8039687131071,
                113.43291646989597, 102.17278881346094, 98.47265230224464,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                106.8666875, 103.0229375, 103.091375, 104.3354375, 104.732, 106.22449999999999, 107.782625, 110.267,
                107.6598125, 104.126375, 104.0504375, 101.8941875, 100.04825, 100.23575, 98.6166875, 97.845125,
                98.591375, 99.720125, 101.17325, 103.188875, 103.61075, 104.0795, 103.79825, 102.907625, 101.7573125,
                105.8354375, 96.11075, 95.267,
            ],
            '25th_percentile': [
                114.438875, 108.813875, 109.61075, 109.4466875, 109.1654375, 110.126375, 112.3529375, 113.8295,
                111.9310625, 108.532625, 106.845125, 105.767, 104.54825, 103.001375, 101.642, 101.8998125, 102.2045,
                103.79825, 103.751375, 104.7591875, 104.782625, 104.970125, 104.782625, 104.2435625, 103.095125,
                108.345125, 97.001375, 95.54825,
            ],
            '50th_percentile': [
                120.063875, 114.251375, 113.876375, 112.892, 112.3295, 113.4545, 115.7045, 117.767, 116.220125,
                111.345125, 109.938875, 108.9545, 107.501375, 106.42325, 106.282625, 106.563875, 107.73575, 109.42325,
                108.345125, 109.188875, 108.251375, 108.5795, 107.501375, 107.54825, 106.517, 111.392, 99.438875,
                96.251375,
            ],
            '75th_percentile': [
                126.67325, 121.095125, 118.6810625, 117.29825, 116.032625, 116.7123125, 119.642, 121.657625, 119.220125,
                115.282625, 114.720125, 113.220125, 111.7435625, 112.2591875, 112.188875, 113.032625, 115.188875,
                115.9623125, 114.907625, 115.9154375, 115.7748125, 115.8685625, 114.29825, 114.0873125, 114.0873125,
                118.188875, 106.8685625, 100.376375,
            ],
            '99th_percentile': [
                137.27075, 131.2491875, 129.3273125, 126.16512499999999, 123.94137499999997, 124.40543749999999,
                128.23137499999999, 129.8898125, 125.595125, 124.9641875, 121.59293749999999, 120.9545, 121.0266875,
                122.45824999999999, 121.98575, 122.53043749999999, 123.626375, 124.42325, 124.188875, 123.5795,
                123.3704375, 123.5795, 122.57731249999999, 122.5266875, 123.32731249999999, 129.2335625,
                120.25512499999999, 112.9641875,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4410038,
        longitude: -122.532852,
        timestamp: '2025-08-29T14:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 127.5162737017247,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5328833,
        timestamp: '2025-08-29T14:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 132.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5328833,
        timestamp: '2025-08-29T14:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5328833,
        timestamp: '2025-08-29T14:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 32,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5328833,
        timestamp: '2025-08-29T14:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5328833,
        timestamp: '2025-08-29T14:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                127.142, 121.892, 119.642, 117.392, 115.142, 116.642, 119.642, 121.142, 118.142, 115.142, 114.392,
                112.892, 112.142, 112.892, 112.892, 113.642, 115.142, 115.892, 115.142, 115.892, 115.142, 115.142,
                114.392, 113.642, 114.392, 118.892, 109.142, 102.392,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                114.392, 109.142, 109.892, 109.142, 109.142, 110.642, 112.142, 113.642, 112.142, 108.392, 106.892,
                106.142, 104.642, 103.142, 101.642, 102.392, 102.392, 104.642, 103.892, 104.642, 104.642, 105.392,
                104.642, 104.642, 103.142, 108.392, 97.142, 95.642,
            ],
            '50th_percentile': [
                120.392, 114.392, 113.642, 112.892, 112.142, 113.642, 115.892, 118.142, 116.642, 111.392, 109.892,
                109.142, 107.642, 106.892, 106.892, 106.892, 108.392, 109.892, 108.392, 109.892, 108.392, 109.142,
                107.642, 107.642, 106.892, 111.392, 99.392, 96.392,
            ],
            '75th_percentile': [
                126.392, 121.142, 118.892, 117.392, 115.892, 116.642, 119.642, 121.892, 119.642, 115.142, 115.142,
                113.642, 112.142, 112.142, 112.142, 112.892, 115.142, 115.892, 115.142, 116.642, 115.892, 115.892,
                114.392, 114.392, 114.392, 118.142, 106.892, 100.142,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5328833,
        timestamp: '2025-08-29T15:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 131.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5328833,
        timestamp: '2025-08-29T15:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5328833,
        timestamp: '2025-08-29T15:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 17,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5328833,
        timestamp: '2025-08-29T15:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5328833,
        timestamp: '2025-08-29T15:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1c08d8219017c185aa405182e0719014e1519014e11185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5328833,
        timestamp: '2025-08-29T15:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.142, 124.142, 121.142, 117.392, 115.142, 112.142, 110.642, 108.392, 109.142, 107.642, 103.142,
                101.642, 100.892, 99.392, 99.392, 99.392, 100.142, 100.142, 101.642, 103.142, 103.142, 103.892, 103.892,
                102.392, 101.642, 106.142, 97.142, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                117.392, 110.642, 107.642, 106.142, 103.142, 102.392, 105.392, 104.642, 106.142, 104.642, 100.892,
                98.642, 98.642, 97.892, 97.142, 96.392, 97.892, 98.642, 100.142, 102.392, 103.142, 103.892, 103.142,
                102.392, 100.892, 105.392, 96.392, 95.642,
            ],
            '50th_percentile': [
                123.392, 117.392, 113.642, 109.892, 106.892, 104.642, 106.892, 106.892, 108.392, 106.892, 103.142,
                100.892, 100.142, 99.392, 98.642, 97.892, 99.392, 99.392, 100.892, 102.392, 103.142, 103.892, 103.142,
                102.392, 101.642, 106.142, 96.392, 95.642,
            ],
            '75th_percentile': [
                129.392, 123.392, 119.642, 115.892, 112.892, 109.892, 109.892, 109.142, 110.642, 108.392, 103.892,
                102.392, 101.642, 100.892, 100.142, 100.142, 100.892, 100.892, 101.642, 103.142, 103.142, 103.892,
                103.892, 103.142, 101.642, 106.142, 97.142, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408422,
        longitude: -122.5329268,
        timestamp: '2025-08-29T15:14:09.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                123.14749734356808, 117.21794819953007, 114.0456120129892, 111.62731582054518, 108.64817989964776,
                106.60261466942333, 107.80581345926994, 107.24917975206802, 108.32398420897479, 106.69586658795937,
                102.61342488193789, 100.76509991145373, 100.13098686540884, 99.33195351239816, 98.70852154663662,
                98.4855470779235, 99.35171074380312, 99.9171438902022, 101.08442547225657, 102.69975900236291,
                103.24366396104061, 103.9470656729651, 103.50155947461796, 102.63251800472418, 101.39821679457063,
                105.76412219598762, 96.82472210743931, 95.46224793388551,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                107.8979375, 103.3041875, 101.497625, 101.3823125, 99.153875, 98.688875, 101.54825, 101.7573125,
                103.091375, 102.345125, 98.54825, 96.7595, 96.017, 95.501375, 94.9135625, 95.2416875, 95.8979375,
                97.04825, 99.11075, 101.407625, 102.438875, 103.142, 102.767, 101.92325, 100.5385625, 104.2885625,
                96.2045, 95.17325,
            ],
            '25th_percentile': [
                117.29825, 110.92325, 107.5248125, 106.2591875, 103.3295, 102.3216875, 104.876375, 104.8529375,
                106.095125, 104.73575, 100.98575, 98.92325, 98.4545, 97.938875, 97.3295, 96.720125, 97.7045, 98.782625,
                100.04825, 102.11075, 102.907625, 103.61075, 103.188875, 102.392, 101.0795, 105.392, 96.532625,
                95.313875,
            ],
            '50th_percentile': [
                123.11075, 117.11075, 113.688875, 110.126375, 106.845125, 104.688875, 107.0795, 107.032625, 108.251375,
                106.751375, 102.767, 100.61075, 100.188875, 99.2045, 98.4545, 98.0795, 99.251375, 99.720125, 100.938875,
                102.48575, 103.188875, 103.845125, 103.42325, 102.5795, 101.313875, 105.720125, 96.720125, 95.407625,
            ],
            '75th_percentile': [
                129.11075, 123.1341875, 119.7591875, 116.220125, 113.1498125, 110.032625, 109.9154375, 109.188875,
                110.36075, 108.48575, 104.0560625, 102.2045, 101.642, 100.7045, 99.7904375, 99.86075, 100.7045,
                100.98575, 101.8529375, 103.188875, 103.4935625, 104.126375, 103.7045, 102.813875, 101.595125,
                106.095125, 97.001375, 95.501375,
            ],
            '99th_percentile': [
                141.13606249999998, 135.08918749999998, 131.5773125, 128.598875, 125.51262499999999, 122.75074999999998,
                119.45543749999997, 116.83324999999999, 114.53637499999999, 111.8860625, 106.80199999999999, 107.313875,
                104.95231249999999, 103.657625, 103.92106249999999, 103.66137499999999, 104.06543749999999, 103.6360625,
                104.57731249999999, 105.7454375, 104.54825, 105.7923125, 105.11075, 103.7045, 102.88981249999999,
                107.642, 98.5266875, 96.46793749999999,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408422,
        longitude: -122.5329268,
        timestamp: '2025-08-29T15:14:09.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.55999607806214,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408422,
        longitude: -122.5329268,
        timestamp: '2025-08-29T15:44:09.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.4302333431629, 116.54592836085133, 113.4483089622663, 109.99514711085106, 107.68047287736037,
                106.8365570459924, 106.0262497051905, 105.70077800707728, 105.82128213443578, 105.33594899764331,
                102.45324705188843, 100.35581191037889, 99.09505129717125, 97.79051120283155, 97.24177520636925,
                97.17063354952963, 96.30217467570881, 97.42861188089756, 98.96371285377501, 101.20497906839779,
                102.55351975236012, 103.14006530070921, 102.52151429835068, 101.64951768868082, 100.32900250589773,
                104.57367747641682, 96.44434743514279, 95.36793602594462,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                106.79543749999999, 102.55184374999999, 101.54543749999999, 99.22371874999999, 98.032625, 99.32028125,
                100.142, 100.892, 101.47653125, 100.72371874999999, 98.99215625, 96.64840625, 96.13278125, 95.313875,
                95.17325, 95.267, 94.63278125, 96.32028125, 98.220125, 100.470125, 101.73575, 102.48575, 101.92325,
                100.938875, 99.55465625, 103.07028125, 95.92325, 95.126375,
            ],
            '25th_percentile': [
                116.1029375, 110.16153125, 107.16153125, 103.83340625, 101.92325, 102.80215625, 103.08340625,
                103.69278125, 103.79825, 103.657625, 100.98575, 99.017, 97.938875, 96.907625, 96.345125, 96.345125,
                95.642, 97.001375, 98.73575, 100.938875, 102.345125, 102.9545, 102.345125, 101.4545, 100.142, 104.17325,
                96.2045, 95.267,
            ],
            '50th_percentile': [
                122.17325, 116.0795, 112.470125, 108.6498125, 105.86075, 105.017, 104.8295, 104.9935625, 105.345125,
                105.063875, 102.063875, 100.142, 98.876375, 97.657625, 97.188875, 97.04825, 96.2045, 97.376375,
                98.92325, 101.17325, 102.532625, 103.142, 102.48575, 101.642, 100.3295, 104.54825, 96.345125, 95.36075,
            ],
            '75th_percentile': [
                128.267, 122.688875, 118.95059375, 115.20059375, 112.517, 109.85684375, 107.970125, 106.80996875,
                106.938875, 106.48184375, 103.563875, 101.41934375, 99.91934375, 98.54825, 97.98575, 97.892, 96.907625,
                97.79825, 99.157625, 101.407625, 102.77871875, 103.3295, 102.720125, 101.876375, 100.517, 104.92325,
                96.5795, 95.407625,
            ],
            '99th_percentile': [
                142.241375, 135.65403125, 132.0666875, 127.7073125, 126.64043749999999, 124.02434374999996,
                119.84356249999999, 117.13559375, 116.47699999999998, 115.11762499999998, 109.68059374999996,
                107.10996875, 105.33762499999996, 101.1760625, 99.97934375, 100.0510625, 98.90121875, 99.157625,
                99.907625, 102.08871875, 103.30746875, 103.845125, 103.26059375, 102.48575, 101.17325, 106.8948125,
                98.66684375, 96.36996875,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408422,
        longitude: -122.5329268,
        timestamp: '2025-08-29T15:44:09.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 124.74409525684173,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5329167,
        timestamp: '2025-08-29T15:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 131.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5329167,
        timestamp: '2025-08-29T15:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5329167,
        timestamp: '2025-08-29T15:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 16,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5329167,
        timestamp: '2025-08-29T15:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5329167,
        timestamp: '2025-08-29T15:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1c7948219017c185aa405010719017b1519017b11185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5329167,
        timestamp: '2025-08-29T15:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.142, 124.142, 120.392, 116.642, 114.392, 112.142, 109.142, 107.642, 107.642, 106.892, 103.142,
                100.892, 100.142, 97.892, 97.142, 97.142, 96.392, 97.142, 98.642, 100.892, 102.392, 103.142, 102.392,
                101.642, 100.142, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                116.642, 110.642, 106.892, 103.892, 101.642, 103.142, 103.142, 103.892, 103.892, 103.892, 100.892,
                99.392, 97.892, 97.142, 96.392, 96.392, 95.642, 97.142, 98.642, 100.892, 102.392, 103.142, 102.392,
                101.642, 100.142, 103.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                122.642, 116.642, 112.892, 109.142, 106.142, 105.392, 104.642, 105.392, 105.392, 105.392, 102.392,
                100.142, 98.642, 97.892, 97.142, 97.142, 96.392, 97.142, 98.642, 100.892, 102.392, 103.142, 102.392,
                101.642, 100.142, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                128.642, 122.642, 118.892, 115.142, 112.892, 109.892, 107.642, 106.892, 106.892, 106.892, 103.892,
                101.642, 100.142, 98.642, 97.892, 97.892, 97.142, 97.892, 99.392, 101.642, 103.142, 103.142, 102.392,
                101.642, 100.892, 104.642, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5329167,
        timestamp: '2025-08-29T16:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 132.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5329167,
        timestamp: '2025-08-29T16:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5329167,
        timestamp: '2025-08-29T16:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 17,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5329167,
        timestamp: '2025-08-29T16:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5329167,
        timestamp: '2025-08-29T16:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1ce9d8219017c185aa40509071901731519017311185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408833,
        longitude: -122.5329167,
        timestamp: '2025-08-29T16:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.142, 124.892, 121.892, 118.142, 115.142, 112.892, 109.892, 107.642, 104.642, 103.142, 101.642,
                101.642, 97.892, 94.892, 94.892, 94.142, 94.892, 96.392, 98.642, 101.642, 103.142, 103.142, 103.142,
                102.392, 100.892, 106.142, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                116.642, 110.642, 107.642, 103.892, 102.392, 100.142, 99.392, 98.642, 97.142, 97.142, 95.642, 94.892,
                94.142, 93.392, 92.642, 93.392, 94.142, 96.392, 98.642, 100.892, 103.142, 103.142, 102.392, 102.392,
                100.892, 105.392, 96.392, 94.892,
            ],
            '50th_percentile': [
                121.892, 116.642, 112.892, 109.142, 106.892, 104.642, 102.392, 100.892, 99.392, 98.642, 97.142, 96.392,
                94.892, 94.142, 94.142, 94.142, 94.142, 96.392, 98.642, 101.642, 103.142, 103.142, 103.142, 102.392,
                100.892, 106.142, 96.392, 95.642,
            ],
            '75th_percentile': [
                128.642, 123.392, 120.392, 116.642, 114.392, 110.642, 107.642, 105.392, 102.392, 100.892, 98.642,
                99.392, 96.392, 94.892, 94.892, 94.142, 94.892, 96.392, 98.642, 101.642, 103.142, 103.892, 103.142,
                102.392, 100.892, 106.142, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4409728,
        longitude: -122.5328313,
        timestamp: '2025-08-29T16:30:03.000Z',
        sensorPosition: null,
        bristlemouth_node_id: '0x9397191e2e5bab8c',
        units: 'hex',
        value: '626d5f70726f746f636f6c2076302e31332e332c20626f7265616c6973206d6f746520386135343735336463362c206461712036306332393638',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: null,
    },
    {
        latitude: 37.4408212,
        longitude: -122.5329512,
        timestamp: '2025-08-29T16:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.759574439861, 117.10019206957777, 113.9959946933984, 110.66599027122844, 108.34208475825663,
                106.07599911556784, 104.17114946934132, 102.54953979952992, 100.82926046580343, 99.65699852594487,
                97.86325589622777, 97.88658284198249, 95.91053626179368, 94.47056721698227, 94.22231765919925,
                94.0940194575483, 94.67934890919928, 96.31157178655788, 98.7005937500014, 101.33841804245439,
                103.16930689858657, 103.37007340802055, 102.8877252358507, 102.31151650943558, 100.89813576061475,
                105.86356913325652, 96.28548098467108, 95.30193514151065,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                108.48575, 103.58309374999999, 101.21731249999999, 98.68606249999999, 97.49215625, 96.88278125,
                95.99215625, 95.49856249999999, 95.35793749999999, 94.77059374999999, 94.02340625, 92.87356249999999,
                92.17325, 92.00778125, 91.91403125, 92.642, 93.626375, 95.54825, 98.032625, 100.7045,
                102.48293749999999, 102.767, 102.345125, 101.73575, 100.23575, 104.501375, 95.8295, 95.0795,
            ],
            '25th_percentile': [
                116.72403125, 110.91153125, 107.4545, 104.16153125, 102.2045, 100.470125, 99.251375, 98.4545, 97.517,
                97.04825, 95.688875, 94.73965625, 93.813875, 93.157625, 92.970125, 93.392, 94.188875, 96.017, 98.501375,
                101.126375, 102.9545, 103.142, 102.720125, 102.11075, 100.7045, 105.438875, 96.063875, 95.220125,
            ],
            '50th_percentile': [
                122.1498125, 116.267, 112.892, 109.3529375, 106.7045, 104.2904375, 102.48575, 101.126375, 99.48575,
                98.4545, 96.86075, 96.392, 94.845125, 94.04825, 93.7904375, 93.86075, 94.517, 96.251375, 98.688875,
                101.36075, 103.142, 103.3295, 102.86075, 102.29825, 100.892, 105.813875, 96.2045, 95.267,
            ],
            '75th_percentile': [
                128.46621875, 123.07559375, 120.2045, 116.79434375, 113.970125, 110.4779375, 107.88809375, 105.26309375,
                102.86075, 100.938875, 98.84121875, 99.54434375, 96.720125, 95.220125, 94.79825, 94.517, 94.892,
                96.48575, 98.876375, 101.501375, 103.376375, 103.563875, 103.04825, 102.48575, 101.0795, 106.23575,
                96.438875, 95.36075,
            ],
            '99th_percentile': [
                140.7966875, 135.89121874999998, 133.2854375, 128.49340625, 126.3010625, 124.43168749999998,
                121.17246875, 119.28106249999999, 115.52590624999996, 114.08871875, 111.0198125, 113.36637499999999,
                107.12403124999997, 102.03106249999999, 102.14403124999998, 98.01059375, 97.80949999999999, 97.86996875,
                99.4885625, 102.017, 103.96371875, 104.126375, 103.563875, 103.001375, 101.688875, 107.501375,
                97.26059375, 95.66684375,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408212,
        longitude: -122.5329512,
        timestamp: '2025-08-29T16:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 124.95867818692689,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408212,
        longitude: -122.5329512,
        timestamp: '2025-08-29T16:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                123.19996727594595, 117.11063944575702, 113.4912040094361, 110.3888307783039, 108.06166391509622,
                105.7378689563697, 104.69407104953004, 107.53990315448311, 103.00933490566207, 99.13844383844483,
                98.52254613797312, 96.58851017099185, 94.93799056603892, 94.57741789504833, 94.35968130896342,
                94.56945798938796, 94.69432900943512, 96.10041317806729, 98.41232355542591, 100.64424793632227,
                102.03656810141669, 102.75975869693559, 102.20919855542614, 101.33731250000156, 100.20391037735997,
                104.4807013561338, 96.45131235259562, 95.3928107311333,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                109.11153125, 103.67684374999999, 101.0795, 99.50778125, 97.98293749999999, 97.46731249999999,
                96.20168749999999, 95.45168749999999, 95.17325, 94.63278125, 94.3295, 93.41403125, 92.73575,
                92.57028125, 92.54825, 93.063875, 93.438875, 94.938875, 97.04825, 99.5795, 100.657625, 101.71090625,
                101.407625, 100.23575, 99.46090625, 102.48575, 95.8295, 95.126375,
            ],
            '25th_percentile': [
                117.345125, 111.19278125, 107.34903125, 104.1966875, 102.626375, 101.032625, 99.9545, 100.23575,
                98.220125, 96.767, 96.29825, 94.97403125, 93.9545, 93.5795, 93.626375, 93.86075, 94.095125, 95.595125,
                97.892, 100.188875, 101.54825, 102.392, 101.970125, 101.032625, 99.9545, 103.892, 96.063875, 95.267,
            ],
            '50th_percentile': [
                122.9466875, 117.0404375, 113.17325, 109.3529375, 106.3998125, 104.17325, 103.04825, 107.54825,
                100.938875, 98.3373125, 98.0795, 96.11075, 94.657625, 94.3295, 94.142, 94.3295, 94.517, 96.017,
                98.313875, 100.657625, 102.11075, 102.767, 102.2045, 101.407625, 100.188875, 104.54825, 96.251375,
                95.36075,
            ],
            '75th_percentile': [
                128.88809375, 122.7591875, 118.80996875, 115.62246875, 112.71621875, 109.66934375, 108.5560625,
                113.8998125, 107.032625, 100.938875, 100.38809375, 97.57559375, 95.642, 95.313875, 94.892, 95.0795,
                95.0795, 96.438875, 98.73575, 100.98575, 102.48575, 103.095125, 102.48575, 101.688875, 100.42325,
                105.017, 96.73184375, 95.501375,
            ],
            '99th_percentile': [
                139.4841875, 133.59434374999998, 130.02621875, 126.59637499999998, 124.21371875, 121.50903124999998,
                118.892, 124.3791875, 118.7541875, 110.25340624999998, 106.66324999999999, 106.28637499999995,
                100.17528124999998, 98.43528124999999, 98.2229375, 97.47574999999999, 97.30746875, 98.267, 101.407625,
                102.3948125, 103.16684375, 104.032625, 103.001375, 102.251375, 101.01059375, 106.42325, 97.751375,
                95.90121875,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4408212,
        longitude: -122.5329512,
        timestamp: '2025-08-29T16:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.20144499457291,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407667,
        longitude: -122.533,
        timestamp: '2025-08-29T16:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 131.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407667,
        longitude: -122.533,
        timestamp: '2025-08-29T16:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407667,
        longitude: -122.533,
        timestamp: '2025-08-29T16:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 23,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407667,
        longitude: -122.533,
        timestamp: '2025-08-29T16:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407667,
        longitude: -122.533,
        timestamp: '2025-08-29T16:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1d5a48219017c185aa50518530719012808011519012911185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407667,
        longitude: -122.533,
        timestamp: '2025-08-29T16:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                129.392, 123.392, 120.392, 116.642, 114.392, 111.392, 109.892, 114.392, 108.392, 100.892, 100.142,
                97.892, 94.892, 94.892, 94.892, 94.892, 94.892, 96.392, 98.642, 100.892, 102.392, 103.142, 102.392,
                101.642, 100.142, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                117.392, 111.392, 107.642, 103.892, 102.392, 100.892, 100.142, 100.142, 98.642, 97.142, 96.392, 94.892,
                94.142, 93.392, 93.392, 94.142, 94.142, 95.642, 97.892, 100.142, 101.642, 102.392, 101.642, 100.892,
                100.142, 103.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                122.642, 117.392, 112.892, 109.142, 106.142, 103.892, 103.142, 107.642, 100.892, 98.642, 97.892, 96.392,
                94.892, 94.142, 94.142, 94.142, 94.892, 96.392, 98.642, 100.892, 102.392, 102.392, 102.392, 101.642,
                100.142, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                128.642, 122.642, 118.892, 115.892, 112.892, 109.892, 108.392, 114.392, 106.892, 100.892, 100.142,
                97.892, 95.642, 95.642, 94.892, 94.892, 94.892, 96.392, 98.642, 100.892, 102.392, 103.142, 102.392,
                101.642, 100.142, 105.392, 97.142, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407667,
        longitude: -122.533,
        timestamp: '2025-08-29T17:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 132.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407667,
        longitude: -122.533,
        timestamp: '2025-08-29T17:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407667,
        longitude: -122.533,
        timestamp: '2025-08-29T17:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 18,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407667,
        longitude: -122.533,
        timestamp: '2025-08-29T17:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407667,
        longitude: -122.533,
        timestamp: '2025-08-29T17:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1dcad8219017c185aa40507071901751519017511185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407667,
        longitude: -122.533,
        timestamp: '2025-08-29T17:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.142, 124.142, 121.142, 118.142, 115.892, 113.642, 112.142, 109.142, 107.642, 107.642, 103.142,
                103.142, 102.392, 99.392, 97.892, 97.892, 97.142, 97.892, 99.392, 101.642, 103.142, 103.142, 102.392,
                101.642, 100.142, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                117.392, 111.392, 107.642, 105.392, 104.642, 104.642, 103.892, 103.892, 103.892, 103.142, 99.392,
                97.892, 97.142, 97.142, 96.392, 96.392, 96.392, 97.142, 98.642, 100.892, 103.142, 103.142, 102.392,
                101.642, 100.142, 104.642, 96.392, 94.892,
            ],
            '50th_percentile': [
                122.642, 116.642, 113.642, 110.642, 108.392, 107.642, 106.892, 106.892, 105.392, 105.392, 101.642,
                99.392, 97.892, 97.892, 97.142, 97.892, 97.142, 97.892, 99.392, 101.642, 103.142, 103.142, 102.392,
                101.642, 100.142, 104.642, 96.392, 95.642,
            ],
            '75th_percentile': [
                129.392, 123.392, 120.392, 117.392, 114.392, 112.142, 112.142, 109.892, 107.642, 107.642, 103.142,
                101.642, 99.392, 100.142, 98.642, 98.642, 97.892, 97.892, 99.392, 101.642, 103.892, 103.892, 102.392,
                101.642, 100.892, 105.392, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407607,
        longitude: -122.5329643,
        timestamp: '2025-08-29T17:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                123.08460392099312, 117.22876665684194, 114.22760583726634, 111.54539401533228, 109.84932606132276,
                108.75329127358685, 108.30062691627552, 107.06971594929433, 106.13884920401125, 105.64726975236033,
                101.62950737028461, 100.31662043042604, 98.8148515625014, 98.4265297759448, 97.51943219339756,
                97.7430281544825, 97.02636025943528, 97.7869734669825, 99.06984492924673, 101.37644870283175,
                103.30274587264317, 103.30860524764317, 102.49509183372804, 101.76001665684122, 100.43032547169962,
                104.86028935731306, 96.39758298938807, 95.31525692806726,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                107.75496874999999, 102.03903125, 100.470125, 99.2045, 99.5710625, 99.85793749999999, 99.720125,
                100.095125, 100.938875, 99.12715625, 97.30465625, 96.05825, 95.032625, 94.84231249999999, 94.657625,
                94.91403125, 95.05465625, 96.46090625, 98.28903125, 100.7045, 102.55465625, 102.67325, 101.92325,
                101.19528125, 99.720125, 103.517, 95.876375, 95.0795,
            ],
            '25th_percentile': [
                117.017, 111.00528125, 107.4545, 105.2045, 104.407625, 104.688875, 103.73965625, 103.98575, 104.220125,
                103.282625, 99.5795, 98.220125, 96.86075, 96.907625, 96.345125, 96.392, 96.017, 97.188875, 98.782625,
                101.16153125, 103.095125, 103.095125, 102.345125, 101.595125, 100.23575, 104.4545, 96.2045, 95.220125,
            ],
            '50th_percentile': [
                122.73575, 116.7591875, 113.6185625, 110.6185625, 108.345125, 107.313875, 107.220125, 106.470125,
                105.626375, 105.1810625, 101.267, 99.626375, 98.126375, 98.1029375, 97.188875, 97.61075, 96.813875,
                97.61075, 99.017, 101.36075, 103.3295, 103.282625, 102.48575, 101.73575, 100.42325, 104.782625,
                96.345125, 95.267,
            ],
            '75th_percentile': [
                129.063875, 123.49746875, 120.59121875, 117.30996875, 114.532625, 112.20059375, 112.05996875,
                109.657625, 107.36075, 107.79434375, 103.04825, 101.36075, 99.626375, 99.767, 98.37246875, 98.79434375,
                97.7045, 98.220125, 99.29825, 101.595125, 103.517, 103.517, 102.67325, 101.92325, 100.61075, 105.2045,
                96.532625, 95.36075,
            ],
            '99th_percentile': [
                140.5154375, 134.24778125, 131.5979375, 129.32309375, 126.80028124999998, 124.42325, 121.56949999999999,
                118.938875, 117.86637499999999, 116.11278124999998, 111.70371875, 113.35887499999995,
                114.79465624999999, 106.06793749999997, 104.17325, 102.07231249999998, 102.32590624999999, 100.3295,
                100.3295, 102.2045, 104.032625, 104.15121875, 103.095125, 102.392, 101.17325, 106.72934375, 97.517,
                96.2045,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407607,
        longitude: -122.5329643,
        timestamp: '2025-08-29T17:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.499313361726,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407607,
        longitude: -122.5329643,
        timestamp: '2025-08-29T17:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                124.74164622641769, 118.94362883254954, 115.99569988207773, 113.25113546580403, 110.85465109080393,
                107.87162116745473, 106.54242747641693, 107.45809301297355, 106.01309375000179, 104.46494737618094,
                103.18627697523749, 102.7094565153318, 100.36498791273736, 99.40902535377502, 99.32887352594483,
                98.93192850825614, 98.60612514740707, 99.05442261202974, 99.9933045400958, 101.53984787736006,
                103.31407768278468, 103.423968602596, 102.33987367335067, 101.33095563089779, 100.0401242629732,
                104.0570022110866, 96.78358313679375, 95.36843352004838,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                108.01418749999999, 102.41121874999999, 100.20809374999999, 98.61153125, 97.74856249999999, 96.78903125,
                97.82028125, 98.47653125, 98.17325, 98.66121874999999, 98.5398125, 98.267, 96.52981249999999,
                96.41121874999999, 96.11075, 95.73575, 95.99215625, 96.86075, 98.33590625, 100.563875, 102.438875,
                102.5795, 101.54825, 100.657625, 99.251375, 102.626375, 96.063875, 95.17325,
            ],
            '25th_percentile': [
                118.85684375, 112.83340625, 109.470125, 106.36465625, 104.501375, 102.11075, 102.00528125, 104.17325,
                103.142, 102.19278125, 101.73575, 100.892, 98.73575, 98.30215625, 98.30215625, 97.751375, 97.517,
                98.126375, 99.157625, 101.126375, 103.001375, 103.095125, 102.063875, 101.0795, 99.767, 103.61075,
                96.48575, 95.267,
            ],
            '50th_percentile': [
                125.267, 119.6654375, 116.5716875, 113.688875, 110.595125, 107.0560625, 105.626375, 107.220125,
                105.7904375, 103.892, 103.04825, 102.11075, 99.9779375, 99.29825, 99.2748125, 98.876375, 98.642,
                98.8998125, 99.7904375, 101.501375, 103.282625, 103.3295, 102.251375, 101.313875, 100.001375,
                104.0091875, 96.720125, 95.36075,
            ],
            '75th_percentile': [
                130.3295, 124.76309375, 122.09121875, 119.7123125, 116.2904375, 112.95059375, 110.220125, 110.55996875,
                108.626375, 106.23575, 104.642, 103.892, 101.32559375, 100.282625, 100.282625, 100.01309375, 99.532625,
                99.9545, 100.61075, 101.876375, 103.61075, 103.7045, 102.532625, 101.501375, 100.282625, 104.407625,
                97.001375, 95.407625,
            ],
            '99th_percentile': [
                141.88090624999995, 135.74496875, 132.626375, 129.83871875, 127.10637499999999, 124.3791875,
                121.31028124999999, 118.87278124999999, 117.3010625, 115.94449999999999, 109.41246874999999,
                112.66324999999999, 111.97699999999998, 103.96653124999999, 103.23575, 102.63199999999999, 102.392,
                102.4885625, 103.30746875, 103.001375, 104.501375, 104.73575, 103.751375, 102.27621875, 101.032625,
                105.48575, 98.032625, 95.76059375,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407607,
        longitude: -122.5329643,
        timestamp: '2025-08-29T17:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 126.95261815349319,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44075,
        longitude: -122.5329667,
        timestamp: '2025-08-29T17:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 133.142,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44075,
        longitude: -122.5329667,
        timestamp: '2025-08-29T17:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44075,
        longitude: -122.5329667,
        timestamp: '2025-08-29T17:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 19,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44075,
        longitude: -122.5329667,
        timestamp: '2025-08-29T17:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44075,
        longitude: -122.5329667,
        timestamp: '2025-08-29T17:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1e3b48219017c185aa4051818071901641519016411185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44075,
        longitude: -122.5329667,
        timestamp: '2025-08-29T17:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.892, 125.642, 122.642, 119.642, 116.642, 113.642, 110.642, 109.892, 108.392, 106.142, 103.892,
                103.892, 102.392, 100.142, 99.392, 99.392, 98.642, 99.392, 100.142, 101.642, 103.142, 103.142, 102.392,
                101.642, 100.142, 106.142, 97.142, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                118.892, 112.892, 109.142, 106.142, 104.642, 102.392, 101.642, 104.642, 103.142, 102.392, 101.642,
                100.892, 98.642, 98.642, 98.642, 97.892, 97.892, 97.892, 99.392, 100.892, 103.142, 103.142, 102.392,
                100.892, 100.142, 103.892, 96.392, 95.642,
            ],
            '50th_percentile': [
                124.892, 119.642, 116.642, 113.642, 110.642, 106.892, 105.392, 107.642, 106.142, 103.892, 103.142,
                102.392, 100.142, 99.392, 99.392, 98.642, 98.642, 98.642, 100.142, 101.642, 103.142, 103.142, 102.392,
                101.642, 100.142, 103.892, 96.392, 95.642,
            ],
            '75th_percentile': [
                130.142, 124.892, 121.892, 119.642, 115.892, 112.892, 109.892, 110.642, 108.392, 106.142, 104.642,
                103.892, 101.642, 100.142, 100.142, 100.142, 99.392, 100.142, 100.892, 101.642, 103.892, 103.892,
                102.392, 101.642, 100.142, 104.642, 97.142, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44075,
        longitude: -122.5329667,
        timestamp: '2025-08-29T18:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 133.142,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44075,
        longitude: -122.5329667,
        timestamp: '2025-08-29T18:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44075,
        longitude: -122.5329667,
        timestamp: '2025-08-29T18:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 17,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44075,
        longitude: -122.5329667,
        timestamp: '2025-08-29T18:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44075,
        longitude: -122.5329667,
        timestamp: '2025-08-29T18:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1eabc8219017c185aa405181d0719015f1519015f11185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.44075,
        longitude: -122.5329667,
        timestamp: '2025-08-29T18:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.892, 126.392, 123.392, 119.642, 116.642, 113.642, 110.642, 108.392, 105.392, 103.142, 100.142,
                98.642, 96.392, 96.392, 96.392, 96.392, 95.642, 96.392, 97.892, 100.142, 102.392, 102.392, 101.642,
                100.142, 99.392, 103.142, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                118.142, 112.142, 109.142, 106.892, 103.142, 101.642, 100.892, 100.142, 98.642, 97.892, 96.392, 95.642,
                94.892, 94.892, 94.892, 94.892, 94.892, 95.642, 97.892, 100.142, 101.642, 102.392, 100.892, 100.142,
                99.392, 103.142, 96.392, 95.642,
            ],
            '50th_percentile': [
                124.142, 118.142, 115.142, 112.142, 108.392, 106.142, 103.892, 103.142, 101.642, 100.142, 97.892,
                96.392, 95.642, 95.642, 95.642, 95.642, 95.642, 96.392, 97.892, 100.142, 102.392, 102.392, 101.642,
                100.142, 99.392, 103.142, 96.392, 95.642,
            ],
            '75th_percentile': [
                130.142, 124.892, 121.142, 118.892, 115.142, 112.142, 109.142, 106.892, 104.642, 103.142, 100.892,
                97.892, 96.392, 96.392, 96.392, 96.392, 96.392, 97.142, 98.642, 100.892, 102.392, 102.392, 101.642,
                100.892, 99.392, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407417,
        longitude: -122.5330247,
        timestamp: '2025-08-29T18:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                124.16866740282943, 118.31945141342992, 115.37057773851815, 112.65199337456043, 109.7496082155497,
                107.33910689046124, 105.24762058304064, 103.98806890459537, 101.72100839222776, 100.62543639576127,
                98.76440503533713, 97.19820583039004, 95.94097305653838, 95.7967040636055, 95.77285247349948,
                95.69947570671503, 95.59865856890583, 96.53671068904724, 97.98790326855261, 100.39382199646795,
                102.10368286219243, 102.44025530035499, 101.29825000000156, 100.37284143109692, 99.22205742049614,
                103.17435424028436, 96.50032597173274, 95.34070803887047,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                107.66262499999999, 101.687, 99.765125, 98.56887499999999, 97.77387499999999, 96.532625,
                95.66449999999999, 95.52387499999999, 94.44574999999999, 94.702625, 94.23575, 93.45949999999999,
                93.22699999999999, 93.392, 93.60199999999999, 93.48575, 93.93012499999999, 95.33637499999999, 97.04825,
                99.5795, 101.313875, 101.71137499999999, 100.7045, 99.67325, 98.36075, 101.73575, 95.99262499999999,
                95.126375,
            ],
            '25th_percentile': [
                118.282625, 112.188875, 109.142, 106.563875, 103.376375, 101.92325, 100.7045, 100.376375, 98.313875,
                97.79825, 96.626375, 95.54825, 94.751375, 94.751375, 94.79825, 94.751375, 94.79825, 95.970125, 97.61075,
                100.095125, 101.8295, 102.157625, 101.0795, 100.188875, 99.017, 102.767, 96.29825, 95.267,
            ],
            '50th_percentile': [
                124.3295, 118.142, 115.001375, 112.3295, 108.48575, 105.9545, 104.220125, 103.23575, 101.313875,
                99.907625, 98.17325, 96.720125, 95.54825, 95.4545, 95.4545, 95.36075, 95.4545, 96.438875, 97.938875,
                100.376375, 102.11075, 102.392, 101.267, 100.376375, 99.2045, 103.142, 96.48575, 95.313875,
            ],
            '75th_percentile': [
                130.188875, 124.517, 121.470125, 118.376375, 115.376375, 112.095125, 108.767, 106.61075, 104.407625,
                103.04825, 100.61075, 98.0795, 96.5795, 96.438875, 96.392, 96.2045, 96.157625, 97.001375, 98.267,
                100.657625, 102.345125, 102.67325, 101.501375, 100.563875, 99.438875, 103.517, 96.626375, 95.407625,
            ],
            '99th_percentile': [
                142.777625, 137.553875, 133.871375, 129.847625, 128.11325, 124.8245, 121.29012499999999,
                117.70887499999998, 114.89262499999998, 112.237625, 107.67575, 107.50699999999999, 102.656375,
                101.10387499999999, 100.050125, 100.2845, 99.02262499999999, 98.5745, 99.157625, 101.38512499999999,
                102.93199999999999, 103.517, 101.99449999999999, 101.0795, 100.11949999999999, 104.92325, 97.3295,
                95.71324999999999,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407417,
        longitude: -122.5330247,
        timestamp: '2025-08-29T18:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 126.23362639234395,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407417,
        longitude: -122.5330247,
        timestamp: '2025-08-29T18:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                123.65155167844779, 117.69566607774085, 114.23972526501986, 111.30161793286425, 109.22978710247546,
                106.8171877208499, 104.7729076855141, 104.46957287986037, 100.8537932862206, 99.62974293286364,
                98.16806007067274, 97.09181227915325, 95.69809540636163, 95.36279284452415, 95.5647031802132,
                95.46775088339342, 95.59898984099058, 96.73138825088466, 98.22625353357026, 100.76561969964816,
                102.51330079505462, 102.5013197879875, 101.26965017668002, 100.36075000000152, 99.15149646643255,
                103.11814840989567, 96.51374249116736, 95.35754770318144,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                107.642, 101.546375, 99.41449999999999, 98.24262499999999, 97.02199999999999, 96.716375, 95.45075,
                96.90575, 94.53949999999999, 94.28075, 93.69574999999999, 93.13324999999999, 93.03949999999999,
                92.876375, 93.202625, 93.392, 93.86075, 95.4545, 96.907625, 99.55512499999999, 101.313875, 101.501375,
                100.42325, 99.392, 98.313875, 101.73575, 95.970125, 95.0795,
            ],
            '25th_percentile': [
                117.532625, 111.157625, 107.032625, 104.688875, 103.61075, 101.8295, 100.376375, 100.938875, 97.61075,
                96.813875, 95.876375, 94.845125, 94.095125, 93.907625, 94.23575, 94.23575, 94.563875, 95.970125, 97.517,
                100.188875, 102.017, 102.11075, 101.032625, 100.095125, 98.92325, 102.67325, 96.29825, 95.220125,
            ],
            '50th_percentile': [
                124.04825, 118.095125, 114.251375, 110.54825, 107.876375, 105.2045, 103.892, 104.032625, 100.188875,
                98.782625, 97.095125, 95.970125, 94.892, 94.657625, 94.845125, 94.7045, 94.938875, 96.29825, 97.79825,
                100.470125, 102.345125, 102.438875, 101.267, 100.376375, 99.11075, 103.095125, 96.438875, 95.313875,
            ],
            '75th_percentile': [
                129.48575, 123.67325, 121.001375, 117.29825, 114.438875, 110.73575, 108.063875, 106.79825, 103.001375,
                101.688875, 99.67325, 98.313875, 96.29825, 95.8295, 95.688875, 95.501375, 95.4545, 96.626375, 98.126375,
                100.79825, 102.626375, 102.813875, 101.501375, 100.563875, 99.345125, 103.517, 96.67325, 95.407625,
            ],
            '99th_percentile': [
                140.7395, 135.08825, 131.26887499999998, 128.76387499999998, 126.22887499999999, 124.237625, 121.00325,
                117.60387499999999, 113.831375, 111.2345, 109.24137499999999, 107.74137499999999, 103.845125,
                104.51449999999998, 105.29825, 104.29325, 103.44762499999999, 102.81575, 105.13512499999999, 107.0795,
                106.78324999999998, 104.60074999999999, 102.22887499999999, 101.24449999999999, 100.02574999999999,
                104.831375, 97.282625, 95.876375,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4407417,
        longitude: -122.5330247,
        timestamp: '2025-08-29T18:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.64361068319025,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5331667,
        timestamp: '2025-08-29T18:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 132.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5331667,
        timestamp: '2025-08-29T18:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5331667,
        timestamp: '2025-08-29T18:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 18,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5331667,
        timestamp: '2025-08-29T18:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5331667,
        timestamp: '2025-08-29T18:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1f1c58219017c185aa6051837071901451519014511185813021602',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5331667,
        timestamp: '2025-08-29T18:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.142, 124.892, 121.142, 118.142, 115.892, 112.892, 109.892, 107.642, 103.892, 101.642, 100.142,
                99.392, 96.392, 96.392, 97.142, 96.392, 96.392, 97.142, 98.642, 100.892, 102.392, 102.392, 101.642,
                100.142, 99.392, 103.142, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                117.392, 111.392, 106.892, 104.642, 103.892, 101.642, 100.142, 100.892, 97.892, 97.142, 95.642, 94.892,
                94.142, 94.142, 94.142, 94.142, 94.892, 95.642, 97.892, 100.142, 102.392, 102.392, 100.892, 100.142,
                98.642, 102.392, 96.392, 94.892,
            ],
            '50th_percentile': [
                124.142, 118.142, 114.392, 110.642, 107.642, 105.392, 103.892, 103.892, 100.142, 98.642, 97.142, 96.392,
                94.892, 94.892, 94.892, 94.892, 94.892, 96.392, 97.892, 100.892, 102.392, 102.392, 101.642, 100.142,
                99.392, 103.142, 96.392, 95.642,
            ],
            '75th_percentile': [
                129.392, 123.392, 121.142, 117.392, 114.392, 110.642, 108.392, 106.892, 103.142, 101.642, 100.142,
                98.642, 96.392, 95.642, 95.642, 95.642, 95.642, 96.392, 97.892, 100.892, 102.392, 103.142, 101.642,
                100.892, 99.392, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5331667,
        timestamp: '2025-08-29T19:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 132.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5331667,
        timestamp: '2025-08-29T19:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5331667,
        timestamp: '2025-08-29T19:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 17,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5331667,
        timestamp: '2025-08-29T19:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5331667,
        timestamp: '2025-08-29T19:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1f8cc8219017c185aa505181a07190162151901621118591401',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5331667,
        timestamp: '2025-08-29T19:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.142, 124.892, 121.892, 118.892, 116.642, 114.392, 111.392, 109.142, 106.142, 103.892, 102.392,
                101.642, 100.892, 98.642, 96.392, 97.142, 96.392, 97.142, 98.642, 100.892, 103.142, 103.142, 101.642,
                100.892, 103.142, 114.392, 100.142, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                118.892, 112.892, 109.892, 108.392, 106.892, 106.142, 105.392, 104.642, 102.392, 100.892, 99.392,
                98.642, 96.392, 96.392, 94.892, 94.892, 95.642, 96.392, 97.892, 100.892, 102.392, 102.392, 101.642,
                100.142, 98.642, 102.392, 96.392, 94.892,
            ],
            '50th_percentile': [
                124.142, 118.142, 115.892, 112.892, 110.642, 108.392, 107.642, 106.142, 103.892, 102.392, 100.892,
                100.142, 97.892, 97.892, 96.392, 96.392, 96.392, 97.142, 98.642, 100.892, 103.142, 103.142, 101.642,
                100.892, 99.392, 103.142, 96.392, 95.642,
            ],
            '75th_percentile': [
                130.142, 124.892, 121.892, 118.892, 115.892, 113.642, 110.642, 108.392, 106.142, 103.892, 102.392,
                101.642, 99.392, 99.392, 97.892, 97.892, 97.142, 97.892, 99.392, 100.892, 103.142, 103.142, 101.642,
                100.892, 99.392, 103.142, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406087,
        longitude: -122.5332903,
        timestamp: '2025-08-29T19:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                124.1110625000026, 118.42672426470827, 115.88119117647288, 113.85828676470807, 111.80813970588446,
                110.18543750000204, 108.7200147058843, 106.97405882353125, 104.52817647058995, 102.69734926470751,
                101.33416911764861, 100.05194485294264, 98.19194485294254, 98.15802941176607, 96.3156764705895,
                96.47979411764832, 96.2936727941189, 97.21837867647191, 98.67856250000142, 100.87484926470742,
                102.88446323529577, 102.87966544117813, 101.63245955882512, 100.61223897058977, 99.15183455882499,
                102.93685294117813, 96.45972058823658, 95.33802941176593,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                107.220125, 101.70996875, 101.38371875, 102.296375, 101.82575, 102.01606249999999, 101.75871875,
                100.61075, 98.313875, 98.17325, 96.69621875, 94.75043749999999, 93.43793749999999, 93.76606249999999,
                93.017, 93.2045, 93.907625, 95.501375, 97.44621875, 99.93059375, 102.18059375, 102.18059375,
                100.96184375, 99.86075, 98.4545, 101.71184375, 95.8295, 95.0795,
            ],
            '25th_percentile': [
                118.7045, 112.79825, 109.657625, 108.30996875, 106.95059375, 106.376375, 105.720125, 104.407625,
                102.532625, 100.98575, 99.767, 98.32559375, 96.438875, 96.532625, 95.0795, 95.126375, 95.267, 96.438875,
                98.0795, 100.517, 102.626375, 102.626375, 101.4545, 100.42325, 98.92325, 102.532625, 96.21621875,
                95.220125,
            ],
            '50th_percentile': [
                124.188875, 118.376375, 115.751375, 113.1029375, 110.4310625, 108.7435625, 107.92325, 106.376375,
                103.98575, 102.157625, 101.1498125, 100.0248125, 98.0560625, 98.17325, 96.345125, 96.3216875, 96.157625,
                97.001375, 98.4779375, 100.79825, 102.86075, 102.86075, 101.595125, 100.61075, 99.11075, 102.86075,
                96.392, 95.267,
            ],
            '75th_percentile': [
                129.89590625, 124.7045, 122.06778125, 118.751375, 116.032625, 113.44278125, 110.86465625, 108.813875,
                105.9545, 103.657625, 102.438875, 101.407625, 99.28653125, 99.48575, 97.517, 97.7045, 97.23575,
                97.845125, 99.11075, 101.126375, 103.095125, 103.095125, 101.782625, 100.79825, 99.29825, 103.188875,
                96.5795, 95.36075,
            ],
            '99th_percentile': [
                140.83418749999998, 135.83778125, 133.21465625, 129.3479375, 126.25231249999999, 124.23575,
                121.12559375, 117.95543749999999, 114.91231249999998, 112.30746875, 110.4104375, 111.02074999999999,
                112.77528124999999, 104.90215624999999, 101.12825, 102.04278124999999, 100.09887499999999,
                100.25965624999999, 101.57215624999999, 102.58043749999999, 104.032625, 103.82215624999999, 102.29825,
                101.267, 99.88465624999999, 104.4545, 97.68153124999999, 96.04090624999999,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406087,
        longitude: -122.5332903,
        timestamp: '2025-08-29T19:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 126.53808671164981,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406087,
        longitude: -122.5332903,
        timestamp: '2025-08-29T19:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.7682867647084, 117.06238602941407, 114.2171838235316, 113.26986764706098, 110.9346102941197,
                109.4697389705902, 110.97409558823733, 110.99571323529615, 112.37185294117857, 109.24506985294315,
                105.45916911764884, 104.28271691176641, 104.0288750000017, 104.3409522058841, 104.84472058823705,
                104.86319485294294, 104.47347058823705, 104.53049264706058, 104.33080514706057, 105.29207352941356,
                106.16494117647241, 105.15310294117825, 103.57964705882524, 102.40942647058989, 100.28477573529565,
                104.10161397058998, 96.3938750000013, 95.30097058823652,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                107.0795, 101.68793749999999, 100.44621875, 102.67231249999999, 101.89840625, 101.782625, 104.687,
                105.55559375, 107.24121875, 104.78075, 100.890125, 99.64934375, 99.251375, 99.83590625, 100.095125,
                100.517, 99.88278125, 100.657625, 100.77434375, 102.157625, 103.142, 103.282625, 101.80559375,
                100.563875, 98.501375, 101.94621875, 95.876375, 95.0795,
            ],
            '25th_percentile': [
                117.157625, 111.16934375, 107.60684375, 108.59121875, 106.42325, 106.095125, 108.813875, 109.42325,
                110.970125, 107.8295, 104.032625, 102.86075, 102.720125, 102.813875, 103.376375, 103.42325, 102.9545,
                103.3295, 103.142, 103.79825, 104.970125, 104.267, 102.626375, 101.407625, 99.438875, 103.10684375,
                96.2045, 95.220125,
            ],
            '50th_percentile': [
                122.54825, 116.7591875, 113.642, 111.7435625, 109.4466875, 108.0873125, 110.4310625, 110.876375,
                112.42325, 109.376375, 105.532625, 104.313875, 104.0560625, 104.313875, 105.063875, 105.017, 104.407625,
                104.595125, 104.17325, 105.11075, 106.001375, 104.970125, 103.42325, 102.345125, 100.23575, 103.98575,
                96.345125, 95.267,
            ],
            '75th_percentile': [
                128.36075, 122.876375, 120.14590625, 117.438875, 114.47403125, 111.67325, 112.61075, 112.22403125,
                113.688875, 110.4545, 106.657625, 105.626375, 105.392, 105.9545, 106.3295, 106.45840625, 106.188875,
                105.813875, 105.38028125, 106.61075, 107.407625, 105.907625, 104.313875, 103.27090625, 101.032625,
                104.92325, 96.52090625, 95.36075,
            ],
            '99th_percentile': [
                140.7385625, 135.22840625, 132.55840625, 129.65121875, 128.032625, 124.91684375, 122.93262499999999,
                119.90121875, 119.01059375, 115.98575, 113.91059374999999, 111.58324999999999, 108.18246875, 108.438875,
                108.67418749999999, 108.907625, 108.41590624999999, 108.438875, 108.74403124999999, 110.126375,
                110.032625, 108.74403124999999, 106.470125, 105.69809375, 102.95543749999999, 107.15028124999999,
                97.84606249999999, 95.83043749999999,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406087,
        longitude: -122.5332903,
        timestamp: '2025-08-29T19:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 126.07231240698182,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5332,
        timestamp: '2025-08-29T19:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 131.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5332,
        timestamp: '2025-08-29T19:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5332,
        timestamp: '2025-08-29T19:44:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 18,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5332,
        timestamp: '2025-08-29T19:44:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5332,
        timestamp: '2025-08-29T19:44:00.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b1ffd48219017c185aa50518e007188c081015189c11185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5332,
        timestamp: '2025-08-29T19:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                129.392, 123.392, 121.142, 118.892, 116.642, 113.642, 112.892, 112.142, 112.892, 109.892, 106.142,
                105.392, 104.642, 104.642, 105.392, 105.392, 104.642, 104.642, 104.642, 106.142, 106.892, 105.392,
                103.892, 102.392, 100.142, 104.642, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                117.392, 111.392, 107.642, 108.392, 106.142, 106.142, 109.142, 109.142, 110.642, 107.642, 103.892,
                103.142, 103.142, 103.142, 103.892, 103.142, 103.142, 103.142, 103.142, 103.892, 105.392, 104.642,
                102.392, 101.642, 99.392, 103.142, 96.392, 94.892,
            ],
            '50th_percentile': [
                122.642, 116.642, 113.642, 111.392, 109.142, 108.392, 110.642, 110.642, 112.142, 109.142, 105.392,
                104.642, 103.892, 104.642, 105.392, 105.392, 104.642, 104.642, 103.892, 105.392, 106.142, 105.392,
                103.142, 102.392, 100.142, 103.892, 96.392, 95.642,
            ],
            '75th_percentile': [
                128.642, 122.642, 119.642, 117.392, 114.392, 111.392, 112.892, 112.142, 113.642, 110.642, 106.892,
                105.392, 105.392, 106.142, 106.142, 106.892, 106.142, 106.142, 105.392, 106.892, 107.642, 106.142,
                104.642, 103.142, 100.892, 104.642, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5332,
        timestamp: '2025-08-29T20:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 130.892,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5332,
        timestamp: '2025-08-29T20:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5332,
        timestamp: '2025-08-29T20:14:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 18,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5332,
        timestamp: '2025-08-29T20:14:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5332,
        timestamp: '2025-08-29T20:14:00.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b206dc8219017c185aa40509071901731519017311185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406333,
        longitude: -122.5332,
        timestamp: '2025-08-29T20:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                128.642, 123.392, 120.392, 117.392, 115.142, 112.142, 109.142, 106.142, 102.392, 100.142, 97.892,
                96.392, 94.142, 93.392, 93.392, 94.142, 94.142, 95.642, 97.892, 100.142, 102.392, 102.392, 101.642,
                100.892, 99.392, 103.142, 96.392, 94.892,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                116.642, 110.642, 106.892, 104.642, 103.892, 102.392, 100.892, 99.392, 97.892, 97.142, 95.642, 94.142,
                92.642, 92.642, 92.642, 93.392, 94.142, 95.642, 97.892, 100.142, 102.392, 102.392, 101.642, 100.892,
                98.642, 103.142, 96.392, 94.892,
            ],
            '50th_percentile': [
                123.392, 117.392, 114.392, 110.642, 108.392, 106.142, 104.642, 102.392, 100.142, 98.642, 97.142, 94.892,
                93.392, 93.392, 93.392, 93.392, 94.142, 95.642, 97.892, 100.142, 102.392, 102.392, 101.642, 100.892,
                99.392, 103.142, 96.392, 94.892,
            ],
            '75th_percentile': [
                128.642, 123.392, 120.392, 117.392, 114.392, 110.642, 108.392, 106.142, 102.392, 100.142, 98.642,
                96.392, 94.892, 94.142, 94.142, 94.142, 94.892, 96.392, 97.892, 100.892, 103.142, 103.142, 101.642,
                100.892, 99.392, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406922,
        longitude: -122.5330765,
        timestamp: '2025-08-29T20:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.73012500000254, 116.8899411764729, 113.73999632353159, 111.26620955882558, 109.32514338235491,
                107.02176102941363, 105.01837867647235, 103.14856250000167, 100.44255147058978, 98.93234926470734,
                97.20426102941312, 95.54665073529536, 93.92885661764821, 93.46727573529523, 93.44416911764817,
                93.71383823529524, 94.26106250000116, 95.86904044117773, 97.80095220588372, 100.4342242647074,
                102.7606029411781, 102.60194485294282, 101.54532720588394, 100.787165441178, 99.12415073529557,
                103.22576838235462, 96.17836029411893, 95.23876470588357,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                105.97746875, 100.81840625, 99.27434375, 98.19621875, 98.10246875, 97.58590625, 96.13371875,
                95.85153125, 94.42325, 93.9545, 93.10981249999999, 92.33590625, 91.657625, 91.44528125, 91.7045, 92.267,
                93.157625, 95.032625, 97.095125, 99.767, 102.11075, 101.876375, 100.892, 100.142, 98.4545, 101.94621875,
                95.782625, 95.032625,
            ],
            '25th_percentile': [
                116.501375, 110.11465625, 106.7045, 104.93496875, 103.61075, 102.07559375, 100.892, 99.5795, 97.79825,
                96.86075, 95.4545, 94.095125, 92.876375, 92.642, 92.73575, 93.2045, 93.813875, 95.54825, 97.563875,
                100.188875, 102.532625, 102.345125, 101.32559375, 100.563875, 98.92325, 102.813875, 96.017, 95.17325,
            ],
            '50th_percentile': [
                123.4154375, 117.5091875, 114.2279375, 110.876375, 108.4623125, 106.0716875, 104.36075, 102.392,
                99.9545, 98.4545, 96.813875, 95.0795, 93.5795, 93.345125, 93.345125, 93.67325, 94.188875, 95.782625,
                97.751375, 100.42325, 102.720125, 102.5795, 101.54825, 100.79825, 99.11075, 103.142, 96.1341875,
                95.220125,
            ],
            '75th_percentile': [
                128.63028125, 123.157625, 120.47403125, 117.52090625, 114.29825, 110.876375, 108.23965625, 106.001375,
                102.345125, 100.50528125, 98.36075, 96.438875, 94.55215625, 94.095125, 94.001375, 94.142, 94.61075,
                96.11075, 97.98575, 100.657625, 102.9545, 102.813875, 101.73575, 101.02090625, 99.29825, 103.517,
                96.29825, 95.313875,
            ],
            '99th_percentile': [
                138.60340625, 133.16684375, 130.2854375, 127.8010625, 126.04840624999999, 123.13653124999999,
                120.27715624999999, 116.22106249999999, 112.30746875, 109.80199999999999, 105.65403124999999, 103.37825,
                100.02621875, 96.55653124999999, 96.487625, 95.94715624999999, 95.8295, 97.16590624999999,
                98.75965624999999, 101.24403124999999, 103.517, 103.470125, 102.251375, 101.501375, 100.02528124999999,
                105.41590624999999, 97.07215624999999, 95.501375,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406922,
        longitude: -122.5330765,
        timestamp: '2025-08-29T20:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 124.88993805309853,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406922,
        longitude: -122.5330765,
        timestamp: '2025-08-29T20:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.2847915687452, 116.46711383666506, 113.54488998237585, 111.69572356051913, 110.82740687426762,
                108.17354377203483, 106.79070373090667, 106.83421871328036, 104.07558915981372, 104.4500934195082,
                104.01037176850937, 103.68252217979018, 101.72748766157622, 100.91750308460793, 102.43281595182304,
                105.3306934488855, 100.01178554641751, 99.70266392479587, 100.21487382491341, 102.07356947708743,
                103.3879973560534, 102.91324339013094, 101.92038572268083, 101.11772708578302, 99.5320741774398,
                103.26009635722849, 96.40257579318579, 95.26226292597069,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                105.86075, 101.0795, 100.142, 100.751375, 101.501375, 100.657625, 98.9466875, 100.3060625, 98.0091875,
                98.782625, 98.36075, 98.126375, 97.4466875, 96.6966875, 96.767, 98.220125, 95.92325, 96.532625,
                97.5873125, 99.9779375, 101.73575, 101.501375, 100.517, 99.67325, 98.3373125, 101.642, 95.92325,
                95.032625,
            ],
            '25th_percentile': [
                116.73575, 110.407625, 107.126375, 106.095125, 106.8216875, 104.267, 103.095125, 104.36075, 102.11075,
                102.720125, 102.2045, 101.73575, 100.1185625, 99.157625, 99.767, 102.720125, 98.0795, 98.2904375,
                98.970125, 101.1498125, 102.86075, 102.48575, 101.267, 100.4466875, 99.063875, 102.720125, 96.251375,
                95.17325,
            ],
            '50th_percentile': [
                122.501375, 116.267, 112.98575, 110.92325, 110.0795, 107.126375, 106.04825, 106.563875, 103.892,
                104.407625, 104.17325, 103.563875, 101.642, 100.892, 102.438875, 105.720125, 99.720125, 99.438875,
                99.907625, 101.73575, 103.23575, 102.9545, 101.970125, 101.17325, 99.532625, 103.23575, 96.392, 95.267,
            ],
            '75th_percentile': [
                128.126375, 122.220125, 119.3373125, 116.595125, 113.6654375, 110.8295, 109.79825, 108.8373125,
                105.813875, 105.9545, 105.86075, 105.720125, 103.3295, 102.5795, 105.017, 107.8998125, 101.595125,
                100.892, 101.267, 102.86075, 103.751375, 103.3295, 102.392, 101.642, 99.907625, 103.7045, 96.532625,
                95.313875,
            ],
            '99th_percentile': [
                141.4154375, 135.0873125, 131.313875, 128.9935625, 126.4154375, 123.7904375, 120.5560625, 117.767,
                114.5091875, 111.7904375, 109.142, 109.001375, 106.3060625, 105.4154375, 108.8373125, 112.3998125,
                105.438875, 103.9154375, 104.032625, 105.9310625, 106.142, 104.4779375, 104.2904375, 103.2591875,
                101.126375, 105.532625, 97.188875, 95.4779375,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406922,
        longitude: -122.5330765,
        timestamp: '2025-08-29T20:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 124.95102366437025,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406,
        longitude: -122.5332667,
        timestamp: '2025-08-29T20:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 131.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406,
        longitude: -122.5332667,
        timestamp: '2025-08-29T20:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406,
        longitude: -122.5332667,
        timestamp: '2025-08-29T20:44:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 18,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406,
        longitude: -122.5332667,
        timestamp: '2025-08-29T20:44:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406,
        longitude: -122.5332667,
        timestamp: '2025-08-29T20:44:00.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b20de48219017c185aa6051834071901481519014811185913011601',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406,
        longitude: -122.5332667,
        timestamp: '2025-08-29T20:44:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                129.392, 124.142, 121.142, 118.142, 115.142, 112.892, 110.642, 109.142, 105.392, 105.392, 104.642,
                104.642, 102.392, 101.642, 103.892, 106.892, 100.892, 100.142, 100.892, 102.392, 103.892, 103.142,
                102.392, 100.892, 99.392, 103.142, 96.392, 94.892,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                116.642, 110.642, 106.892, 106.142, 106.892, 104.642, 103.142, 104.642, 102.392, 103.142, 102.392,
                101.642, 100.142, 99.392, 100.142, 103.142, 97.892, 98.642, 99.392, 100.892, 103.142, 102.392, 101.642,
                100.892, 99.392, 103.142, 96.392, 94.892,
            ],
            '50th_percentile': [
                122.642, 116.642, 112.892, 111.392, 109.892, 106.892, 106.142, 106.892, 103.892, 104.642, 104.642,
                103.892, 101.642, 100.892, 102.392, 106.142, 100.142, 99.392, 100.142, 101.642, 103.142, 103.142,
                102.392, 100.892, 99.392, 103.142, 96.392, 95.642,
            ],
            '75th_percentile': [
                127.892, 121.892, 119.642, 116.642, 113.642, 110.642, 109.892, 109.142, 106.142, 106.142, 106.142,
                106.142, 103.142, 102.392, 105.392, 107.642, 101.642, 100.892, 101.642, 103.142, 103.892, 103.142,
                102.392, 101.642, 100.142, 103.892, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406,
        longitude: -122.5332667,
        timestamp: '2025-08-29T21:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 131.642,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406,
        longitude: -122.5332667,
        timestamp: '2025-08-29T21:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 10.5,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406,
        longitude: -122.5332667,
        timestamp: '2025-08-29T21:14:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 18,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406,
        longitude: -122.5332667,
        timestamp: '2025-08-29T21:14:00.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406,
        longitude: -122.5332667,
        timestamp: '2025-08-29T21:14:00.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b214ed8219017c185aa40504071901781519017811185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406,
        longitude: -122.5332667,
        timestamp: '2025-08-29T21:14:00.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                129.392, 124.142, 121.142, 118.142, 115.892, 112.892, 110.642, 108.392, 103.892, 100.892, 99.392,
                97.892, 95.642, 94.892, 94.142, 94.142, 94.892, 95.642, 97.892, 100.142, 102.392, 102.392, 100.892,
                100.892, 98.642, 103.142, 96.392, 94.892,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                117.392, 110.642, 106.892, 105.392, 104.642, 103.142, 103.892, 103.892, 99.392, 97.892, 97.142, 95.642,
                94.142, 94.142, 94.142, 93.392, 94.142, 95.642, 97.142, 100.142, 102.392, 102.392, 100.892, 100.142,
                98.642, 103.142, 95.642, 94.892,
            ],
            '50th_percentile': [
                123.392, 117.392, 114.392, 110.642, 108.392, 106.142, 106.142, 106.142, 100.892, 98.642, 97.892, 96.392,
                94.892, 94.892, 94.142, 94.142, 94.142, 95.642, 97.892, 100.142, 102.392, 102.392, 100.892, 100.892,
                98.642, 103.142, 96.392, 94.892,
            ],
            '75th_percentile': [
                128.642, 124.142, 121.142, 118.142, 115.142, 112.142, 109.142, 109.142, 103.142, 100.892, 99.392,
                97.892, 95.642, 95.642, 94.892, 94.892, 94.892, 96.392, 97.892, 100.142, 102.392, 102.392, 101.642,
                100.892, 99.392, 103.142, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406237,
        longitude: -122.5332665,
        timestamp: '2025-08-29T21:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.99290073529667, 117.30696323529644, 114.39222058823748, 112.07885661764914, 110.34200000000202,
                107.88966544117837, 107.31657720588423, 106.71536397059006, 101.80032720588396, 99.6643713235309,
                98.5297205882367, 97.11012500000132, 95.22696323529533, 94.71006985294235, 94.39407720588352,
                94.25361764705998, 94.50084191176586, 95.83297426470713, 97.60176102941313, 100.2085625000015,
                102.48961029411929, 102.25010661764868, 101.22696323529568, 100.60220220588388, 98.92534558823672,
                103.09981250000168, 96.14256985294246, 95.24626470588356,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                106.5123125, 101.00871875, 99.76606249999999, 100.86621875, 100.11809375, 98.8745, 100.39934375,
                99.86075, 96.60246875, 95.99309375, 95.17325, 94.16496875, 93.063875, 92.80559375, 92.782625,
                92.89934375, 93.392, 94.98575, 96.93059375, 99.48575, 101.876375, 101.61809375, 100.7045, 99.9545,
                98.36075, 101.8295, 95.73575, 95.0795,
            ],
            '25th_percentile': [
                117.11075, 110.93496875, 106.99746875, 105.438875, 104.74746875, 102.907625, 104.032625, 104.0795,
                99.345125, 97.845125, 97.095125, 95.688875, 94.15371875, 94.001375, 93.767, 93.720125, 94.04825,
                95.501375, 97.376375, 100.001375, 102.29825, 102.017, 101.0795, 100.470125, 98.73575, 102.813875,
                95.970125, 95.17325,
            ],
            '50th_percentile': [
                123.1341875, 117.67325, 114.5091875, 111.017, 108.720125, 106.3295, 106.3529375, 106.42325, 100.8685625,
                98.92325, 98.0795, 96.7435625, 94.845125, 94.61075, 94.282625, 94.188875, 94.42325, 95.782625,
                97.563875, 100.23575, 102.48575, 102.2045, 101.220125, 100.61075, 98.92325, 103.04825, 96.11075,
                95.220125,
            ],
            '75th_percentile': [
                128.86465625, 123.813875, 121.22403125, 118.0248125, 115.31778125, 112.0716875, 109.41153125, 108.86075,
                103.41153125, 100.50528125, 99.29825, 98.0795, 95.73575, 95.267, 94.845125, 94.7045, 94.892, 96.11075,
                97.845125, 100.42325, 102.67325, 102.438875, 101.407625, 100.751375, 99.11075, 103.42325, 96.251375,
                95.313875,
            ],
            '99th_percentile': [
                139.86996875, 134.52528125, 132.18246875, 129.18153125, 126.81481249999999, 124.142, 120.8166875,
                117.41778124999999, 114.13465624999999, 110.29184375, 106.4729375, 103.11903124999999,
                101.90215624999999, 97.563875, 97.54090624999999, 96.11168749999999, 96.04090624999999, 97.001375,
                98.47840624999999, 100.91590624999999, 103.095125, 103.142, 101.782625, 101.17325, 99.55653124999999,
                104.33778124999999, 96.9545, 95.4545,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406237,
        longitude: -122.5332665,
        timestamp: '2025-08-29T21:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.31862423706151,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406237,
        longitude: -122.5332665,
        timestamp: '2025-08-29T21:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                122.6560845070448, 116.97051012324175, 114.19322139084728, 112.10695378521338, 110.46401804577668,
                108.78064436619913, 108.04148283450895, 107.99301232394559, 103.26793529929745, 100.83599207746634,
                99.33698239436767, 97.33065536971965, 96.0860470950717, 95.6587253521139, 95.37582482394488,
                94.9593965669026, 95.28229489436741, 96.26501936619846, 97.62488952464925, 100.14260519366348,
                102.44701760563545, 102.14326540493121, 100.91252156690298, 100.3328560739452, 98.66301672535354,
                102.99086663732561, 96.08956822183227, 95.23002816901531,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                106.35340624999999, 101.10434375, 100.7045, 101.688875, 101.597, 101.1273125, 101.85434375, 101.501375,
                98.38465624999999, 96.347, 95.267, 93.8616875, 93.345125, 92.75965624999999, 92.52528124999999,
                92.66590624999999, 93.392, 94.91590624999999, 96.67325, 99.36903124999999, 101.595125, 101.17325,
                100.07215624999999, 99.65028124999999, 98.0795, 101.90028124999999, 95.642, 95.032625,
            ],
            '25th_percentile': [
                116.782625, 110.4779375, 107.16153125, 106.27090625, 105.66153125, 104.86465625, 105.2045, 105.907625,
                101.267, 99.157625, 97.938875, 95.8295, 94.845125, 94.376375, 94.36465625, 93.86075, 94.23575, 95.54825,
                97.188875, 99.86075, 102.2045, 101.876375, 100.751375, 100.142, 98.501375, 102.626375, 95.876375,
                95.17325,
            ],
            '50th_percentile': [
                123.063875, 117.157625, 114.017, 110.5248125, 108.7904375, 107.407625, 107.17325, 107.4545, 102.5795,
                100.376375, 98.92325, 96.9545, 95.73575, 95.4545, 95.36075, 94.79825, 95.032625, 96.063875, 97.517,
                100.142, 102.438875, 102.11075, 100.938875, 100.3295, 98.642, 102.907625, 96.017, 95.220125,
            ],
            '75th_percentile': [
                128.65371875, 123.07559375, 120.67325, 117.3685625, 114.70840625, 111.532625, 109.657625, 109.563875,
                104.407625, 101.74746875, 100.142, 98.220125, 96.813875, 96.86075, 96.438875, 95.876375, 96.251375,
                96.813875, 97.938875, 100.376375, 102.67325, 102.392, 101.126375, 100.517, 98.8295, 103.282625, 96.2045,
                95.267,
            ],
            '99th_percentile': [
                138.390125, 133.185125, 131.10153125, 128.18965625, 126.21903125, 124.11809375, 120.45715625, 119.732,
                115.702625, 111.97746875, 108.82278125, 105.71825, 103.91309375, 100.136375, 98.66496875, 98.6879375,
                98.17325, 98.5004375, 99.392, 101.126375, 103.21184375, 103.04825, 101.54825, 100.938875, 99.29825,
                104.47653125, 97.23575, 95.4545,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4406237,
        longitude: -122.5332665,
        timestamp: '2025-08-29T21:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 125.12794631809183,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5333167,
        timestamp: '2025-08-29T21:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 130.892,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5333167,
        timestamp: '2025-08-29T21:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9.75,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5333167,
        timestamp: '2025-08-29T21:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 18,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5333167,
        timestamp: '2025-08-29T21:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5333167,
        timestamp: '2025-08-29T21:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b21bf48219017c185aa705020719017a1519017a111857130114021601',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5333167,
        timestamp: '2025-08-29T21:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                128.642, 123.392, 121.142, 118.142, 115.892, 112.892, 110.642, 109.892, 105.392, 102.392, 102.392,
                98.642, 96.392, 96.392, 95.642, 94.892, 95.642, 96.392, 97.892, 100.142, 102.392, 102.392, 100.892,
                100.142, 98.642, 103.142, 96.392, 94.892,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                116.642, 110.642, 106.892, 106.142, 105.392, 104.642, 105.392, 106.142, 100.892, 99.392, 97.892, 95.642,
                94.892, 94.142, 94.142, 94.142, 94.142, 95.642, 97.142, 100.142, 102.392, 101.642, 100.892, 100.142,
                98.642, 102.392, 95.642, 94.892,
            ],
            '50th_percentile': [
                123.392, 117.392, 113.642, 110.642, 108.392, 107.642, 106.892, 107.642, 102.392, 100.142, 98.642,
                97.142, 95.642, 95.642, 95.642, 94.892, 94.892, 96.392, 97.142, 100.142, 102.392, 102.392, 100.892,
                100.142, 98.642, 103.142, 96.392, 94.892,
            ],
            '75th_percentile': [
                128.642, 123.392, 120.392, 117.392, 114.392, 111.392, 109.892, 109.892, 104.642, 101.642, 100.142,
                97.892, 97.142, 97.142, 96.392, 95.642, 96.392, 97.142, 97.892, 100.142, 102.392, 102.392, 100.892,
                100.892, 98.642, 103.142, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5333167,
        timestamp: '2025-08-29T22:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 132.392,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5333167,
        timestamp: '2025-08-29T22:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5333167,
        timestamp: '2025-08-29T22:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 17,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5333167,
        timestamp: '2025-08-29T22:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5333167,
        timestamp: '2025-08-29T22:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b222fd8219017c185aa805186b0719010e080315190111111859130114011601',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405833,
        longitude: -122.5333167,
        timestamp: '2025-08-29T22:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                130.142, 124.892, 121.892, 118.892, 116.642, 114.392, 113.642, 114.392, 109.142, 106.892, 105.392,
                103.142, 100.892, 100.142, 98.642, 100.142, 101.642, 100.142, 100.142, 101.642, 103.142, 103.142,
                101.642, 100.142, 98.642, 102.392, 96.392, 94.892,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                117.392, 111.392, 109.892, 109.142, 108.392, 107.642, 108.392, 109.892, 104.642, 100.892, 100.142,
                98.642, 97.892, 97.142, 96.392, 96.392, 96.392, 97.142, 97.892, 100.142, 102.392, 101.642, 100.892,
                100.142, 98.642, 102.392, 96.392, 94.892,
            ],
            '50th_percentile': [
                123.392, 117.392, 115.142, 113.642, 111.392, 110.642, 111.392, 112.892, 107.642, 103.892, 103.142,
                101.642, 100.142, 98.642, 97.142, 97.142, 97.892, 97.892, 98.642, 100.142, 102.392, 102.392, 100.892,
                100.142, 98.642, 102.392, 96.392, 95.642,
            ],
            '75th_percentile': [
                129.392, 124.142, 121.142, 118.142, 115.892, 113.642, 114.392, 115.142, 109.892, 106.892, 106.142,
                104.642, 101.642, 100.142, 99.392, 100.142, 101.642, 100.142, 100.142, 101.642, 103.142, 103.142,
                101.642, 100.142, 98.642, 103.142, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405778,
        longitude: -122.5333863,
        timestamp: '2025-08-29T22:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                123.50649065836552, 117.81476467971763, 115.55269839857874, 114.17369483985983, 112.57038078292027,
                111.20333229537573, 111.62576334519783, 112.5791107651267, 107.56370818505529, 104.2301895017811,
                103.2454808718878, 101.9352606761582, 100.17742037366698, 99.00632384341779, 97.9384301601437,
                98.6219822064071, 99.26655516014381, 99.1425004448413, 99.42413967971676, 101.11475355872038,
                103.03985364768846, 102.71011610320446, 101.19821663701221, 100.3375627224214, 98.73458229537505,
                102.54786076512615, 96.23830782918273, 95.25649065836416,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                107.01481249999999, 102.49793749999999, 101.681375, 103.61075, 103.8179375, 103.1148125, 104.8295,
                105.6929375, 100.7710625, 98.118875, 97.41575, 96.4116875, 95.688875, 95.313875, 94.5366875, 94.657625,
                95.032625, 95.782625, 97.142, 99.5795, 101.688875, 101.407625, 100.23575, 99.48575, 98.0054375,
                101.407625, 95.73575, 95.0795,
            ],
            '25th_percentile': [
                117.67325, 111.626375, 109.517, 109.188875, 108.4154375, 107.876375, 108.626375, 109.845125, 104.642,
                101.126375, 100.188875, 98.8295, 97.892, 97.42325, 96.063875, 96.251375, 96.532625, 97.001375, 97.892,
                100.095125, 102.157625, 101.876375, 100.7045, 99.9779375, 98.407625, 102.11075, 96.063875, 95.17325,
            ],
            '50th_percentile': [
                123.767, 117.67325, 115.282625, 113.92325, 111.626375, 110.595125, 111.345125, 112.563875, 107.73575,
                103.845125, 103.095125, 101.876375, 100.001375, 98.54825, 97.282625, 97.376375, 97.7045, 97.98575,
                98.501375, 100.42325, 102.438875, 102.157625, 100.892, 100.142, 98.642, 102.438875, 96.157625, 95.267,
            ],
            '75th_percentile': [
                129.48575, 124.0248125, 121.23575, 117.9779375, 115.845125, 113.6654375, 114.1341875, 115.1185625,
                110.126375, 106.751375, 105.86075, 104.313875, 101.876375, 100.0716875, 99.157625, 99.767, 101.2435625,
                100.3998125, 99.9545, 101.267, 102.907625, 102.720125, 101.313875, 100.470125, 98.876375, 102.86075,
                96.392, 95.313875,
            ],
            '99th_percentile': [
                140.1535625, 135.46887500000003, 132.87106250000002, 129.6685625, 127.72231250000002,
                125.17606250000001, 122.336375, 121.04825, 116.76575000000001, 115.61825, 112.17200000000001,
                109.87231249999999, 107.73575, 106.40356249999999, 105.5673125, 108.88793749999999, 108.4266875,
                107.24731249999999, 106.59106249999999, 107.0673125, 108.74731249999999, 108.212, 104.66918749999999,
                102.86075, 100.563875, 104.76293749999999, 97.3295, 95.52856249999999,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405778,
        longitude: -122.5333863,
        timestamp: '2025-08-29T22:14:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 126.42733082440034,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405778,
        longitude: -122.5333863,
        timestamp: '2025-08-29T22:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                124.68711443662231, 118.83362632042493, 115.73101848591774, 113.49565316901625, 112.00043970070632,
                109.92875176056539, 109.19470686619916, 108.71610871479068, 105.37587984155107, 103.17869674295939,
                101.49383758802972, 100.12637500000149, 99.52437235915636, 99.03796170774791, 97.99906426056474,
                97.84385959507179, 97.42820158450839, 97.78383538732531, 98.43865492957887, 100.30160607394518,
                102.18716945422699, 101.86008978873402, 100.35761399648041, 99.72601188380432, 98.41351188380425,
                102.28961223591713, 96.44008538732525, 95.31354489436744,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '1st_percentile': [
                107.75965624999999, 102.13465624999999, 101.43434375, 103.04825, 103.96278124999999, 103.376375,
                104.05653124999999, 103.75325, 100.3773125, 98.4545, 97.563875, 96.41590624999999, 96.04090624999999,
                96.04090624999999, 95.220125, 95.10340624999999, 95.0795, 95.92325, 97.001375, 99.46278124999999,
                101.501375, 101.10340624999999, 99.767, 99.157625, 97.79825, 101.29090624999999, 95.876375, 95.0795,
            ],
            '25th_percentile': [
                118.73965625, 113.06778125, 109.64590625, 108.05215625, 107.407625, 106.142, 106.376375, 106.376375,
                102.626375, 100.23575, 99.09903125, 97.892, 97.517, 97.3295, 96.438875, 96.29825, 96.017, 96.626375,
                97.61075, 99.9545, 101.970125, 101.54825, 100.142, 99.532625, 98.17325, 101.876375, 96.157625,
                95.220125,
            ],
            '50th_percentile': [
                124.563875, 118.7748125, 115.3998125, 112.3060625, 110.595125, 108.3216875, 107.92325, 107.92325,
                103.98575, 101.4545, 100.1654375, 99.0404375, 98.501375, 98.54825, 97.282625, 97.142, 96.767, 97.188875,
                98.032625, 100.188875, 102.157625, 101.782625, 100.3295, 99.67325, 98.36075, 102.2045, 96.345125,
                95.267,
            ],
            '75th_percentile': [
                130.43496875, 124.80996875, 121.52871875, 118.62246875, 115.80996875, 112.751375, 110.8060625,
                110.220125, 106.38809375, 103.79825, 101.970125, 100.938875, 99.96621875, 99.907625, 98.54825,
                98.46621875, 97.79825, 98.032625, 98.595125, 100.470125, 102.345125, 102.063875, 100.517, 99.907625,
                98.54825, 102.532625, 96.5795, 95.36075,
            ],
            '99th_percentile': [
                142.67684375, 136.9360625, 133.57559375, 129.31840625, 126.84575000000001, 125.07668749999999,
                121.44528125, 120.948875, 121.16215625, 123.36621875, 119.61809375, 114.43325, 112.74575, 108.202625,
                109.368875, 106.82028125, 105.93059375, 106.48559375, 105.9535625, 103.02434375, 103.35246875, 102.9545,
                101.10246875, 100.3754375, 99.18059375, 104.05559375, 97.91496875, 95.8285625,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405778,
        longitude: -122.5333863,
        timestamp: '2025-08-29T22:44:08.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 126.93836835916969,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_hdr',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T22:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 133.142,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T22:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 8.25,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T22:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 17,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T22:44:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T22:44:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b22a048219017c185aa50518190719016310011519016311185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T22:44:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                131.642, 125.642, 122.642, 118.892, 116.642, 113.642, 112.142, 110.642, 109.892, 110.642, 106.892,
                104.642, 103.142, 100.142, 99.392, 98.642, 98.642, 98.642, 98.642, 100.142, 102.392, 101.642, 100.892,
                100.142, 100.892, 106.892, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                118.892, 112.892, 109.142, 107.642, 107.642, 106.142, 106.142, 106.142, 102.392, 100.142, 99.392,
                97.892, 97.892, 97.142, 96.392, 96.392, 95.642, 96.392, 97.892, 100.142, 101.642, 101.642, 100.142,
                99.392, 97.892, 101.642, 96.392, 94.892,
            ],
            '50th_percentile': [
                124.892, 118.892, 115.142, 112.142, 110.642, 108.392, 107.642, 107.642, 103.892, 101.642, 100.142,
                99.392, 98.642, 98.642, 97.142, 97.142, 96.392, 97.142, 97.892, 100.142, 102.392, 101.642, 100.142,
                99.392, 98.642, 102.392, 96.392, 95.642,
            ],
            '75th_percentile': [
                130.142, 124.892, 121.142, 118.142, 115.892, 112.892, 110.642, 109.892, 106.142, 103.892, 101.642,
                100.892, 100.142, 100.142, 98.642, 98.642, 97.892, 97.892, 98.642, 100.142, 102.392, 102.392, 100.892,
                100.142, 98.642, 102.392, 96.392, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T23:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 136.142,
        unit_type: 'sound_pressure_level',
        data_type_name: 'bm_borealis_spl_broadband_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T23:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: 9,
        unit_type: 'interquartile_range',
        data_type_name: 'bm_borealis_max_iqr_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T23:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 18,
        unit_type: 'index',
        data_type_name: 'bm_borealis_max_iqr_band_number_6bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T23:14:01.000Z',
        sensorPosition: 1,
        units: 'unitless',
        value: 0,
        unit_type: 'spectral_entropy',
        data_type_name: 'bm_borealis_entropy_8bits',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T23:14:01.000Z',
        sensorPosition: 1,
        units: 'hex',
        value: '84011a68b2310d8219017c185aa4051855071901271519012711185a',
        unit_type: 'binary',
        data_type_name: 'binary_hex_encoded',
        sensorConfigurations: 66553,
    },
    {
        latitude: 37.4405667,
        longitude: -122.5334167,
        timestamp: '2025-08-29T23:14:01.000Z',
        sensorPosition: 1,
        units: 'dB re µPa²',
        value: {
            mean: [
                133.892, 128.642, 126.392, 122.642, 119.642, 117.392, 115.142, 113.642, 114.392, 111.392, 106.892,
                106.892, 106.142, 103.142, 105.392, 103.142, 102.392, 100.892, 103.142, 102.392, 103.142, 102.392,
                100.892, 100.142, 98.642, 102.392, 96.392, 95.642,
            ],
            frequency: [
                40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000, 1250, 1600, 2000, 2500, 3150,
                4000, 5000, 6300, 8000, 10000, 12500, 16000, 20000,
            ],
            band_number: [
                16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
                42, 43,
            ],
            '25th_percentile': [
                120.392, 114.392, 110.642, 109.142, 109.142, 109.892, 107.642, 106.892, 104.642, 103.142, 102.392,
                100.142, 98.642, 99.392, 99.392, 100.142, 99.392, 98.642, 99.392, 100.892, 102.392, 102.392, 100.142,
                99.392, 98.642, 102.392, 96.392, 95.642,
            ],
            '50th_percentile': [
                127.142, 121.142, 118.142, 115.142, 112.892, 112.892, 109.892, 109.142, 106.142, 104.642, 103.142,
                101.642, 100.892, 100.892, 100.892, 101.642, 100.892, 100.142, 100.892, 101.642, 103.142, 102.392,
                100.892, 100.142, 98.642, 102.392, 96.392, 95.642,
            ],
            '75th_percentile': [
                132.392, 127.142, 124.142, 120.392, 118.142, 116.642, 113.642, 111.392, 109.142, 106.892, 105.392,
                103.892, 103.142, 103.142, 103.142, 103.142, 103.142, 101.642, 102.392, 102.392, 103.142, 103.142,
                100.892, 100.142, 98.642, 103.142, 97.142, 95.642,
            ],
        },
        unit_type: 'borealis_sound_pressure_level_stats',
        data_type_name: 'bm_borealis_spl_band_stats',
        sensorConfigurations: 66553,
    },
];
